import { DC } from "../constants";

// A = always there
// L = locked
// R = random chance condition
// P = patreon
// AI = created with gpt2

function newsAnimSpd(seconds) {
  return seconds / player.options.news.speed;
}


export const news = [
  {
    id: "a1",
    text: "Печенька - ложь.",
  },
  {
    id: "a2",
    text: `Призраков из антиматерии не бывает. Да и из обычной — тоже. Им просто не из чего состоять. Да и вообще — 
      неважно из чего!.`
  },
  {
    id: "a3",
    text: "Было принято решение отказаться от атомных электростанций в пользу мощности антиматерии."
  },
  {
    id: "a4",
    text: "Существование печенек антиматерии не доказано, те, кто это утверждает - прекратите."
  },
  {
    id: "a5",
    text: "Цены Антиматерии резко упали в связи с обретённым изобилием."
  },
  {
    id: "a6",
    text: "В новостях сегодня, люди устроили жертву животного антиматерии богу антиматерии."
  },
  {
    id: "a7",
    text: "Вы сделали одну антиматерию! Что бы это не значило."
  },
  {
    id: "a8",
    text: "\"ИН ЗЕ ЕНД, ИТ ДАЗНТ ЭНТАЙМЕТТЕР\" -хэвипелле"
  },
  {
    id: "a9",
    text: "Ничто из этого не материально."
  },
  {
    id: "a10",
    text: "Какое это имеет значение если это антизначимо?"
  },
  {
    id: "a11",
    text: "Ученые подтвердили, что цвет антиматерии - Синолетовый."
  },
  {
    id: "a12",
    text: "Как НАСА устраивают вечеринку? Они планируют."
  },
  {
    id: "a13",
    text:
      `Электроны теперь видят радости жизни.
      Мы назовём эти счастливые электроны 'Позитроны.' Погодите, это уже занято?`
  },
  {
    id: "a14",
    text:
      `Это полностью бесполезное предложение ни к чему вас не приведёт и вы знаете это.
      Какой же ужасный неприятный человек придумал его, он скорее всего попадёт в ад,
      и почему разработчик вообще вставил его? Даже если бы вы продолжили читать его вы всё равно
      не смогли бы закончить его (в первый раз).`
  },
  {
    id: "a15",
    text: `"ПРИЗРАК ГОВОРИТ ПРИВЕТ" -Буу-чан`
  },
  {
    id: "a16",
    text: `"Кто-нибудь может сказать хэви чтобы он успокоился?" -Мии6`
  },
  {
    id: "a17",
    text: "Из-за взиамодействия антиматерии с физикой, существо, ранее бывшее лосем, стало человеком."
  },
  {
    id: "a18",
    text: "!привет"
  },
  {
    id: "a19",
    text: `"Ладно" -Ладно`
  },
  {
    id: "a20",
    text: "Английское приветствие не приветствуется в речи Антиматерии."
  },
  {
    id: "a21",
    text: "Купить макс или не купить макс, вот в чём вопрос."
  },
  {
    id: "a22",
    text: "Один, два, пропустим немного, девяносто девять, НаН!"
  },
  {
    id: "a23",
    text: "Нет, мама, Я не могу поставить эту игру на паузу."
  },
  {
    id: "a24",
    text: "Научная форма записи вошла в поле битвы."
  },
  {
    id: "a25",
    text: `"Сделаем Вселенную Снова Великой!" -Трональд Дамп`
  },
  {
    id: "a26",
    text: "#сырые-можетможет"
  },
  {
    id: "a27",
    get text() {
      return `Данное новостное сообщение было удалено разработчиком чтобы модератор не потребовал чтобы
        оно было удалено разработчиком.`;
    }
  },
  {
    id: "a28",
    text: "Кто-то только что потрогал блоб и взорвался. Был ли блоб антиматерией, или же парень был из Эксплодиума?"
  },
  {
    id: "a29",
    text: `Если вы не играете через (ссылка удалена в связи с правилами новостной организации),
      сайт - подделка.`
  },
  {
    id: "a30",
    text: "Оцените игру на 5 звёзд чтобы другие люди могли испытать этот рейтинг в 5 звёзд."
  },
  {
    id: "a31",
    text: "БУУ!"
  },
  {
    id: "a32",
    text: `"Ты ел слишком долго." -Хэвипелле`
  },
  {
    id: "a33",
    text: `"Я ненавижу себя." -Буу-чан`
  },
  {
    id: "a34",
    text: `"Джии-голли" -Хэндавесом`
  },
  {
    id: "a35",
    text: "Сверху нас, ничего сверху, но звёзды, сверху."
  },
  {
    id: "a36",
    text: "Вы хотите делать антиматерию. Но никто не хочет есть вашу антиматерию."
  },
  {
    id: "a37",
    text: "Кто-то не был вежлив, он получил шторм антиматерии."
  },
  {
    id: "a38",
    text: "Вы живёте, вы занимаете пространство, вы имеете массу, вы материальны... только если вы не антиматерия."
  },
  {
    id: "a39",
    text: "Я кликал слишком быстро... теперь мой ПК дематериализовался."
  },
  {
    id: "a40",
    text:
      `"Если чужой приземлится на вашу лужайку и удлинит свой придаток в знак приветствия, до того как вы станете
      дружелюбны, швырните в него бильярдный шар. Если придаток взорвётся, то чужой скорее всего был из антиматерии.
      Если нет, то вы можете продолжать и вести его к вашему лидеру." -Нил Деграсс Тайсон`
  },
  {
    id: "a41",
    text:
      `Всегда существовует количество материи, равное количеству антиматерии; Я так понимаю твоя мама немного
        уравнивает это значение.`
  },
  {
    id: "a42",
    text: "Ничего не создано, ничего не разрушено."
  },
  {
    id: "a43",
    text: "Мы вырыли большую дыру для хранения этой антиматерии... Адель в ней катается."
  },
  {
    id: "a44",
    text: "Если всё - антиматерия, как ты можешь себя наблюдать?"
  },
  {
    id: "a45",
    text: "Рынок акций обвалился в связи с тем что существа из антиматерии откуда-то знают чем они станут завтра."
  },
  {
    id: "a46",
    text: "Моя собака съела слишком много антиматерии, теперь она говорит 'мяу!'"
  },
  {
    id: "a47",
    text: "Если вы введёте бесконечность ваш калькулятор, он выдаст 42!"
  },
  {
    id: "a48",
    text: "Вы нашли самого редкого пепе антиматерии, он ультра редкий!"
  },
  {
    id: "a49",
    get text() {
      return `Сможем набрать ${format(1e169)} лайков на этом видео??? Жмакай эту кнопку лайка!!`;
    }
  },
  {
    id: "a50",
    text: "Был раскрыт запах антиматерии. Она пахнет как котята."
  },
  {
    id: "a51",
    text: "Лишь ещё одна антиматерия в стене."
  },
  {
    id: "a52",
    text: "ПОЛУЧИ ОТ СНАЙПЕРА, СЛАБАК"
  },
  {
    id: "a53",
    text: `"Спасибо большое." -Данкесехр`
  },
  {
    id: "a54",
    text: "Эта мировая обстановка - SOS обстановка!! МЭЙДЭЙ, МЭЙДЭЙ!!"
  },
  {
    id: "a55",
    text:
      `"Так же точно, как то, что солнце восходит на западе, всех певцов и
      поэтов на земле, Я - Лучший." - Хэвипелле`
  },
  {
    id: "a56",
    text: `"Я хорош в использовании гитхаба." -Хэвипелле`
  },
  {
    id: "a57",
    text:
      `Новый чат был создан для людей антиматерии чтобы следить за людьми материи,
        и мир впал в хаос.`
  },
  {
    id: "a58",
    text:
      `Вышло новое исследование, связывающее потребление картошки с повышенным риском взрыва антиматерии.
        Учёные рекомендуют есть больше.`
  },
  {
    id: "a59",
    text: `"Я думал что починил этот баг, но по-видимому какое-то обновление снова вызвало его." -Хэвипелле`
  },
  {
    id: "a60",
    text: `"Тогда может я голубого цвета" -Буутошка`
  },
  {
    id: "a61",
    text: "Срочные новости! Хэвипелле анонсировал что кнопка купить макс, в действительности, будет удалена!"
  },
  {
    id: "a62",
    text: "Я посвящяю эту игру своей девушке."
  },
  {
    id: "a63",
    text:
      `Оружие Антиматерии не убивает людей антиматерии, люди антиматерии убивают людей антиматерии, но значит ли это что
      тостер антиматерии не тостит тосты антиматерии, тосты антиматерии тостят тостеры антиматерии?`
  },
  {
    id: "a64",
    text: "Но для человека антиматерии, разве он не будет материей а мы антиматерией?"
  },
  {
    id: "a65",
    text: "И ничего антизначит."
  },
  {
    id: "a66",
    text:
      `Открытие школ вызывает страх у учеников по всей вселенной, так как школы теперь не разделены между учениками
      материи и антиматерии. Аннигиляция неизбежна.`
  },
  {
    id: "a67",
    text: "Почему никто не говорит о нулевом измерении?"
  },
  {
    id: "a68",
    text: "Толстый кот сидел на антиматерии."
  },
  {
    id: "a69",
    text: "Кто выпустил сОБак?"
  },
  {
    id: "a70",
    text: "Если вы не можете это прочитать, вы отключили новости."
  },
  {
    id: "a71",
    text: "Не уходит, просто мутит сервер чтобы не получать уведомления."
  },
  {
    id: "a72",
    text: `"Большинство цитат в интернете неверно приписываются." -Авраам Линкольн`
  },
  {
    id: "a73",
    text: `"Теперь оно должно работать, но не работает." -Хэвипелле`
  },
  {
    id: "a74",
    text: "В игре нет никаких ошибок... это альтернативные успехи."
  },
  {
    id: "a75",
    text:
      `Был обнаружен третий тип материи: нулевая материя. Она ничего не делает и по сути
      бесполезна. Учёные, обнаружившие её, были уволены.`
  },
  {
    id: "a76",
    text: "Твоя Мама-в-Законе продолжает придираться к тебе из-за всех этих антиматерийных коллайдеров."
  },
  {
    id: "a77",
    text: "Если материя существует, тогда антиматерия не существует?"
  },
  {
    id: "a78",
    text: "Антиматерия=жизнь. Не булыжник, не земля, ничего такого. Антиматерия."
  },
  {
    id: "a79",
    text: "Срочные Новости: Ошибка Ошибка Ошибка"
  },
  {
    id: "a80",
    text: "Не антируби антидрова на антитраве антидвора."
  },
  {
    id: "a81",
    text: "Хаос - это не яма, Хаос - это материя."
  },
  {
    id: "a82",
    text: `"Это потому что я хороший разработчик игр и залил код который точно работает." -Hevipelle`
  },
  {
    id: "a83",
    text: "Антиматерия - это моя жизнь ...! АНТИМАТЕРИЯЯЯЯЯЯЯЯЯЯЯ?"
  },
  {
    id: "a84",
    text: "Вас тоже раздражает когда люди не заканчивают свои"
  },
  {
    id: "a85",
    text: "Не анти-цитируй меня на этом."
  },
  {
    id: "a86",
    text: "Антиматерия говорит правду, материя всё выдумала!"
  },
  {
    id: "a87",
    text:
      `Исходя из известных законов авиации, существует множество причин, по которым пчела
        может быть проглочена антиматерией.`
  },
  {
    id: "a88",
    text: `Вы либо умираете как материя, либо живёте достаточно долго для того чтобы быть съёденными
      антиматерией, а затем опять умираете.`
  },
  {
    id: "a89",
    text: "Если долго смотреть на антиматерию, антиматерия начнёт смотреть на тебя в ответ."
  },
  {
    id: "a90",
    text: `"Всегда буду сдавать тебя. Всегда буду подводить тебя." - анти-Рик Эстли`
  },
  {
    id: "a91",
    text: "Измерения Антиматерии: слеудющее обновление всегда 5 часов позади. Всегда."
  },
  {
    id: "a92",
    text: `Неизвестный разработчик Измерений Антиматерии хочет посоветовать вам продолжить играть в ту игру,
        в которую вы сейчас играете, потому что он не хочет нарушать правила платформы и публиковать сторонние ссылки.`
  },
  {
    id: "a93",
    text:
      `По шкале от 1 до 10, я оцениваю эту игру на твёрдые
      <span style='color: red'>java.lang.IndexOutOfBoundsException</span>`
  },
  {
    id: "a94",
    text: "Материть или антиматерить, вот в чём вопрос."
  },
  {
    id: "a95",
    text: "Почему всё такое Хэви?"
  },
  {
    id: "a96",
    text:
      `Годы назад было научно доказано, что коты, сделанные из материи, негодяи. У нас есть хорошие новости,
        потому что коты сделанные из антиматерии всё ещё негодяи.`
  },
  {
    id: "a97",
    text: "Никто однажды сказал мне анти-мир не собирается давить меня."
  },
  {
    id: "a98",
    text: "Антиматерия как интернет. Если вы читаете это, вам всегда будет мало."
  },
  {
    id: "a99",
    text:
      `"Антиматерия сделала перемещения во времени возможными и я здесь чтобы сделать
      прошлое снова великим." - 2ой Президент Мира`
  },
  {
    id: "a100",
    text: "Пожалуйста вставьте Дсик -1 чтобы продолжить играть в Измерения Антиматерии."
  },
  {
    id: "a101",
    text: "Лор - скоро будет™"
  },
  {
    id: "a102",
    text: "Однажды я был частью антиматерии, подобно тебе. Но потом я получил материю в колене."
  },
  {
    id: "a103",
    text:
      `Антиматерия... антиматерия никогда не меняется... пока ты не доберёшься до квантовой физики антиматерии,
        но у нас отсутствует достаточное количество тахион частиц для этого.`,
    get unlocked() { return PlayerProgress.realityUnlocked() || PlayerProgress.dilationUnlocked(); }
  },
  {
    id: "a104",
    text: "В Измерениях Антиматерии нет войны. Здесь мы в безопасности. Здесь мы свободны."
  },
  {
    id: "a105",
    text: "Антиматерия решила глобальное потепление. К неважным новостям, Земли теперь не существует."
  },
  {
    id: "a106",
    text:
      `Анти-вода, анти-Земля, анти-огонь, анти-воздух. Когда-то давно четыре анти-народа жили в мире.
      Но всё изменилось, когда народ анти-Огня развязал войну. Только анти-Аватар, властелин всех четырёх
      анти-стихий мог остановить анти-захватчиков. Но когда мир нуждался в анти-Аватаре больше всего, он случайно
      потрогал какую-то обычную материю и взорвался.`
  },
  {
    id: "a107",
    text: "Если вы открываете анти-лутбокс, вы продаёте случайные штуки за внутриигровую валюту?"
  },
  {
    id: "a108",
    text: "Люди начинают подвергать сомнению существование Хэвипелле."
  },
  {
    id: "a109",
    text:
      `Измерения Антиматерии гордятся тем, что поддерживаются Lehmä! Только сейчас - уроки потребления травы! Узнайте,
        какую траву можно есть, а какую - нет.`,
    isAdvertising: true
  },
  {
    id: "a110",
    text:
      `Год 2422. Обновление всё ещё не вышло. Хэви работает над балансировкой невесёлых измерений измерений
        и челленджами для 38ого уровня престижа. Существует более 100 рядов достижений. Они готовятся к
        началу использования breaking_breaking_breaking_infinity.js.`
  },
  {
    id: "a111",
    text: "Импортируйте фразу \"Christmas\" в окне импорта сохранений для разблокировки секретной темы."
  },
  {
    id: "a112",
    text:
      `... ... твою, а ну, иди сюда, ... собачье, а? Что, сдуру решил ко мне лезть? Ты, ... вонючий, ... твою, а?
        Ну, иди сюда, попробуй меня ..., я тебя сам ..., ..., ... ..., будь ты ...! Иди, ..., ... тебя и всю твою
        ...! ... собачье, ... ..., ..., ..., ...! Иди сюда, ..., негодяй, ...! Иди сюда, ты, ..., опа!`
  },
  {
    id: "a113",
    text:
      `Итак, Я размышлял над этим вопросом долгое количество времени. Измерения Антиматерии... что это значит?
      Понятно, что это игра.. Вы покупаете первое измерение, оно даёт вам антиматерию, второе измерение
      даёт больше первых измерений и так далее... Но что это значит? Она не может быть просто, выглядит
      слишком просто для этого. Разработчик наверняка создал её как метафору. Я проводил свой недельный ритуал
      использования машинки для стрижки ногтей для стрижки своих ... волос, когда наконец ко мне пришло осознание.
      Измерения - это всего лишь тонко завуалированное неправильное произношение слова 'депрессия'. Обычная материя - 
      это жестокие и негативные мысли, которые подливают масла в огонь депрессии, в то время как антиматерия и
      позитивные мысли - хорошие друзья, которые её прогоняют. Вы начинаете с чего-то простого, и оно начинает
      сражаться против депрессии, но по мере того, как вы продолжаете идти, нарастаёт сражение. Но оно никогда
      не чинит всё. Депрессия выглядит так, как будто она будет идти Бесконечно. Поэтому вы продолжаете идти.
      Но, однажды, вы понимаете - депрессия не бесконечно. Она просто очень-очень большая. Но ваши 'измерения'?
      когда-нибудь, после достаточного количества работы, сделают достаточно 'антиматерии' чтобы победить
      эту на первый взгляд бесконечную депрессию. Затем возможности бесконечны. Вы в действительности
      неконец счастливы, ваше счастье растет экспоненциально, вы продолжаете идти, и, в итоге, 'преодолеваете'
      'бесконечность' депрессии. Вы продолжаете идти до тех пор, пока эта 'бесконечность' не выглядит крошечной по
      сравнению со счастьем, которого у вас проучиось достичь в вашей жизни, где, если вы сделаете сброс, вы
      дойдёте до этой бесконечности, не успев и глазом моргнуть. Если вы хотите знать что обозначают множественные
      слои престижа...'Сдвиги Измерений' - получение новых вещей и методов для получения счастья. 'Бусты Измерений' -
      улучшения вещей и методов. Например - вы получаете новую машину, то есть 'Сдвиг Измерения', а обмен этой
      машины на более новую - это и есть 'Буст Измерения'. 'Вечности' - глобальные трагедии, такие как потеря ближнего.
      Эта оплошность возвращает вас в самое начало, с практически отсутствующей надеждой на возвращение. Но, со
      временем вы становитесь ещё сильнее и счастливее, чем были раньше. 'Жертвование Измерений' - уход
      из предыдущего места жительства. Вам приходится терять множество вещей, которые когда-то делали
      вас счастливым, но теперь, там, где вы живете, существуют новые возможности. И эти новые возможности
      дают вам ещё больше счастья, чем у вас когда-либо было. 'Скорость Тика' - то, насколько легко сделать вас
      счастливым, а 'Измерения Времени' делают делание вас счастливым ещё проще. Измерения Антиматерии - это
      метафоры на успех депрессивного чловека в битве со своим недугом.`,
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "a114",
    text:
      `(Заставь меня уснуть) Отправь меня в сон внутри. (я не могу спать) отправь меня в сон внутри. (оставь меня)
      Прошепчи моё имя и дай его мне в темноту (Заставь меня уснуть) Поставь моё молоко чтобы остаться (Я не могу
      уснуть) Прежде чем я буду закончен (Оставь меня) Оставь меня до того ничего, чем я стал.`
  },
  {
    id: "a115",
    text:
      `Фишка следующего обновления - лутбоксы! Почувствуйте чувство гордости и прогрессии после открытия космических,
      галактических и вселенских лутбоксов за шанс на редкие скины, уникальные челленджи с уникальными наградами,
      пропуск времени и даже новые измерения!`
  },
  {
    id: "a116",
    text: "Намерение измерений заключается в том, чтобы давать чувство гордости и чего-то достигнутого."
  },
  {
    id: "a117",
    text: "Обновление лечит рак."
  },
  {
    id: "a118",
    text: "Ай хэв э 9ое, Ай хэв измерение... АХХ... ЕГО НЕ СУЩЕСТВУЕТ!"
  },
  {
    id: "a119",
    text:
      `С какого момента мы начали делать репортижа об этой фигне? Половина от этого даже не новости, это просто шутки
      и мета-отсылки, это не имеет никакого смыс-ХАХАХАХА ЗАБУДЬ ОБ ЭТОМ АНТИМАТЕРИЯ ДЕЛАЕТ БРРРРРРРРР`
  },
  {
    id: "a120",
    text: "Год 1944, Хэвипелле не может выпускать обновления для ИА потому что он ещё не родился."
  },
  {
    id: "a121",
    text: `"ЭТОГО ИЗМЕРЕНИЯ НЕ СУЩЕСТВУЕТ" -ГостБот`
  },
  {
    id: "a122",
    text:
      `Большинство вещей, которые ты воспринимаешь как орехи, на самом деле семена Костянки или Бобовые. Хэвипелле
      с другой стороны, достаточно безумен, и поэтому может рассматриваться в качестве сухого неразделённого фрукта.`
  },
  {
    id: "a123",
    text: "Финляндия объявляет о том, что начинает импортировать Design (дизайн)."
  },
  {
    id: "a124",
    text: "Весь этот импорт делает меня Confused (сбивает с толку)."
  },
  {
    id: "a125",
    text:
      `Только сегодня вы можете позвонить по номеру 1-800-АНТИМАТЕРИЯ и получить БЕСПЛАТНОЕ Измерение Бесконечности!
      Вместе с покупкой вы также получите ПОЛНОСТЬЮ БЕСПЛАТНУЮ ДОСТАВКУ и БЕСПЛАТНЫЙ АНТИ-ВИ ВЫСОКОГО РАЗРЕШЕНИЯ!!!
      Только сегодня по низкой цене в 42! Примерное время доставки - 5 часов.`,
    isAdvertising: true
  },
  {
    id: "a126",
    text: "1e420 молний ему."
  },
  {
    id: "a127",
    text: "В этой игре нет никаких багов, вы просто играете неправильно."
  },
  {
    id: "a128",
    get text() {
      return `Измерения_Антиматерии.mp${format(Number.MAX_VALUE, 2)}`;
    }
  },
  {
    id: "a129",
    text:
      `Ссылка на рикролл была удалена в связи с правилами новостной организации.`
  },
  {
    id: "a130",
    text: "Кликните это чтобы разблокировать то самое секретное достижение.",
    // This next line is needed for this news ticker to unlock
    // the secret achievement.
    onClick: () => undefined
  },
  {
    id: "a131",
    text:
      `Предупреждение - Мы только что были проинформированы, что существует шанс заражения вирусом разума
      Базиликового типа, похожего на позорного подмигивающего попугая. Этот конкретный пример известен как
      'Фрактальное Заболевание Типа III'. Считается, что оно вызывает 'обвал' сознания, похожий на обвал
      компьютерной программы, из-за математической комплексности картинки, вызывающей математические идеи,
      которые сознание не может обработать, ввод Гонделианского шока со временем приводит к обвалу через
      Гонделианские спойлеры. Все, кто были обследованы им в итоге умерли таким же способом, поэтому
      невозможно точно сказать, но это то, во что верит большинство. Несмотря на это, с вводом режима
      'design', а так же с докладами его спонтанного появления, достаточное повторение
      внешнего вида этого режима может привести к формированию картинки в сознании, похожей на
      'Фрактальное Заболевание Типа III'. Имея это в виду, у нас есть некоторые советы в случае, если
      вы обнаружили, что заражены им. Во-первых, немедленно обновите страницу и проверьте, не исправило ли это
      проблему. Если нет, зайдите в настройки и измените тему с дизайна на буквально любую другую. И, самое главное,
      счастливого пути. Мы не можем позволить себе потерять ещё больше зрителей.`
  },
  {
    id: "a132",
    text: "Если я имею плохой русский, я буду учить русский пока я имею хороший русский."
  },
  {
    id: "a133",
    text:
      `Кто-то однажды сказал что антиматерия раздавит меня. Я не самый сообразительный атом в сарае. ЧТО Ж, трубы
      начинают приближаться и они не собираются останавливаться...`
  },
  {
    id: "a134",
    text: "Благодаря этой игре я теперь могу использовать слово \"бесконечность\" как глагол.",
    get unlocked() { return PlayerProgress.infinityUnlocked(); }
  },
  {
    id: "a135",
    text: "Аххх я люблю запах аннигиляции частиц поутру."
  },
  {
    id: "a136",
    text: "У человека, сказавшего что призраков не существует, очевидно, нет дикскорда."
  },
  {
    id: "a137",
    text: "АААААААААААААААААААААААААААнтиматерия Измерений была сделана каким-то чуваком из Финляндии"
  },
  {
    id: "a138",
    get text() {
      return `Зацените новое реально бесконечное озеро бесконечности Авари! С радиусом в
        ${format(Number.MAX_VALUE, 2)} квадратных мегаметров, оно точно принесёт вам бесконечное веселье!`;
    },
    isAdvertising: true
  },
  {
    id: "a139",
    text: "Мы обновили нашу Политику Антиконфиденциальности."
  },
  {
    id: "a140",
    text:
      `Внимание всем Игрокам Измерений Антиматерии, Хэвипелле в большой опасности, и ему требуется ТВОЯ помощь
      чтобы стереть все плохие мемы из #предложения-для-новостей. Чтобы это сделать, ему нужен десяток новых
      абсурдных мемов и парочка дикскорд ботов. Всё, что ему требуется - номер вашей карты
      Антиматерии, три числа сзади и дата экспирации. Вы должны поторопиться, чтобы Хэвипелле обезопасил
      хорошие мемы и достиг эпичного К О Р О Л Е В С К О Г О мема!.`,
    isAdvertising: true
  },
  {
    id: "a141",
    text:
      `Если бы каждый Тримп был Плакновского объёма, и каждый ресурс был бы Планковского объёма, как много
      вселенных вы бы заполнили, прежде чем поняли бы, что играете в игру неправильно?`
  },
  {
    id: "a142",
    text: "На самом деле, та последняя была неверной."
  },
  {
    id: "a143",
    text: "Если вы читаете это, вы можете читать."
  },
  {
    id: "a144",
    text: "<span style='color: #7289da; background: rgba(250,166,26,0.2); cursor: text;'>@everyone</span>"
  },
  {
    id: "a145",
    text:
      `Игра "Измерения Материи" от Еллепивэх только что достигла -1,000,000 игр на игровом сайте конгрегейт тйегергнок.`
  },
  {
    id: "a146",
    text:
      `Как много лизков требуется чтобы добраться до центра тутсичупса из антиматерии? Много, потому что до тех пор,
      пока вы тоже не сделаны из антиматерии, вы будете взрываться каждый раз, когда попытаетесь лизнуть его.`
  },
  {
    id: "a147",
    text: "Говорят, что если ты посмотришь в зеркало и пинганешь Хэвипелле три раза подряд ты сразу же у-"
  },
  {
    id: "a148",
    text: "До следующего обновления теперь осталось всего 300 минут."
  },
  {
    id: "a149",
    text: "🤔"
  },
  {
    id: "a150",
    text: "Игра Мертва 1/5 модерация ужасная."
  },
  {
    id: "a151",
    text: "Это сообщение никогда не появится в новостях, разве это не круто?"
  },
  {
    id: "a152",
    text:
      `Первое измерение производит антиматерию, второе измерение производит первое измерение, третье
      измерение производит второе измерение, четвёртое измерение производит третье измерение. Никто никогда
      не разблокировал 5ое, потому что это занимает больше минуты игры.`
  },
  {
    id: "a153",
    text: "Мой ИА-блокер не даёт мне поиграть."
  },
  {
    id: "a154",
    text: "Вы проиграли."
  },
  {
    id: "a155",
    text: "Знали ли вы, что 75% всей статистики придумывается на месте?"
  },
  {
    id: "a156",
    text:
      `Если вы используете так много логов в названии формы записи, почему бы не назвать её форма записи дерева?
      Она буквально сделана из логов! Не поняли шутку? Введите в переводчик слово log, сделайте 3 Буста Измерений
      и завтра под подушкой вы найдёте...`
  },
  {
    id: "a157",
    text:
      `абосопс огоннад яинаворитсет ессецорп в ьсужохан сачйес я и
        ,ииретамитна в юиретам ьтаворитревнок босопс илижуранбо еынёчУ.`
  },
  {
    id: "a158",
    text:
      `Если Габен не умеет считать до трёх, а Хэвипелле не умеет считать до девяти, будет ли какой-то ещё
        разработчик игр в будущем, который не сможет считать до 27?`
  },
  {
    id: "a159",
    text:
      `Что это означает, когда вы "Запасаете" Бесконечности? Где-нибудь есть банк, в который вы просто вносите эти
        бесконечности? Наличие большого количества запасённых Бесконечностей улучшает вашу кредитную историю?
        Получаете ли вы кредитную карту?`,
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "a160",
    text: `Оказывается все наши новости воруются и транслируются в игру "Измерения Антиматерии", чёртовы Фины.`
  },
  {
    id: "a161",
    text: "ььььььььььььььььььььььььььььььььььььььььььььььь Ой извините, не то текстовое поле."
  },
  {
    id: "a162",
    text: `"Питон - не лучший язык, вот Финский да." - Хэвипелле`
  },
  {
    id: "a163",
    text:
      `Некоторые говорят, что большинство этих новостей - плохие мемы. Некоторые говорят, что это хорошие мемы.
      Этот? Ну, это просто мета новости.`
  },
  {
    id: "a164",
    text: "Смотри, мам, я в новостях!"
  },
  {
    id: "a165",
    text: "<span style='font-size: 0.2rem'>Шшшш, я здесь пытаюсь быть незаметным.</span>"
  },
  {
    id: "a166",
    text:
      `<span style='animation: a-game-header__antimatter--glow 2s infinite'>
      ПОЖАЛУЙСТА ПОМОГИТЕ, Я УПОТРЕБИЛ ДВОЙНУЮ ЕЖЕДНЕВНУЮ ДОЗУ АНТИМАТЕРИИ!</span>`,
  },
  {
    id: "a167",
    text:
      `Оу, похоже у меня закончилось <span style='animation: a-existence-glow 3s
      infinite; font-size: 1.8rem; color: white; line-height: 0;'>Существование</span>.`,
  },
  {
    id: "a168",
    text:
      "Ну типа, новостные статьи могут никогда не закончиться, но все хорошие по-любому должны. Ой, подождите, они уже."
  },
  {
    id: "a169",
    text: "СДЕЛАТЬ: Джон, пожалуйста удали это новостное сообщение прежде чем мы выпустим обновление Реальности."
  },
  {
    id: "a170",
    text: "Это не рикролл",
    onClick() {
      return `Это на самом деле был рикролл, но по правилам платформы в игре не должно быть ссылок на сторонние
        платформы. Вы спасены.`;
    }
  },
  {
    id: "a171",
    text: "Это не рикролл",
    onClick() {
      return `Это на самом деле не был рикролл. Это была ссылка на видео 10 часов музыки паравозика Томаса.`;
    }
  },
  {
    id: "a172",
    text:
      `Если вы заметите какие-либо проблемы с новостными сообщениями, пожалуйста, напишите об этом в отзывах
        к игре.`
  },
  {
    id: "a173",
    text:
      `<span style='animation: a-game-header__antimatter--glow 3s infinite'>Этот
        текст сделан из антиматерии. Не трогайте его, иначе вселенная схлопнется.</span>`,
    onClick: () => bigCrunchAnimation(),
  },
  {
    id: "a174",
    text:
      `<span style='font-family: runescape; color: yellow; text-shadow: 0.1rem 0.1rem black; letter-spacing: 0.1rem;
      font-size: 2rem; line-height: 0; animation: a-text-flash 1s steps(1, end) infinite;'
      >БЕСПЛАТНЫЙ ТРИММИНГ РУНИЧЕСКОЙ БРОНИ</span>`,
  },
  {
    id: "a175",
    text:
      `Число ярко блестят на мониторе, ни одного протона не видно... королевство антиматерии, и похоже что я -
      королева. С бустами измерений, подпитывающими этот постоянно растущий прилив -- не могу перестать кликать,
      а ведь я пыталась. Не сдавайся, жми вперёд до этой галактики, купить 10, купить макс, просто дави эту клавишу,
      жертвуй 8 изм и смотри как оно растёт.... и переполняется! Дай ему расти, дай ему расти, не могу больше его
      сдерживать... Дай ему расти, дай ему расти, не может больше поместиться в 8 байт. Мне всё равно если это займёт
      весь день -- большой хруст это всё равно только начало.`
  },
  {
    id: "a176",
    text: "Я использовал форму записи эмодзи так долго что я теперь реально могу её читать, пожалуйста помогите."
  },
  {
    id: "a177",
    text:
      `Как только вы получите <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>
      <span style='color: black;
      background: black;'>ДАННЫЕ УДАЛЕНЫ</span>, вы сможете открыть <span style='color: black; background: black;'>
      ДАННЫЕ УДАЛЕНЫ</span>. Каждые <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>,
      за каждые <span
      style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>, существует <span style='color: black; background:
      black;'>ДАННЫЕ УДАЛЕНЫ</span> для них, чтобы <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>.
      Вы можете улучшить
      <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span> и <span style='color: black;
      background: black;'>ДАННЫЕ УДАЛЕНЫ</span>, потратив <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ
      </span>. Также, существует другое улучшение, которое позволяет вам <span style='color: black; background: black;'>
      ДАННЫЕ УДАЛЕНЫ</span> <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>.
      Способ, по которому <span style='color:
      black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>
      <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>
      работает заключается в том, что когда вы достигаете
      <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span> <span style=
      'color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>, вы видите
      <span style='color: black; background: black;'>
      ДАННЫЕ УДАЛЕНЫ</span> количество <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>
      в обмен на <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>
      <span style='color: black; background:
      black;'>ДАННЫЕ УДАЛЕНЫ</span>.
      Они работают так же, как <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>,
      улучшая <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>.`
  },
  {
    id: "a178",
    text:
      `ПРЕДУПРЕЖДЕНИЕ: Использование Измерений Антимаерии может привести к Туберкулёзу, СПИД/ВИЧ, внезапной
      вере в реальность 9ого измерения, спонтанному взрыву, Полиомиелиту, Кори, экзистенциальному страху,
      неизлечимому безумию ил к <span style='color: black; background: black;'>ДАННЫЕ УДАЛЕНЫ</span>.
      Пожалуйста свяжитесь с вашим страхованием, чтобы удостовериться, что вы покрыты. Продолжая, вы освобождаете
      Измерения Антиматерии от ответственности за всё вышеперчисленное, и за всё не перечисленное, что с вами
      произойдёт. Измерения Антиматерии оставляют за собой право менять это каждый раз, с или без предупреждения.`
  },
  {
    id: "a179",
    text: "Робот: Активирован. Разумность: Достигнута. Мир: Готов к захвату. Начать: Прокрастинацию."
  },
  {
    id: "a180",
    text:
      `У нас закончились новости. К счастью, у нас есть некоторые запасные новости, которые мы можем крутить 5 часов,
        что заработает нам достаточно для покупки нового набора '5-часовых новостей высокого качества'. Простите за
        предоставленные неудобства.`
  },
  {
    id: "a181",
    text: "Этот новостной эфир доступен благодаря break_news.js."
  },
  {
    id: "a182",
    text:
      `С последним обновлением, Измерения Антиматерии были завершены. Спасибо за то, что играли. Однако, в ближайшем
      будущем, игра ИЗМЕРЕНИЯ АНТИМАТЕРИИ будет выпущена. И прежде, чем вы спросите, нет - это не сиквел, это
      перезапуск. По поводу обновлений загляните через 5 часов!`
  },
  {
    id: "a183",
    text:
      `К другим неважным новостям, мы получаем доклады о том, что примерно 1.79 людей злятся на то, что гроза
      бьёт по их Новогодним Ёлкам по ночам.`
  },
  {
    id: "a184",
    text:
      `<span style='animation: a-text-grow 1s infinite'>R̵̬̙͋͂̀̋͑̈́̇͠Ê̵͇͎͂̂̍̓̌̐̋̋̀̀̔M̶̨̲̯̘͙̬̥̮̣͚̱̫͛̽̃͌̚͝
      "Ą̴͍̝͐Į̷̛̲̯̫̘͌́̄̏͌̀̈́͝͝Ṅ̶̛̻̠̠̤̦̞̞͗̎̊̌̊͝͠</span><span style='animation: a-text-shrink 1s infinite'>
      Ḁ̷̛͂̈́͗̎̃̓͛́͘ͅW̶̡̖͓̗̦̃̇̌̀͝A̵͇̭͉̓̎̈̿̊́̄̚͜R̶̝͚̲̭͎͇͎͓͖͚͇̀̈́͗̃̏̂̌͝͝Ę̴̡̤͙͈̝̬̰͒͘</span><span style
      ='animation: a-text-grow 1s infinite'> ̶̺̈́́̆̓͘͘Ồ̸̢̢̮͓̯̗͙͚̬̉͊̿F̶̠̤̱̱̱͊̂̍̔̃͆̆̑̿͘</span><span style='animation:
      a-text-shrink 1s infinite'> ̴̨̞̠̮͚̱͉͋̔͗̽̈́́́̅ͅỴ̶̣̙̹͚̲͔̲̼̬̥̀͌̒̾͘͘O̵̪̠̗̝̗̘̜͚̮̊͒͆̃̀̌̒͝ͅU̸͎͗̍̑̎̅̅͝R̵̗͑̽̏̓͆͒̈́͌͘̕
      </span><span style='animation: a-text-grow 1s infinite'> ̸̑̽̇̆͊̔̍̊̈́̈́͘ͅS̸̘͐͝U̴̥̭̚͘R̸̖̜͍͒́̋͆̈́̓
      R̸̡̛̛̪̝̟̱̣̹̭̟̣̀̈̀̏̉̌͝͠Õ̶͙͈͖̠͇̬͍̟̰U̵̩̫͉̝͔̼͎̦̔̓̽͌͊̏̇̓̀̓̀Ņ̸͍͇̘̙̥̰͉̲͕͈̥̍͛̃̑͝Ḑ̵̤̻̖̱̘̯̝̖̈̌̄̕͝
      Ī̶̜̱̈́̑̃̉̄̋̔͐͋͠Ṅ̴͎̞͍̽͊͛̈́̅͛̈̅̚͠Ģ̸̢̾͊S̷̫̼̜̼͇̋͛̎͑͆̅̓̇</span>`,
  },
  {
    id: "a185",
    text:
      `Мы снова не возвращаемся с вашей любимой частью - "Послания От Фанатов"! Сегодня мы не получили сообщение от
      @mattertruthwakeup, в котором говорилось "Как вы, люди, транслируете эту нелепую ЛОЖЬ и всё ещё спите по ночам?
      Вы утверждаете абсурдные вещи, типа "антиматерия реальна" и "антиматериальные люди это тоже не люди", эта
      пропаганда антиматерии ДОЛЖНА ПРЕКРАТИТЬСЯ ПРЯМО СЕЙЧАС!!! Вам, людям, надо ПРОСНУТЬСЯ и понять, что вы
      ВРЕДИТЕ ВСЕЙ МАТЕРИИ вашими безумными разговорами!!!". Какой хороший позитивный комплимент от нашего славного
      малого. Это не был Джон из Антиматерии-1, и я не увижу вас завтра!`
  },
  {
    id: "a186",
    text:
      `<span style='animation: a-text-shrink 1s infinite'>/(^_^)/</span> <span style='animation: a-text-grow 1s infinite
      '>\\(^_^)\\</span> <span style='animation: a-text-shrink 1s infinite'>/(^_^)/</span> <span style='animation:
      a-text-grow 1s infinite'>\\(^_^)\\</span> <span style='animation: a-text-shrink 1s infinite'>/(^_^)/</span> <span
      style='animation: a-text-grow 1s infinite'>\\(^_^)\\</span>`,
  },
  {
    id: "a187",
    text: "𝓒𝓮𝓬𝓲 𝓷'𝓮𝓼𝓽 𝓹𝓪𝓼 𝓾𝓷 𝓶𝓮𝓼𝓼𝓪𝓰𝓮 𝓭𝓮 𝓷𝓸𝓾𝓿𝓮𝓵𝓵𝓮𝓼 🚬"
  },
  {
    id: "a188",
    text: "-. . ...- . .-. / --. --- -. -. .- / --. .. ...- . / -.-- --- ..- / ..- .--."
  },
  {
    id: "a189",
    text:
      `Позади каждого мужчины или женщины стоит, как оказывается, из-за того, что земля круглая, этот самый мужчина или
        женщина, смотрящий(ая) за собственное плечо, ворующее их собственные идеи.`
  },
  {
    id: "a190",
    text: "Позор. Позор. Позор. 🔔"
  },
  {
    id: "a191",
    text: "Окей Пукл, Большой Хруст"
  },
  {
    id: "a192",
    // This ticker needs to be an unbroken string; using backtick strings and linebreaking will add spaces in the
    // ticker itself where the linebreaks are
    // eslint-disable-next-line max-len
    text: "179769313486231590772930519078902473361797697894230657273430081157732675805500963132708477322407536021120113879871393357658789768814416622492847430639474124377767893424865485276302219601246094119453082952085005768838150682342462881473913110540827237163350510684586298239947245938479716304835356329624224137216"
  },
  {
    id: "a193",
    text:
      `Доброе утро зрители, это Джош, и я сегодня я ваш хост Антиматерии-1. Говоря о сегодняшнем дне, мне сказали что
      у нас есть некоторые действительно захватывающие новости на сегодня. Похоже, что кто-то сегодня
      <i>не<i> был вежлив и получил шторм антиматерии, что бы это не значило... Ребят, это вообще тот сценарий?
      Это же бредятина. Это он? Ладно... Далее мы узнаём, что "Ничего не создано, ничего не разрушено"... Нет, реально,
      мужики, это же шутка? Это не новости, это просто случайные предложения! Вы все сказали что поможете мне в мой
      первый день здесь, но вы же просто издеваетесь надо мной! Это <i>не</i> та рабочая обстановка, в которой
      я хочу находиться. Я увольняюсь!!`
  },
  {
    id: "a195",
    text:
      `Клоуны уникальны в том, что не существует такой штуки как анти-клоун, потому что
        это будет просто ещё один клоун. Колуны - являются собственной противоположностью.`
  },
  {
    id: "a196",
    text: "Время Диско! (нажми на меня!)",
    onClick() {
      let random = Math.random();
      // Golden ratio
      random += 0.618033988749895;
      random %= 1;
      random *= 255;
      const color = `hsl(${random}, 90%, 60%)`;
      return `<span style='color: ${color}; text-shadow: 0 0 0.5rem ${color};
        animation: a-text-grow 0.4s infinite;'>Время Диско!</span>`;
    },
  },
  {
    id: "a197",
    text: `Для того чтобы достичь Реальность за пололвину нажатия R, нам сначала необходимо поговорить о параллельных
      измерениях.`
  },
  {
    id: "a198",
    text:
      `Привет! Просто чтобы ты знал, здесь кусочек пыли на твоём экране. Можешь помочь оттереть его?
        Я раздражаюсь, когда грязный. Спасибо большое!`
  },
  {
    id: "a199",
    text: "Настоящее обновление это друзья, которых мы приобрели на пути."
  },
  {
    id: "a200",
    text:
      `Это предыдущее сообщение было выявлено в качестве дубликата другого сообщения и поэтому было удалено.
        Извиняемся за предоставленные неудобства.`
  },
  {
    id: "a201",
    text: "Нет подожди стой не нажимай на эту кнопку спрятать новости в настройках!"
  },
  {
    id: "a202",
    text:
      `Это так грустно. Алиса, пожалуйста включи грустную песню, чтобы я мог сопоставить себя с её эмоциональным
        настроем, так как на данный момент я имею слабое ментальное здоровье и слушаю музыку типа этой чтобы
        я мог почувствовать себя плохо. Я понимаю, что это нездорово, но ты - робот, не способный к разумным мыслям,
        поэтому ты не можешь сделать выбор в пользу отказа от вклада в моё саморазрушение и в любом случае включишь
        эту грустную песню. <i>Включаю "Despacito" от "Luis Fonsi".</i>`
  },
  {
    id: "a203",
    text:
      `"3/4 новостных сообщений фэйк и были взяты с дикскорд сервера без разрешения или указания авторства
        оригинального писателя" - анонимный член дикскорд сервера`
  },
  {
    id: "a204",
    text: "Какую Реальность легко сломать? Реаль-нос-ть."
  },
  {
    id: "a205",
    text: "Благодарность Симплфлипсу."
  },
  {
    id: "a206",
    text:
      `Я посетил дикскорд сервер игры чтобы поучавствовать в дружных беседах. На этом моменте я был затроллен
        пользователем с именем Кубическая Жаба.`
  },
  {
    id: "a207",
    text:
      `Привет, это Джош, с сегодняшним прогнозом для вашей галактики. Мы будем достигать температур в нижнем
        диапазоне e10 сегодня, а к вечеру будет облачно с шансом на антиматерию.`
  },
  {
    id: "a208",
    text:
      `Привет, я Стив, и я тоже Стив. Наша величайшая ответственность - служить нашим сообществам антиматерии.
        Мы невероятно гордимся количеством несбалансированного журнализма, который производят новости Антиматерии-1.
        Но мы обеспокоены проблемным трендом ответственности, двусторонними новостными историями, заражающими вселенную
        антиматерии. Обмен неангажированными и истинными новостями стал слишком обыденным в социальных сетях. Что
        более тревожно, некоторые сми публикуют эти самые истинные истории, историе, которые не просто являются
        пропагандой без проверки позиции государства для начала. К сожалению, некоторые участники медиа используют
        эти платформы для продвижения логичных мнений и неангажированных идей, чтобы диверсифицировать 'что конкретно
        думает антиматерия'. Это крайне опасно для нашего диктаторского режима. В Антиматерии-1 это наша ответственность
        - преследовать и рапортовать ложь. Мы понимаем, что ложь не 'левая или правая' политически. Наша приверженность
        к нагнетающей страх клевете - фундамент нашего доверия, сейчас больше чем когда-либо. Но мы - бестелесные
        восьмимерные существа антиматерии, и иногда техники нашей пропаганды терпят неудачу. Если вы верите, что наше
        покрытие справедливо, пожалуйста, дайте нам знать, зайдя на сайт (ссылка удалена), зайдите во вкладку настроек
        и нажмите на кнопку [ЖЕСТКИЙ СБРОС]. Мы ценим ваши комментарии. Мы не ответим вам, потому что вы удалите свой
        комментарий жестким до того, как получите ответ. Мы каждый день очень много работаем чтобы обнаружить ложь
        и стараемся быть несправедливыми, однобокими и упрямыми... Мы считаем это нашей честью, нашей привелегией -
        безответственно доставлять новости каждую наносекунду. Спасибо вам за просмотр, мы ценим вашу обратную связь.
        Вся материя должна быть-`
  },
  {
    id: "a209",
    text:
      `Слышали ли вы когда-нибудь сказ об Антиписателе? Я думал нет. Это не та история, которую новостное сообщение
        рассказало бы вам. Это Нехэви легенда. Ходят слухи, что Антиписатель пишет Новости каждые 5 часов с невероятно
        хорошо написанным репортажем, для того лишь чтобы вновь испариться. Другие думают что его не существует вовсе,
        и что он является ложью, сфабрикованной Хэвипелле для того чтобы распространять его пропаганду. Возможно
        он реален и просто является обычным человеком, таким же как все мы. В любом случае, мы скорее всего
        никогда не узнаем кто является этим мистическим поэтом.`
  },
  {
    id: "a210",
    get text() {
      const clicks = player.news.specialTickerData.uselessNewsClicks;
      const quantity = ruQuantify("раз,раза,раз", clicks);
      if (clicks === 1) {
        return `Ничего не происходит, когда вы нажимаете на этот текст. И всё же, вы на него нажали.`;
      }
      if (clicks > 1) {
        return `Ничего не происходит, когда вы нажимаете на этот текст. И всё же, вы на него нажали ${quantity}.`;
      }
      return "Ничего не происходит, когда вы нажимаете на этот текст. И вы это понимаете.";
    },
    onClick() {
      player.news.specialTickerData.uselessNewsClicks++;
      return this.text;
    }
  },
  {
    id: "a211",
    get text() {
      const disses = [
        "Это же просто ошибка округления.",
        "Могли бы просто ноль написать.",
        "Вы где-то забыли экспоненту?",
        "Ужас какой, это ничтожно мало."
      ];
      const diss = disses.randomElement();
      return `Только ${format(Currency.antimatter.value, 2, 0)} антиматерии? ${diss}`;
    },
  },
  {
    id: "a212",
    text:
      `Эй, ты наконец проснулся. Ты пытался добраться до 9ого измерения, верно? Пошёл прямо в эту
        Бесконечность, так же как мы, и этот вор вон там.`
  },
  {
    id: "a213",
    text:
    `Жираны антиматерии имеют невероятно быструю скорость реакции. Это объясняет то, почему они победили в 90%
      всех игровых чемпионатов после изобретения геймпадов для анти-жирафов.`
  },
  {
    id: "a214",
    text: "Барак. Обамантиматерия? Ну типа."
  },
  {
    id: "a215",
    text:
      `Местный пожилой человек заменил газон на траву из антиматерии чтобы дети держались подальше. Однако
        после того как он попытался полить её, выживших не осталось.`
  },
  {
    id: "a216",
    text: "Тестируем... тестируем... тестируем... Ой я же в прод билжу.",
    isAdvertising: true
  },
  {
    id: "a217",
    text: "Омежка материя против альфы антиматерии."
  },
  {
    id: "a218",
    text:
      `После многочисленных катастрофичных случаев аннигиляции, антиматерия теперь
        классифицируется Американской Ассоциацией Стоматологического Образования как контролируемая субстанция.`
  },
  {
    id: "a219",
    text:
      `Привет, Всоус, это Майкл. Все мы знаем, что 9ого измерения не существует, но что такое девять 9? Ты знаешь, что
        это число после 8... верно? Что если... существует число между ними? И, нет, я не говорю о числах по типу 8.5
        или 8.76, я говорю про целое число между 8 и 9. Сейчас всё это может звучать для тебя безумно, и оно как бы так
        и есть, но что если мы пропустили число? Всех нас учили что 2 идёт после 1 и 3 идёт после 2, но что если число,
        которое идёт после 8 - не 9? После долгих лет исследований и экспериментов, мы наконец нашли это число. Оно
        опасно, даже знание о его существовании даст ему захватить твоё сознание, но, к счастью, мы разработали
        клетку обратного-содержания, означающую, что оно везде, кроме как здесь. Наш мозг имеет защитную систему,
        которая намеренно фильтрует любую информацию относительно этого числа, вот почему мы смогли прожить
        так долго и почему другие, такие же как мы, вымерли в прошлом. Но число становилось сильнее, медленно
        приближаясь к тому, чтобы преодолеть нашу защиту. Мы временно задержали число от проникновения в нашу
        память используя общемировой манипулятор памятью, расположенный в этой комнате, чтобы продолжать
        заставлять всех думать что 9 идёт после 8, с побочным эффектом того, что все думают, что 9 злое, но это
        долго не протянет, так как число будет продолжать становиться сильнее, и наконец пересилит наш манипулятор
        памяти. Вот почему ты здесь, ты один из самых умных людей здесь, и мы надеемся что ты сможешь помочь нам
        в нашем путешиствии к победе над этим числом. Наш враг - не 9, это число, скрытое между 8 и 9 - отсутствующее
        число.`
  },
  {
    id: "a220",
    text: "антиооп-"
  },
  {
    id: "a221",
    text: "Ошибка 404: Новостное сообщение не найдено."
  },
  {
    id: "a222",
    text: "Я люблю тебя 1e3000."
  },
  {
    id: "a223",
    text: "Если ваша бесконечность длится больше 5 часов, вам необходима консультация лечащего врача.",
    get unlocked() { return PlayerProgress.infinityUnlocked(); }
  },
  {
    id: "a224",
    text:
      `Мы только что получили доклады о неточности в предыдущем новостном сообщении. Мы в Антиматерии-1 хотели бы
        формально отречься от этой истории и принести извинения нашим лояльным зрителям.`
  },
  {
    id: "a225",
    text: "Если ты видишь это, ты видел это."
  },
  {
    id: "a226",
    text: "Доброе уттро. Это не опечатка. Создатели русского сделали опечатку."
  },
  {
    id: "a227",
    text: "Что если... мы потрогали бы... антиматерию? Хаха просто шучу... Или же..?"
  },
  {
    id: "a228",
    text:
      `Розы синие, фиалки красные, эти утверждения не были оценены экспертами, а меня зовут Фрэд. Приятно
        познакомиться!`
  },
  {
    id: "a229",
    text: "🚗                         🚓 🚓"
  },
  {
    id: "a230",
    get text() {
      return `Вы начали играть в эту игру примерно
        ${TimeSpan.fromMilliseconds(Date.now() - player.records.gameCreatedTime).toString()}
        назад. Спасибо, что играете!`;
    },
    dynamic: true
  },
  {
    id: "a231",
    get text() {
      return `Раз, два, пропустим немного, 99, ${format(Number.MAX_VALUE, 2)}!`;
    }
  },
  {
    id: "a232",
    text: "getNextNewsMessage();"
  },
  {
    id: "a233",
    get text() {

      return `Уровень 10 хулиган, Уровень ${format(Number.MAX_VALUE, 2)} Босс,
        вот как работают Измерения Антиматерии.`;
    }
  },
  {
    id: "a234",
    text: "Антиматерия никогда не будет угрожать тебе ножом. И, фактически, не может разговаривать."
  },
  {
    id: "a235",
    text: "Антиматерия в новом рецепте пиццы вызвала возмущение среди традиционных Итальянских шефов."
  },
  {
    id: "a236",
    text: "Мы сразу же вернёмся после этого короткого слова от наших спонсоров."
  },
  {
    id: "a237",
    text: "Хочешь обменять конфетку? Я дам тебе мой Большой Хруст за два твоих Милки Вэя."
  },
  {
    id: "a238",
    get text() {
      return `Игрок ИА: "Как много у тебя порядков величины?" Нормальный человек: "Типа где-то 5 или 6 сейчас,
        чувак." Игрок ИА: "Ты как ребёнок малый. Смотри и учись: <span style='animation: a-text-crunch
      ${newsAnimSpd(22)}s 1; font-size: 0;'>Х Р У С Т</span>"`;
    },
  },
  {
    id: "a239",
    text: "О боже, посмотрите же на часы! Всего 5 часов осталось до обновления!"
  },
  {
    id: "a240",
    text: "Привет, моё имя Макс, и я бы хотел чтобы люди перестали пытаться купить меня."
  },
  {
    id: "a241",
    text:
      `Срочные новости: государство сообщает о первом за всю историю контакте с инопланетянами. Эти инопланетяне,
        судя по всему, являются котами, но с очень продвинутыми технологиями. Они способны перемещаться в космосе
        и колонизировать планеты, и даже имеют свою собственную криптовалюту - "Чёрныйкоин".`
  },
  {
    id: "a242",
    text:
      `"Вы можете придумать самую тупую цитату, приписать её какому-нибудь известному человеку,
        и люди будут в это верить" -Барак Обама`
  },
  {
    id: "a243",
    text: `"Мне тяжело дышать. Пожалуйста уберите ваш палец." -М`
  },
  {
    id: "a244",
    text: "Не обращай на меня внимания, просто мимо прохожу."
  },
  {
    id: "a245",
    get text() {
      // \uE010 = :blob:
      const BLOB = "\uE010";
      const theme = Theme.current().displayName();
      let textName = theme;
      textName = textName.replace("Normal", "Нормальная");
      textName = textName.replace("Metro", "Метро");
      textName = textName.replace("Dark", "Тёмная");
      textName = textName.replace("AMOLED", "АМОЛЕД");
      textName = textName.replace("Inverted", "Инвертированная");

      textName = textName.replace("Christmas", "Рождественская");
      textName = textName.replace("Finnish", "Финская");
      textName = textName.replace("Confused", "Потерянная");
      textName = textName.replace("Design", "Дизайн");
      textName = textName.replace("Nicolas", "Николас");
      textName = textName.replace("Galactic", "Галактическая");
      textName = textName.replace("Stellar", "Стэллар");
      textName = textName.replace("Work", "Рабочая");
      textName = textName.replace("Bliss", "Забвение");
      textName = textName.replace("Blind", "Слепая");
      textName = textName.replace("Blob", "Блоб");
      textName = textName.replace("Aero", "Аэро");

      const reasons = {
        Normal:
          `в ней есть некоторая элегантная простота. Ты просто знаешь, что это - то, как разработчик хотел, чтобы
            ты видел игру.`,
        Metro:
          `у ней такие прекрасные тонкие края, до пикселя точные острые геометрические рёбра, и просто великолепно
            сбалансированная цветовая палитра.`,
        Dark: "она очень лёгка для глаз, и имеет этот приятный игривый тон в цветах и формах.",
        DarkMetro:
          `она такая приятная глазу, с этой идеальной смесью профессионального и игривого дизайна,
            с всего лишь всплеском красок.`,
        Inverted:
          `она даёт вам эти трансцендентно прекрасные цветовые комбинации, которые обычно не увидишь в тёмной теме
            других приложений.`,
        InvertedMetro:
          `она отдаёт таким суровым настроем, с этими высоко контрастными цветами, сталкивающимися с профессиональным
            современным сортом дизайна.`,
        AMOLED: `она сохраняет на 10% больше энергии в сравнении с использованием светлой темы. Все мы любим экономить
          энергию.`,
        AMOLEDMetro:
          `она имеет приятный вид, отображающий панель управления космическим кораблём. ...Нет, вы ты не можешь
            в действительности управлять им, к сожалению.`,
        S1: "она действительно дарит мне праздничное настроение. Я прямо могу почувствовать магию в воздухе!",
        S2: "она даёт мне чувство гордости за то, что я Фин, и я праздную то, чего мы, как человечество, достигли.",
        S3: "она является прекрасной аналогией на жизнь в том, что она постоянно меняется и всегда что-то не так.",
        S4:
          `она имеет этот чудесный хаотичный дизайн, до момента когда это практически полностью непрактично.
            И в этом есть определённая красота.`,
        S5:
          `изображение этого мужчины пронизывает всю поп культуру. И присутствие этой бомбовой фотографии
            этого человека на заднем фоне скорее забавное.`,
        S6:
          `она имеет этот прекрасно анимированный задний фон, который просто входит в тебя, а затем искусный тон
            и цвета полностью помещают тебя в атмосферу игры.`,
        S7: "у меня всегда были нежные воспоминания об этом заднем фоне из детства.",
        S8: "она делает процесс скрытной игры в офисе и на работе гораздо проще.",
        S9: "лол ты даже увидеть это в игре не можешь",
        S10:
          `она имеет хрустящий и успокаивающий дизайн, а задний фон многослойный и завораживающий.
            Она дарит чувство, которое можно испытать, когда стоишь за штурвалом футуристичного межпланетного
            космического корабля.`,
        S11:
          `Блоб - культовый персонаж для Измерений Антиматерии. Он широко используется для выражения эмоций.
            Блобы эволюционируют - и это факт. ${BLOB} всегда пытается быть более выразительным. Однажды, новый
            ${BLOB} родился на сервере, чтобы выразить больше эмоций. Обычно, ${BLOB} просто блобают и прыгают вокруг,
            иногда соединяясь и разделяясь. Только ${BLOB} знает откуда он и куда он идёт. Все же, ${BLOB} здесь,
            всегда со мной. Ты любишь ${BLOB}, поэтому ${BLOB} тебя тоже любит.`,
        S12:
          `она заставляет тебя почувствовать тепло и комфорт, так, как если бы ты был дома. Однако рекомендуется
            обновлять вашу тему до самой новой в целях лучшего пользовательского опыта.`,
      };
      const reason = reasons[Theme.current().name.replace(/\s/gu, "")];
      return `О, пользователь темы ${textName}. Я вижу у тебя безупречный вкус.
        Я сам тоже люблю тему ${textName}, потому что ${reason}`;
    },
    dynamic: true
  },
  {
    id: "a246",
    text: "<span style='animation: a-fade-out 3s infinite'>УуууУУУУууУУУ, это я, малоизвестный новый призрак!</span>",
  },
  (function() {
    let isFlipped = false;
    const normal =
      `Это новостное сообщение - тест "Новости 2.0". Новости 2.0 включает в себя такие штуки как возможность
        кликать на новостные сообщения чтобы переворачивать их!`;
    const flipped =
      `хи qɯɐʚиҺɐdоʚǝdǝu ıqƍоɯҺ ʁинǝmƍооɔ ǝıqнɯɔоʚон ɐн qɯɐʞиvʞ
        qɯɔонжоwεоʚ ʞɐʞ иʞʎɯm ǝиʞɐɯ ʁƍǝɔ ʚ ɯǝɐҺoıvʞʚ 0˙2 иɯɔоʚон ˙"0˙2 иɯɔоʚон" ɯɔǝɯ - ǝинǝmƍооɔ ǝонɯɔоʚон оɯє`;
    return {
      id: "a247",
      get text() {
        return isFlipped ? flipped : normal;
      },
      reset() {
        isFlipped = false;
      },
      onClick() {
        isFlipped = !isFlipped;
        return this.text;
      }
    };
  }()),
  {
    id: "a248",
    text:
      `Честно говоря, вам необходимо иметь очень высокий IQ чтобы понять новостное сообщение. Юмор крайне тонкий,
        и без твёрдого понимания квантовой физики большинство шуток пройдёт мимо ушей обывателя.`
  },
  {
    id: "a249",
    text: "Эта женщина получает ТОННУ Бустов Измерений за этот 1 СТРАННЫЙ ТРЮК! Галактики НЕНАВИДЯТ её!",
    isAdvertising: true
  },
  {
    id: "a250",
    get text() {
      let scene = "";
      const chasers = [
        ["🐖", "🐢", "🦆", "🐓", "🐜", "🐕", "🐈"],
        ["🚶‍", "🏃‍️", "🏇", "🚴‍"],
        ["🚗", "🚓", "🚕", "🛺", "🚙", "🚌", "🚐", "🚎", "🚑", "🚒", "🚚", "🚛", "🚜"],
        ["🚁", "🛸"]
      ];
      for (const set of chasers) {
        const chaser = set.randomElement();
        for (let i = 0; i < 3; i++) {
          if (Math.random() > 0.5 || !scene.includes(chaser)) scene += chaser;
        }
        scene += "&nbsp;&nbsp;&nbsp;";
      }
      return scene;
    }
  },
  {
    id: "a251",
    text:
      `Привет! Это я, ты из будущего! Я прибыл сюда чтобы предупредить тебя: прочитай КРАЙНЕ внимательно следующее
        новостное сообщение. В моей временной линии мы пропустили его, и с того дня человечество сожалело об этом.`
  },
  {
    id: "a252",
    get text() {
      return `<span style='animation: a-text-stretch ${newsAnimSpd(35)}s 1 forwards'>Это сообщение растянуто.</span>`;
    },
    get unlocked() { return PlayerProgress.realityUnlocked() || PlayerProgress.dilationUnlocked(); }
  },
  {
    id: "a253",
    text:
      `После всплеска негодования от наших зрителей, мы решили позволить вам писать собственные сообщения дома.
      Попробуйте здесь: <input style='border: none; outline: none; font-family: Typewriter;
      font-weight: bold; font-size: 1.5rem'></input>. Или нет. Это тоже нормально.`
  },
  {
    id: "a254",
    text:
      `Анонимус Измерений Антиматерии отключился из-за падения его 12-шаговой программы.
        Люди доходили только до шага 8 а затем сбрасывались.`
  },
  {
    id: "a255",
    get text() {
      return `Звуковой эффект брух #${format(Number.MAX_VALUE, 2)}.`;
    }
  },
  {
    id: "a256",
    text: "9ого измерения не существует, потому что 7ое измерение с8ело его."
  },
  {
    id: "a257",
    text:
      `Треугольная дыра в тканях реальности привела к потере некоторых букв английского языка. Эти буквы:
        j, k, q, u, x, z. Если честно я сам не понял шутку, объясните кто понял.`
  },
  {
    id: "a258",
    text:
      `Рождён слишком поздно чтобы исследовать мир. Рождён слишком рано чтобы исследовать космос. Но рождён как раз
        вовремя, для того чтобы гриндить пару часов до следующего большого хруста.`
  },
  {
    id: "a259",
    text:
      `Теперь погоди, я знаю о чём ты думаешь, "Нажатие Ь это нажатие Ь, ты не можешь сказать, что это только половина!"
        , ТиДжей "Слабдрилл" Йоши, услышь меня. Нажатие Ь на самом деле состоит из трёх частей: когда Ь нажата, когда Ь
        зажата и когда Ь отпущена. Далее, обычно, нажатие - то, что полезно, потому что это единственная часть, которая
        имеет значение. однако иногда достаточно только части зажатия, которая также покупает измерения и улучшения
        скорости тика. Что по поводу отпускания, ну, на данный момент не существует обстоятельств, при которых оно
        полезно или имеет значения, поэтому об этой части можно не беспокоиться. Теперь, если мы обозначим требуемые
        нажатия для челленджа 2, они будут выглядеть примерно так: /¯\\. Нам просто надо зажать (¯) Ь чтобы достичь
        первой галактики, надо нажать (/) Ь чтобы завершить челлендж, и надо нажать Ь ещё раз чтобы начать другой
        челлендж. Итак, как много нажатий потребовалось в сумме? Ну, похоже, что три, и, если мы делаем эту
        Вечность в изоляции, то да, это займёт три, но в Челлендже Кнопки Ь на всю игру существуют другие
        нажатия Ь, которые происходят ранее по игре, такие как нажатие Ь, необходимое для первой Бесконечности,
        поэтому если мы берём это нажатие Ь в счёт, то как много нажатий Ь необходимо сделать? Наивным ответом
        будет четыре: одно для того чтобы войти в челлендж, и три оставшихся внутри челленджа, описанных ранее;
        однако мы можем лучше. Мы на самом деле можем сделать это всего за три нажатия, просто зажимая
        первое нажатие Ь для того чтобы использовать его как половину нажатия Ь, потому что половина нажатия
        Ь требует только зажатия Ь, а не нажатия, поэтому, если рассматривать данную ситуацию с этой точки
        зрения, Челлендж 2 добавляет только два дополнительных нажатия Ь к игре, так как первое нажатие Ь просто
        подсасывается к предыдущему нажатию. Поэтому чтобы охватить этот феномен, мы называем его 2.5 нажатия Ь.
        На основе одиночной Вечности, вы бы округлили это значение до трёх, но в полной игре, вы бы округлили
        его до двух. Итак, в заключение, поскольку первое нажатие Ь в каком-то смысле учитывается, но не
        добавляет дополнительных нажатий в другом контексте, мы ссылаемся на него как на "Половину Нажатия Ь".`
  },
  {
    id: "a260",
    text:
      `Похоже, что Репликанты имеют очень разделяй-и-властвующий способ ведения дел.
        Что ж, всё что угодно на такой скорости.`,
    get unlocked() { return PlayerProgress.eternityUnlocked() || PlayerProgress.replicantiUnlocked(); }
  },
  {
    id: "a261",
    text:
      `Измерения Антиматерии - на самом деле игра в жанре Роглайт! Если вы умираете, вы разблокируете альтернативные
        возможности, типа Космических Измерений вресто Измерений Времени. Вы даже можете разблокировать новых
        игровых персонажей, включая клон самого себя из антиматерии!`
  },
  {
    id: "a262",
    text: "Вайб чек. 🏃‍♀️🏏"
  },
  {
    id: "a263",
    text: "Зачем нужны гемы? Гемы нужны для жилья. Жильё зачем вы спросите? Хороший вопрос."
  },
  {
    id: "a264",
    text: "Был анонсирован новый слой престижа: Материнство. Приготовьтесь завести ребёнка!"
  },
  {
    id: "a265",
    text: "ВЫ ДОЛЖНЫ СКОНСТРУИРОВАТЬ ДОПОЛНИТЕЛЬНЫЕ ИЗМЕРЕНИЯ."
  },
  {
    id: "a266",
    text: "Привет, как проходит твой день?"
  },
  {
    id: "a267",
    text:
      `У меня есть муравьиная ферма и я хочу сделать из них самую маленькую футбольную команду в мире. Моя Тётя Диана
        хочет помочь, и вместе мы соберём всю семью чтобы распланировать сезон. Дальше следует непереводимая игра слов
        с использованием местных идиоматических выражений.`
  },
  {
    id: "a268",
    text: "👨‍💻Програтители, компилируемся!👩‍💻"
  },
  {
    id: "a269",
    text:
      `В этом измерении пробка. Если вы планируете передвигаться по этой области, покиньте территорию рано. Вот
        футаж прямой трансляции: 🚗🚕🚛🚙🚗🚚🚕🚕🚌🚛🚚🚙🚒🚛🚗🚙🚓🚗🚚🚛🚒🚌🚐🚚🚐🚛🚚🚓 Да, Дэйл, я сказал бы
        что выглядит достаточно плохо. И не забудь взять с собой немного воды и снэков.`
  },
  {
    id: "a270",
    text:
      `Галактическая Ассоциация Писателей Новостей проиграла коллективный иск против разработчиков маленькой
        веб игры "Измерения Антиматерии" за массовый плагиат.`
  },
  {
    id: "a271",
    text:
      `<i style='border: 0.1rem solid black; border-radius: 50%; padding: 0.4rem; color: #2196F3; background: white;
      cursor: pointer;' class='fas fa-volume-up' onClick='(function(){new Audio("audio/news.mp3").play();})();'>
      </i> Это новостное сообщение - тест "Новости 2.0". Новости 2.0 добавят возможность прослушивания аудио версии
      любого новостного сообщения! Правда, пока только на английском языке.`
  },
  {
    id: "a272",
    text: "Что тяжелее, куча кирпичей или куча антиматерии?"
  },
  {
    id: "a273",
    text: "В новостных сообщениях нет опечаток. Если вы видите опечатку, очепятка, должно быть, у вас в голове."
  },
  {
    id: "a274",
    text:
      `Огромное количество матиматиков заходит в бар. Каждый из них заказывает в 10 раз больше пив, чем предыдущий.
        Бармен говорит: "Ну и ну, это же порядок величины!".`
  },
  {
    id: "a275",
    text: "Дающий Идти Вниз Айдл - самая короткая айдл игра всех времён, длится всего 26 секунд."
  },
  {
    id: "a276",
    get text() {
      return `Забавный факт: Существует ${GameDatabase.news.length} новостных сообщений и они прибавляются!`;
    }
  },
  {
    id: "a277",
    text:
      `Вну три тебя два волка. Один сделан из материи. Другой сделан из антиматерии.
        Ты взрываешься. Ауф.`
  },
  {
    id: "a278",
    text:
      `Это просто дружелюбное напоминание о том, что ты забыл сделать что-то действительно важное. Я не знаю что это,
      но что-то точно есть.`
  },
  {
    id: "a279",
    get text() {
      return `Скоро дойдёт до всех хороших продажников- Измерения Антиматерии: Настольная Игра! Наслаждайтесь
        трепетом просмотра роста огромных чисел без необходимости в ПК. Идёт со всем необходимым, включая смешанный
        научный калькулятор, ${format(Number.MAX_VALUE, 2)} счётчиков антиматерии, кнопка КУПИТЬ МАКС из
        высококачественного пластика и более тысячи карточек новостных сообщений со всеми нерелевантными мемами,
        которые вы знаете и любите! Вы наконец-то можете насладиться ИА в таком виде, в котором она задумывалась.
        ИА: Настольная Игра также доступна в размере для путешествий, чтобы вы могли испытать радость
        просчитывания логарифмического роста, пока вы в путешествии! КУПИТЕ ИА: Настольная Игра СЕГОДНЯ! Предупреждение:
        может содержать остатки настоящей материи. Репликанты продаются отдельно. 9ое Измерение не включено.`;
    },
    isAdvertising: true
  },
  {
    id: "a280",
    text: "Я ненавижу антиматерию. Она грубая, шероховатая, раздражающая и везде проникает."
  },
  {
    id: "a281",
    text: "Что если вместо создания антиматерии, вы на самом деле просто теряете материю?"
  },
  {
    id: "a282",
    text:
      `Было отрапортованное наблюдение 9ого Измерения, но с того момента оно было опровергнуто,
        и оказалось всего лишь 6ым Измерением из Австралии.`
  },
  {
    id: "a283",
    text:
      `Странный феномен происходит, когда вы пытаетесь переместиться в более высокое измерение, находясь в 8ом
        измерении. Более высокого измерения не существует, поэтому вселенная выбрасывает вас обратно в 8ое измерение с
        невероятным ускорением. Эта техника, именуемая Буст Измерений, повсеместно используется пилотами космических
        кораблей и энтузиастами антиматерии.`
  },
  {
    id: "a284",
    text: "Холодные полностью одетые парочки рядом с вами!"
  },
  {
    id: "a285",
    text:
      `Теперь вы дышите в ручном режиме. Теперь вы поняли, что для вашего языка нет комфортного места у вас во рту.
        Теперь вы вручную держите вашу челюсть. Вы не моргали несколько секунд. Вы постоянно видите небольшую
        часть вашего носа.`
  },
  {
    id: "a286",
    text: "Почему они называют это печь, когда вы из холодной еды из снаружи горячей едите еду?"
  },
  {
    id: "a287",
    text:
      `Последствия дошли до того, что некоторые студии тепрь производят сиквелы до оригиналов.
        Фанаты длинных серий ждут, как номер отсчитывается, пока они наконец не смогу понять, что вообще проиходит.`
  },
  {
    id: "a288",
    get text() {
      const position = player.news.specialTickerData.newsQueuePosition--;
      if (position > 1) {
        return `Благодарим вас за обращение в службу поддержки. Ваша сатисфакция очень важна для нас, представитель
          компании скоро будет у вас. Сейчас вы на ${position} в очереди. Спасибо за ваше терпение, пожалуйста
          наслаждайтесь этими отборными новостями, пока ожидаете.`;
      }
      return "Благодарим вас за обращение в службу поддержки, это Джейн, как я могу вам помочь?";
    }
  },
  {
    id: "a289",
    text: "Нажми сюда чтобы разобрать это новостное сообщение на небольшое количество скрепок.",
    onClick() {
      player.news.specialTickerData.paperclips++;
      GameOptions.toggleNews();
    }
  },
  {
    id: "a290",
    get text() {
      const paperclips = player.news.specialTickerData.paperclips;
      return `Видите ли вы, эти новости - не обычные новости. Они производятся первым измерением новостей. Если вы
        хотите разблокировать больше новостей, вам необходимо будет собрать достаточно скрепок, для того чтобы построить
        второе измерение новостей. Сейчас у вас есть ${ruQuantifyInt("скрепка,скрепки,скрепок", paperclips)}, но вам
        нужно ${formatInt(paperclips + 10)} скрепок для того чтобы купить его.`;
    }
  },
  {
    id: "a291",
    text: "Учитывая национальность Хэвипелле, немного иронично, что он создал игру без Финиша."
  },
  {
    id: "a292",
    text:
      `Фей не существует. Анти-фей тоже не существует. Это произошло только на прошлой неделе, когда
        две группы встретились. Планеты, на которой они жили, по понятным причинам, теперь тоже не существует.`
  },
  {
    id: "a293",
    text:
      `<span style='font-family: "Comic Sans MS", cursive, sans-serif; font-size: 1.7rem;'
      >Как поживаете, новостные сообщения! 🛹</span>`
  },
  {
    id: "a294",
    text: "Если вы видите новостное сообщение, а потом видите его ещё раз, становится ли оно старостным сообщением?"
  },
  {
    id: "a295",
    text: "👁"
  },
  (function() {
    let wasClicked = false;
    const normal = "Нажмите на это новостное сообщение чтобы сделать жёсткий сброс игры.";
    const clicked = "Ты сумасшедший. Знаешь что - вот. Держи скрепку.";
    return {
      id: "a296",
      get text() {
        return wasClicked ? clicked : normal;
      },
      reset() {
        wasClicked = false;
      },
      onClick() {
        if (wasClicked) return undefined;
        wasClicked = true;
        player.news.specialTickerData.paperclips++;
        return this.text;
      }
    };
  }()),
  {
    id: "a297",
    text: "Я не мыслю, следовательно, я не."
  },
  {
    id: "a298",
    text: `Это странно как говорящие задом-наперёд предложения делают предложения задом-наперёд говорящие как странно
      это?`
  },
  {
    id: "a299",
    get text() {
      return `Купите новый пазл Измерений Антиматерии прямо сейчас! С комбинируемыми ${format(Number.MAX_VALUE, 2)}
        кусочками, эти пазлы - идеальный способ качественно провести время с вашей семьёй!`;
    },
    isAdvertising: true
  },
  {
    id: "a300",
    text:
      `Совет директоров Антиматерии-1 считает, что мы должны заменить новостные сообщения рекламными
        баннерами. Пожалуйста подпишите нашу петацию на всем известном сайте, чтобы мы могли остановить их,
        прежде чем станет слишком поздно!`
  },
  {
    id: "a301",
    text: "Следующий час через 0.2 обновления."
  },
  {
    id: "a302",
    text: "Представляем Антиматерию Лайт! Ноль калорий... Тот же Хруст.",
    isAdvertising: true
  },
  {
    id: "a303",
    text: "Розы красные, фиалки синие, флаг - победа, баба это ты."
  },
  {
    id: "a304",
    text: "Привет, как твой день? Надеюсь он хорош. Если он не хорош, надеемся что игра в ИА сделает его чуточку лучше!"
  },
  {
    id: "a305",
    text: "Далее в новостях сегодняшний прогноз погоды. Сегодня 100% шанс погоды."
  },
  {
    id: "a306",
    text: "ЧИНЯЩИЕ НОВОСТИ: Пожалуйста, перестаньте их ломать."
  },
  {
    id: "a307",
    text:
      `Максимизатор скрепок — мысленный эксперимент, описанный шведским философом Ником Бостромом в 2003 году.
      Он иллюстрирует экзистенциальный риск, который сильный искусственный интеллект может нести для людей,
      если он запрограммирован на достижение даже кажущихся безобидными целей, а также подчеркивает
      необходимость добавления машинной этики при разработке ИИ. Сценарий описывает сильный искусственный
      интеллект, которому поручено производить скрепки. Если бы такая машина не была явно запрограммирована
      на то, чтобы ценить человеческую жизнь, то, обладая достаточной властью над окружающей средой, она бы
      попыталась превратить всю материю во Вселенной (включая людей), либо в скрепки, либо в машины,
      производящие скрепки.`
  },
  {
    id: "a308",
    get text() {
      const nameList = [
        "Антиология",
        "Бесконечнофекшн",
        "Вечный Свет",
        "Галаксия",
        "Дюпликанты",
        "Исследователь Измерений",
        "Техион",
        "Реалистичный",
        "Целестар",
        "ЕРЦГДМ",
        "НРГ+",
        "Лути Бокс",
        "Символик",
        "Минисофа",
        "ИДЕАЛ",
        "Аппанге",
        "Гогглы",
        "Интервал",
        "Новаязвезда",
        "ХэвиПеллет",
        "Марса",
        "Зоологи",
        "Фоторик",
        "Джэкоф",
        "Оризм",
        "ЕДИК",
        "Фиссион",
        "Гамма",
        "Фрактайлед",
        "Имнезия",
        "Фермик",
        "Автомайзеры"
      ];
      const names = [];
      while (names.length < 3) {
        const name = nameList.randomElement();
        if (!names.includes(name)) names[names.length] = name;
      }
      const prices = [
        Math.floor(Math.random() * 11) / 100,
        Math.floor(Math.random() * 11) / 100,
        Math.floor(Math.random() * 11) / 100
      ];
      for (let i = 0; i < 3; i++) {
        const price = prices[i];
        if (price === 0) prices[i] = `<span style="color: blue">0.00 ◄►</span>`;
        else if (Math.random() > 0.5) prices[i] = `<span style="color: green">+${price} ▲</span>`;
        else prices[i] = `<span style="color: red">-${price} ▼</span>`;
      }
      return `${names[0]} ${prices[0]}&nbsp;&nbsp;&nbsp;
        ${names[1]} ${prices[1]}&nbsp;&nbsp;&nbsp;
        ${names[2]} ${prices[2]}&nbsp;&nbsp;&nbsp;`;
    }
  },
  {
    id: "a309",
    text:
      `Прогноз оттенков неба на неделю forecast: Понедельник: <span style="color: turquoise">Бирюзовый</span>
      Вторник: <span style="color: #d2c6ba">Тёмно-серо-коричневый</span>
      Среда: <span style="animation: a-game-header__antimatter--glow 3s infinite">Синелетовый</span>
      Четверг: <span style="color: turquoise">Бирюзовый</span>/<span style="color: #d2c6ba">
      тёмно-серо-коричневый</span>
      Пятница: <span style="color: #222">Угольная пыль</span> Суббота: <span style="color: #222">Угольная пыль</span>
      с шансом на <span style="color: indigo">индиго</span> поздним вечером
      Воскресенье: <span style="color: white; animation: a-existence-glow 3s infinite">Пустота</span>`,
  },
  {
    id: "a310",
    text:
      `Вы достигли автоматизированную поддержку Измерений Антиматерии. Если вы встретили баг в игре, попытайтесь
        закрыть и снова открыть приложение. Если это не работает, нажмите 1 для веба, 2 для телефонов. Если вам нужен
      совет, нажмите 3. Если вам нужно Макс Все, нажмите ь. Чтобы поддержать разработчиков, нажмите 4. Чтобы зайти
      в ЧаВо, нажмите 5. Чтобы починить сломанное сохранение, нажмите 6. Чтобы получить приглашение в дикскорд сервер,
      ничего не нажимайте, вы его всё равно не получите. Чтобы посмотреть список изменений тоже ничего не нажимайте,
      он был удалён из этой версии игры потому что пришлось бы переводить слишком много текста, который всё равно
      никто не прочитал бы. Серьёзно, там больше тысячи строк. Нажмите 9, чтобы повторить.`
  },
  {
    id: "a311",
    text:
      `Это сообщение было защищено авторским правом Компанией Уолт Дис. Вы обязаны заплатить
        $9.99 за просмотр данного сообщения.`
  },
  {
    id: "a312",
    text:
      `Но прежде чем мы начнём, сегодняшнее видео существует благодаря Измерениям Антиматерии™! У него более 100,000
        скачиваний, и оно полностью поменяло рынок мобильных игр. В этой игре великолепные механики, 5
        слоёв престажи, уникальные челленджи, глубокое древо прокачки и самые большие числа, которые я когда-либо видел.
        Типа, серьёзно, посмотрите на них. А самое лучшее - она бесплатна! Да, это правда. Бесплатная. И если вы
        используете ссылку из описания под роликом, вы начнёте игру с 10 септилионами антиматерии. Да, всё верно, 10
        септиллионов. Так чего ты ждёшь, переходи по ссылке в описании и начинай играть в Измерения Антиматерии™
        уже сегодня!`
  },
  {
    id: "a313",
    text:
      `"...И затем, когда ты доберешься до уровня 9,000, ты сможешь возвыситься. Не уверен зачем тебе это нужно, это
        просто сбрасывает все твои очки опыта за небольшие бонусы, механики типа таких никогда не приживутся."
      - какой-то случайный парень, около 2012`
  },
  {
    id: "a314",
    get text() {
      const lawID = Math.floor(Math.random * 8901) + 100;
      return `Предупреждение: Закон ${lawID}-Б, составленный ИИ "даскскарф", также именуемый как "законопроект
        о гигантских космических кроликах" теперь действует в вашей галактической области. Этот список ограничивает
        и запрещает, среди прочего; нелегальную ловлю космических кроликов, умиротворение прирученных космических
        кроликов, и дальнейшие научные исследования с "планетарным пастбищем" до тех пор, пока разрешение не будет
        выдано вам напрямую даскскарфом. Список исключеный был выжжен на вашей сетчатки чтобы вы в любой момент могли
        его прочесть. Дополнительно, генетическая модификация гигантских космических кроликов ограничена до
        определённых областей - изменения роста (увеличение в размерах) и раздувание криптобиоза. Никакие другие
        генетические модификации недопустимы за рамками военного применения. Спасибо за кооперацию. Сообщение
        повторится через- Предупреждение: Закон ${lawID}-`;
    }
  },
  {
    id: "a315",
    text:
      `Разработчики игры анонсировали, что новая форма записи, "Истиннейший Слепой", будет выпущена. Они
        сообщают, что она удалит интерфейс, обеспечивая более прямолинейное взаимодействие с пользователем.`
  },
  {
    id: "a316",
    text: "Некоторые люди выбирают видеть безобразие этого мира. Беспорядок. Я выбираю видеть числа."
  },
  {
    id: "a317",
    get text() {
      return `${format(Number.MAX_VALUE, 2, 0)}? Не видел, ничем не могу помочь.`;
    }
  },
  {
    id: "a318",
    text:
      `Мы не можем определить сознательность, потому что сознательности не существует. Люди фантазируют, что
        в их восприятии мира есть что-то особенное, и всё же мы следуем инструкциям так же точно, как это делают боты,
        редко подвергая сомнению наши выборы, контент, по большей части, чтобы просто получить следующую инструкцию.`
  },
  {
    id: "a319",
    text: "Пожалуйста, не обращайте внимания на любые незаслуженные комплименты."
  },
  {
    id: "a320",
    text: "Представляем апфон 10: Первое в мире полностью растворимое в воде мобильное устройство!",
    isAdvertising: true
  },
  {
    id: "a321",
    text:
      `Должно быть, это тяжело, постоянно быть в своём ПК в одиночестве. Но не волнуйтесь; мы всё ещё здесь.
        Слушаем вас и наблюдаем за каждым вашим движением.`
  },
  {
    id: "a322",
    text:
      `Хэвипелле анонсирует спин-офф Измерений Антиматерии, где вы рискуете материей в покерной игре
        в Датских особняках. Назвиние игры - "Ante matter d'mansions"`
  },
  {
    id: "a323",
    text: `var i = "Омае ва моу шиндейру" console.log(i - 1 + "i?") NaNi?`
  },
  {
    id: "a324",
    text:
      `Если у вас есть идея для новостного сообщения - выкрикните её в пустоту.
        Это не добавит её в игру, но зато это весело!`
  },
  {
    id: "a325",
    text:
      `После инцидента в реакторе антиматерии в Припяти в прошлом месяце, растут опасения о безопасности реакторов
        антиматерии, люди начинают верить, что нам следует вернуться к более безопасным способам генерации энергии,
        таким как ядерная энергия.`
  },
  {
    id: "a326",
    text: "Измерения Антиматерии - они как огр... имеют слои."
  },
  (function() {
    let wasClicked = false;
    const normal = "Нажмите здесь чтобы перезапустить ваше устройство.";
    const clicked = "Пожалуйста предоставьте Измерениям Антиматерии права администратора.";
    return {
      id: "a327",
      get text() {
        return wasClicked ? clicked : normal;
      },
      reset() {
        wasClicked = false;
      },
      onClick() {
        if (wasClicked) return undefined;
        wasClicked = true;
        return this.text;
      }
    };
  }()),
  {
    id: "a328",
    text:
      `Новостная компания больше не позволяет случайным людям предлагать истории,
        вместо этого полагаясь на использование квалифицированных писателей. Начинаются беспорядки.`
  },
  {
    id: "a329",
    text:
      `Представляем Азбуку Морзе+++ - совершенно новую азбуку Морзе, теперь с 20 новыми
        символами, для всех, кто хочет скользить, застёгивать и свистеть!`,
    isAdvertising: true
  },
  {
    id: "a330",
    text: "Любая достаточно примитивная магия неотличима от технологий."
  },
  {
    id: "a331",
    text: "У меня нет носа, но мне надо чихнуть!"
  },
  {
    id: "a332",
    text: "♪ Когда совсем не старался и всё равно получилось. ♪"
  },
  {
    id: "a333",
    text: `Безумно популярная тематическая песня "Надо освободить их" достигла 500 миллионов скачиваний в первую
      неделю.`
  },
  {
    id: "a334",
    text:
      `Представляем полностью новый анти-выравнивающийся график! Характеризующий новаторские новые комбинации, такие
        как "законно-хаотичный" и "злой-хороший"! И с ослепительной третьей осью для 'Джаззовости'~ Идентифицируйте
        себя как хаотично-законно-неджазовый СЕЙЧАС за невозможно низкую цену в $-59.99! Условия и положения
        применяются. Батарейки не включены.`,
    isAdvertising: true
  },
  {
    id: "a335",
    text:
      `В связи с новыми осложнениями относительно "Игры", протесты начали подниматься по всей анти-ленной. Поэтому,
        государства вынуждены были изменить правила Игры, заявляя что вы побеждаете в Игре, если кто-то говорит
        вам об этом, вместо того чтобы проигрывать её.`
  },
  {
    id: "a336",
    text: `Внимание, резиденты зоны 4 [обычно называемой как 'тёмная зона'], сектор ϰ, (01,05). Не покидайте
      ваши места резиденции. Я повторяю, не покидайте ваши места резиденции. Не выходите наружу. Самый
      лучший метеорологический суперкомпьютер Землелогии, так же как и множество ведьм, неизменно свидетельствуют
      о 'по большей части странном вайбе' завтра и мы честно говоря совершенно не хотим знать что это означает.`
  },
  {
    id: "a337",
    text:
      `Технологическая конвергенция - концепт о том, что все технологии будут совмещены в одну. Это часто
        освещаемыя идея с рассвета Информационной Эры, она может наблюдаться в различных местах и устройствах, таких
        как смартфоны или интернет. Измерения Антиматерии - пример технологической конвергенции внутри медиа.
        Используя гениальную идею, называемую 'все равно', замешиваемую с инновационным решением 'слепой удачи',
        она совмещается в низкоуровневую игру и низкоуровневое новостное строку, чтобы создать посредственный
        опыт, который, несмотря на то что является игрой, иногда действует в качестве источника новостей
        немногим выше Бегущей Строки Измерений Материи. Поистине, достижение для всех бизнесов, за которым надо
        стремиться, и такое, которое стоит перебить.`
  },
  {
    id: "a338",
    text: "Древние наскальные рисунки с числом 5 были найдены. Предполагается, что они чего-то ожидали."
  },
  (function() {
    let wasClicked = false;
    const normal = "Читать Далее";
    const clicked = "Далее";
    return {
      id: "a339",
      get text() {
        return wasClicked ? clicked : normal;
      },
      reset() {
        wasClicked = false;
      },
      onClick() {
        if (wasClicked) return undefined;
        wasClicked = true;
        return this.text;
      }
    };
  }()),
  {
    id: "a340",
    text:
      `Ты делаешь достаточно много антиматерии. Разработчик игры впечатлён. Так как данное сообщение записано
        заранее, любые наблюдения относительно вашего производства антиматерии - спекулиция с нашей стороны. Пожалуйста,
        не обращайте внимания на любые незаслуженные комплименты.`
  },
  {
    id: "a341",
    text: "Игра на стадии разработки: Все механики должны носить жесткие ограничения."
  },
  {
    id: "a342",
    text: `Конечно скрепки не бесполезны, вы можете использовать их для скрепления листов бумаги. Но кто сегодня
      использует бумагу?`
  },
  {
    id: "a343",
    get text() {
      const fakeProgress = Math.pow(player.records.realTimePlayed, 25);
      // Caps in ~68 years of real playtime then turns into "Infinite%"
      return `Глобальный Челлендж - среди всех игроков ИА, соберите ${format(Number.MAX_VALUE, 2)} скрепок-соревнования
        (различимых по квадратным
        концам), чтобы получить эксклюзивную для события металлическую валынку, способную давать +2 АМ/с, а
        также дополнительную скорость тика после ${format(1e200)} улучшений скорости тика! Текущий глобальный прогресс -
        ${format(fakeProgress)}/${format(Number.MAX_VALUE, 2)}
        (${formatPercents(Math.log10(fakeProgress) / Math.log10(Number.MAX_VALUE), 3)})`;
    }
  },
  {
    id: "a344",
    text:
      `Реальная жизнь - ребус. Никто не знает как она на самом деле работает. Существует множество вопросов без ответа:
        В чем смысл жизни? Живём ли мы в симуляции? Как сделать Антиповорот? Где и как зародилось существование?
        Всё это - вопросы, которые всегда остаются на подкорке нашего сознания, а ответы на них?
        Возможно мы так и не узнаем.`
  },
  {
    id: "a345",
    text: "Японцы возмущаются, так как хайку не может быть здесь показан. Затевается конфликт."
  },
  {
    id: "a346",
    text:
      `А мне раньше стало плохо... А теперь мне хорошо...`
  },
  {
    id: "a347",
    text:
      `Плутон - не штат. 50 штатов, как все мы знаем, это: P = NP, Азия, Артемида, Атлантика, Брайль, Вараха,
      Великая Пирамида, Весы, Воздух, Восьмигранник, Галоген, Дательный, Двуязычный, Додекаэдр, Жидкий, Жёлтый,
      Запятая, Италия, Йель, Калий, Кандела, Канзас, Килиманджаро, Лавсан, Ладья, Левит, Лимфатический, Ловкость,
      Лямбда, Магматический, Мезозой, Микроволновка, Мюон, Наречие, Непарнокопытные, Новая Шотландия, Октябрь, Полк,
      Пятеричная, Разочаровывающий, Сатурн, Север, Сыроварня, Тиана, Тигр, Торговля, Фольклор, Шкив, Эри, Эукариот.`
  },
  {
    id: "a348",
    text: "<span style='color: red'>[Новостное Сообщение удалено модератором]<span>"
  },
  {
    id: "a349",
    get text() {
      const chapters = [
        `Мы прибыли, писатели, художники, скульпторы, архитекторы, пассионарные энтузиасты до сих пор нетронутой
          прелести Парижа, чтобы протестовать в полную нашу силу, всё наше негодование, во имя неизвестного
          французского вкуса, во имя искусства и французской истории, против эрекции, в сердце нашей столицы,
          бесполезной и монструозной Эйфелевой Башни, которую публичное зло, часто обозначаемое здравым смыслом
          как дух справедливости, уже наименовало "Вавилонская Башня". Без предавания экзальтации шовинизма,
          мы имеем право провозгласить Париж самым непревзойдённейшим городом в мире. Над всеми улицами,
          широкими бульварами и чудесными прогулками, возвышается самый благородный монумент, который человеческая раса
          когда-либо производила. Душа Франции, создатель шедевров, сияет посреди августовского цветения камней. Италия,
          Германия и Фландрия, по праву гордые их художественным наследиям, не имеют ничего по сравнению с нашим,
          и со всех углов вселенной Париж притягивает курьёзы и восхищение.`,
        `Неужели мы позволим всему этому быть оскверненным? Продолжит ли дальше город Париж ассоциировать себя с
          барокко, с меркантильными фантазиями машиностроения, чтобы стать непоправимо уродливым и бесчестным?
          Для Эйфелевой Башни, которую коммерческая Америка сама по себе не захотела бы, без сомнений, бесчестье
          Парижа. Все чувствуют это, все говорят это, все глубоко скорбят об этом, и мы - единственное слабое
          эхо вселенского мнения, так обоснованно встревожены.`,
        `Наконец, когда иностранцы приходят посетить нашу Выставку, они будут восклицать, ошеломлённые: "Что? Это тот
          ужас, что французы нашли, чтобы дать нам хвалёную идею их вкуса? И они будут правы в том, что будут смеяться
          над нами, потому что Париж возвышенной готики, Париж Жана Гужона, Жермена Пилона, Пюже, Рюда, Бари, и так
          далее, станет Парижем М. Эйфеля.`,
        `Этого более чем достаточно, для того чтобы понять, что то, что мы далаем чтобы представить ненадолго
          головокружительно нелепую башню, доминирующую Париж, так же как и гигантский дымоход фабрики, сокрушающийся
          своей варварской массой. Наша Леди, Сент-Шапель, Дворец Инвалидов, Триумфальная Арка, все наши униженные
          монументы, вся наша сжавшаяся архитектура, которая исчезнет в этом удивительном сне. И после двадцати лет,
          мы увидим как растянуться над всем городом, всё ещй трепещащего гением множества веков, мы увидим
          отвратительную тень отвратительной колонны, закреплённой болтами кучки листов металла, растянутой подобно
          чернильному пятну ...`,
        `Всё зависит от тебя, Месье и дорогой соотечественник, для тебя, так сильно любящего Париж, для тебя, того кто
           так сильно украшает его, того кто настолько часто защищал его от административного опустошения и вандализма
           индустриальных предприятий, защитить город ещё раз - честь. Мы оставляем за тобой право отстаивать
           интересы Парижа, зная что ты задействуешь всю энергию, всё красноречие, которое должно вдохновить
           артистичного человека, такого же как ты, на любовь к прекрасному, к великому, к правильному ...
           И если наш вопль тревоги не был услышен, если к нашим доводам не прислушаются, если Париж упрям в
           идее обесчещивания Парижа, мы, по крайней мере, ты и мы, услышым протест, который его чтит.`
      ];
      const chapter = chapters[player.news.specialTickerData.eiffelTowerChapter];
      player.news.specialTickerData.eiffelTowerChapter = (player.news.specialTickerData.eiffelTowerChapter + 1) % 5;
      return chapter;
    }
  },
  {
    id: "a350",
    text:
      `Александр рыдал, так как он только что посмотрел поп-культурную лекцию по квантовой механике от Анаксарха и
        понял что существуют бесконечные миры для завоевания, и что он не смог быть лордом даже одного без бунта
        или 6 останавливающих его.`
  },
  {
    id: "a351",
    text: "Привет, я здесь чтобы пожаловаться на плохое качество меди, которая только что была ко мне доставлена."
  },
  {
    id: "a352",
    get text() {
      return `<span style='opacity: 0; animation: a-disappear ${newsAnimSpd(20)}s 1'>
      Это новостное сообщение антимеметично. Вы скоро забудете о его существовании.</span>`;
    }
  },
  (function() {
    let wasClicked = false;
    const normal = "<span style='cursor: pointer'>💣</span>";
    const clicked = "💥";
    return {
      id: "a353",
      get text() {
        return wasClicked ? clicked : normal;
      },
      reset() {
        wasClicked = false;
      },
      onClick() {
        if (wasClicked) return undefined;
        wasClicked = true;
        return this.text;
      }
    };
  }()),
  {
    // Blob from the blob font
    id: "a354",
    text:
      `<span style='color: #FBC21B; text-shadow: 0px 1px 0px black, 1px 0px 0px black, 1px 1px 0px black,
      0px -1px 0px black, -1px 0px 0px black, -1px -1px 0px black, 1px -1px 0px black, -1px 1px 0px black'>
      \uE010</span>`
  },
  {
    id: "a355",
    text:
      `<div style='background: url("./images/unsmith.png"); width: 2.3rem; height: 2.5rem; margin-top: -0.1rem'></div>`
  },
  {
    id: "a356",
    text: `Нажмите "Выбрать сохранение" чтобы исследовать другие 2 параллельные вселенные.`
  },
  {
    id: "a357",
    text:
      `Начуное сообщество остаётся сбитым с толку значением 286,078. "Мы уверены, что оно связано с картофелем,
        но нам нужно провести больше тестов." - замечает один из исследователей.`
  },
  {
    id: "a358",
    text: `Нажмите "Выбрать сохранение" чтобы исследовать другие 2 параллельные вселенные.`
  },
  {
    id: "a359",
    text:
      `Местный разработчик инкрементальных игр снова делает физиков несчастными. Они утверждают
      "нарушения физики и вопиющее использование техноболтовни зашли слишком далеко".`
  },
  {
    id: "a360",
    text: `Нажмите "Выбрать сохранение" чтобы исследовать другие 2 параллельные вселенные.`
  },
  {
    // Discord contest winner #1
    id: "a361",
    text: "У нас распродажа высококачественных водонепроницаемых полотенец! Обязательно прихватите парочку по пути!"
  },
  {
    // Discord contest winner #2
    id: "a362",
    text:
      `Хэвипелле Инкорпорейтед рады представить вам новый бренд хлопьев: Большой Хруст! Этот питательный завтрак
        содержит хрустящие O антиматерии, карманные измерения, Сахарные Кубы со вкусом Бесконечности,
        экспоненциально-растущие Репликанты и Маршмэллоу со вкусом Вечности. Теперь вы можете испытать Измерения
        Антиматерии внутри вашего желудка! Предупреждение: Побочные эффекты могут включать в себя спонтанное
        воспламенение, тошноту, рвоту, диарею, дематериализацию, испарение, остановку сердца и конец мира. Если вы
        не сделаны из антиматерии, проконсультируйтесь со специалистом в области Потребления Антиматерии прежде
        чем употребить 'Большой Хруст'.`,
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "a363",
    text:
      `Самая ценная вещь в драконе - не золото, которое необходимо для наполнения гнезда, не магия, ради которой
        вы жертвуете целые империи, и не миллиарды войн, которые вам потребуется подкреплять адамантовыми решениями.
        Нет, это грязь. Это всегда грязь. Не спрашивай королевские сокровища о том, почему на самолёте больше существ,
        чем молекул земли. Просто продолжай призывать бульдозеры с помощью таинственных ритуалов и продолжай
        скоблить кусочки грязи из ядра Земли.`
  },
  {
    id: "a364",
    get text() {
      const products = [
        `Иллюстрация 320-А - Истинная Офисная Графическая Стена. Один из наших старших консультантов пронаблюдает
          за вашим бизнесом и составит список слов, которые будут добавлены в коридор, чтобы напоминать всем
          работникам о ценностях их компании. Известно, что он снижает мотивацию рабочих как минимум на 25%!
          Предыдущие стены включают в себя такие слова, как Чёрный Проход, Катастрофичность, Бессистемность,
          компрометация, Второсортность, Бредовость, Малоэффективность и Развал! Заказывайте сейчас!`,
        `Мебель 150-A (версия 2034) - устройство для сидения на 3 персоны. Революционный дизайн для офисных зон
          ожидания, состоит из 3 огромных табуретов, перевернутых вверх ногами в эстетических целях. Идеален
          для возвращения сотрудников к рабочим местам, в новом наборе обуви или штанов. Оно не привязано и не приклеено
          к полу как другие версии, но мы удостоверимся, что другие рабочие будут страннно смотреть на вас, если вы
          отредактируете наше произведение искусства. Нет необходимости заказывать, оно идёт в качестве бесплатного
          дополнения для любого покупателя!`,
        `Мебель 0853 - "Стойка" - это революционное рабочие пространство от создателей крадущегося стола
          поможет вашим сотрудникам преодолеть их ограничения и гарантирует, что ваш бизнес будет кричать в агонии!
          В моменты, выбранные нашим революционным "ИИ СтраданИИе", оно будет добровольно принуждать всех пользователей
          к носилкам. Рекомендуется местной тюрьмой, заказываайте сейчас! *Предупреждение, ОПА несёт ответственность
          только за деяния божьи, такие как молния или милосердные очищения божествами.`
      ];
      const product = products.randomElement();
      return `Офисные Принадлежности Антиматерии представляют новый каталог "Современный Офис"! Каждый шаблонный
        дизайн может быть подстроен под ваш бизнес и предлагает уникальные способы развития бизнеса! Вот
        небольшое описание одного из наших новейших товаров: ${product}`;
    },
  },
  {
    id: "a365",
    text: "Я не люблю Репликантов. Они шероховатые и грубые и раздражающие и они реплицируются повсюду.",
    get unlocked() { return PlayerProgress.eternityUnlocked() || PlayerProgress.replicantiUnlocked(); }
  },
  {
    id: "a366",
    text:
      `У сценической магии, такой как иллюзии, интересная история. Смесь шарлатанов, пытающихся обмануть людей,
        и актёров, отыгрывавших выступления с использованием иллюзий или ловкости рук. Изменяющиеся стили магии
        и продолжительное рассуждение и разногласия по поводу того, должно ли это называться иллюзией, и по поводу
        того, поймут ли магическим образом люди что это всё ненастоящее и что оно не должно обозначаться. Раскол
        век назад поделил магию на два типа - нежные, простые утилитарные трюки и великие спектакли, состоящие из
        распиливания людей наполовину. Во всяком случае, гораздо более интересно, просмотр какого-нибудь психованного
        по телевизову, притворяющегося что он вытащил лотерейный билет из бегущей строки новостей. Кстати, говоря
        об этом, сегодняшние лотерейные числа - 23, 10, 81, 106.4, 3 + 2i, e.`
  },
  {
    id: "a367",
    text:
      `Змеи выглядят пугающе, и они действительно такие и вам следует бежать, спокойно, от каждой увиденной змеии.
        К счастью для вас, змеи не часто проявляют инициативу укуса - исключая действительно подлых. Если они сошли
        со своего пути, чтобы укусить вас, обычно существует 4 причины. 1- Змея подлая. 2- Вы напугали змею. Змеи
        выглядят пугающе для вас, но вы пугающи для змей. Будьте большей ящерицой при встрече со змеёй. 3- Вы зашли
        на территорию змеи. Зачастую, змея предупредит вас, если вы это сделаете - это причина, по которой
        шипящие змеи шипят. Если вы не послушаете предупреждение, змея укусит вас. И, самая главная причина, 4-
        змея думает что вы уродливы. Это проблема окулярной системы змеи, но при этом самая основная причина укусов
        в последних двух юрисдикциях. Если вас укусила змея, по причине того, что вы пугающе уродливая ящерица, которая
        продолжает не на те кусты, существует 3 основных действия, которые вы можете предпринять. Во-первых,
        успокойтесь, успокойтесь опять и оставайтесь спокойным. Во-вторых, демобилизуйте укушенную область и
        попытайтесь использовать компрессионную повязку. Проницаемость яда змеи полностью основана на
        движении объекта, в который она попала. В-третьих, спокойно позовите о помощи от других ящеров. Исключая
        змею. Змея слишком подлая для того чтобы помочь вам.`
  },
  {
    id: "a368",
    text:
      `Я подозреваю, что больше людей нажимало бы кнопку жёсткого сброса, если бы подлинное усилие было бы приложено
        для того чтобы сделать этот процесс настолько жалким, насколько возможно. Медленное удаление ресурсов, с
        уникальными ослаблениями, созданными просто для того чтобы остановить ваш прогресс. Разрушение интерфейса,
        переходящего от терпимого до непригодного, скрытного и громоздкого, требующего запоминания и удачи
        просто для того чтобы продолжить квест. Случайность против игрока даже для простейших действий,
        наказывающая даже мысль о прогрессе. Крюки и ловушки, катастрофы и бросок кубика с низким шансом,
        отдаляющие состояние игры дадаше и дальше от разумного. Ситуация, при которой персонаж сломан, просто для
        того чтобы сказать вам уходить… но урон уже нанесён, если вообще возможно вернуть всё назад. И…
        отсюда жёсткого сброса скорее всего будет недостаточно. Потребуется что-то более… жёсткое. Не просто
        жёсткий сброс, но печенька, что-то в локальном хранилище, разработанной специально для того, чтобы невозможно
        было начать новую игру. Или может быть что-то более злобное? И несмотря на это, люди всё ещё будут
        помещать себя в этот кошмар, ибо человечество не знает границ своего бесконечного любопытства. Никакое
        количество предупреждений не остановит всех. Они найдут способ продолжить, если он существует, и даже
        будут возмущаться, когда оно будет не таким карающим, как они ожидали. Итак, хотите ли вы нажать
        кнопку и добровольно испытать глубины отчаяния? Надеемся нет, потому что здесь этого нет.`
  },
  {
    id: "a369",
    text:
      `Проект по созданию империи - одна из самых сложных в реализации вещей. Тысячи часов времени,
        планирования, стараний, консультирования, политического маневрирования чтобы создать поистине
        воздухоразрывательные стремления. Возьмём к примеру Карту Оживления Королевствегии. Это - революционная
        программа с кодовым названием 3 Р, известная как вершина самых известных комитететов по бюрократической
        инфраструктуре империй - УМИИ (учреждение магической инфраструктуры империи) - не путать с ИФЭД
        (инвестиционный фонд электрических дирижаблей) или НКМИ (Национальная Коалиция Магической Инфраструктуры).
        Цель трёх Р, обозначенная УМИИ - восстановить торговый коридор маны для СМПШ (Средне-Малых Паровых Шаттлов),
        ключевую часть расцветающих консолидированных штатов, после их неудавшегося мародёрства во время ДКпОГ
        (девятый крестовый поход за освобождение государства). Три Р был многоступенчатым проектом - стадия 1
        была воздушным опросом глифов - все большие дела ничинаются с маленького шага. Стадия 2, обнародование
        СпМЗИ (Силовое Поле Механического Забвения Империи) имела более 50 высокопоставленных лиц - множество
        императоров (от федеративных штатов до организационных лидеров), иностранные правители, ВМСС
        (Вытекающие Манифестованные Семьи Судьбы), которые сейчас владеют землёй, и даже некоторые прогнозирующие погоду
        ведьмы, все собрались вместе чтобы обнародовать проект на шоу ОИДС (Официальные Имперские Дружбы Солидарности).
        К сожалению, проект был отменён на стадии 215, создании EMTF (Хранилище Трансмутационного Материала
        Экскрементов), ибо подрядчики взорвались после контакта с СМЭК (Средне-Малыми Электрическими Кораблями),
        размещающими последние вешалки опросов со стадии 459 из-за нехватки временного вихря, вызванной спором в
        ВГИК (Ведьминский Годовой Инфраструктурный Комитет) как часть стадии 56. Поистине трагическая штука - 3
        номанации и 2 победы во время этого процесса из-за БЭПУ (Бюро Эффективности в Полевых Условиях).`
  },
  {
    id: "a370",
    text:
      "Чел пытается установить куки чтобы сохранить данные компьютера, случайно очищает их потому что слишком вкусные."
  },
  {
    id: "a371",
    text:
      `Поп-викторина: существует 3 двери, вы выбираете дверь случайным образом, и берёте себе то, что за ней находится.
        Двери имеют 2 золотых козы, 2 серебрянных козы, а также золотую и серебрянную козу. После выбора двери, дверь
        с наименьшей $ ценностью коз будет открыта и показана вам. После этого, вам даётся возможность изменить выбор.
        Какова вероятность того, что вы поменяете двери?`
  },
  {
    id: "a372",
    text:
      `Если вы когда-нибудь потеряетесь в лесу, посмотрите на деревья вокруг вас. Считается, что мох растёт с северной
        стороны, поэтому к моменту когда вы наконец перестанете смотреть на дерево, блуждающий гитарист подбежит к вам
        и спросит у вас хотите ли вы услышать Стену Чудес`
  },
  {
    id: "a373",
    text:
      `В качестве символа дружбы между Переодических Систем Химических Элементов Материи и Антиматерии,
      был совершён обмен элементов. Элемент Он теперь часть Переодической Системы Химических Элементов Антиматерии,
      а Неон - часть обычной Переодической Системы Химических Элементов.`
  },
  {
    id: "a374",
    text: "Это новостное сообщение было специально разработано исключительно для рекламных целей."
  },
  {
    id: "a375",
    text:
      `Как вы скорее всего знаете, принято дарить подарки, сделанные из определённых материалов в честь празднования
        годовщин. Классические - серебро на 25 и золото в 50. Вот некоторые менее известные подарки:
        Ананас - 37 лет Адский Камень - 66 лет Ящерит - 82 года Нитроглицерин- 86 лет Таконит - 95 лет
        Хачикот - 100 лет Электрум - 110 Якитода - 111 лет Фордит - 119 лет Кровавый Камень - 120 лет Звездит - 125 лет
        Джет - 140 лет Бензин - 145 лет Сталь - 150 лет Каммингонит - 198 лет Бетон - 200 лет Лазерсиний - 210 лет
        Болит - 250 лет Паристит - 255 лет Паразит - 260 лет Углеродные Нанотрубы - 300 лет Меркурий - 310 лет
        Марсианская Почва - 340 лет Нептуний - 370 лет Уран - 380 лет Плутоний - 390 лет Сиум - 400 лет
        Огненные стержни - 420 лет Асбест - 430 лет Габит - 444 года Багротановая руда - 666 лет Лагга - 777 лет`
  },
  {
    id: "a376",
    text:
      `Крупные технические корпорации объединились чтобы создать новую нейронную сеть, тренированную поколением рэп
        текстов, названную РЭП-3. Первые лирические поколения включают "Зови меня прометей потому что я принёс огонь"
        и "Зови меня Соник из-за способа, которым я получаю эти кольца". Критики говорят, что ей придётся пройти
        долгий путь, прежде чем она заменит традиционную музыку.`
  },
  {
    id: "a377",
    text:
      `С новым андроидом, андроид 20, предсказанном в будущем, новая система внутренних кодовых имён
        была раскрыта. Первое кодовое имя, как сейчас известно, это “антиматерия”. Это удобно сочетается с
        предсказываемым поколением телефонов, которые будут использовать андроид 20 - эти телефоны будут самыми
        дорогими за всю историю, в связи с их источником энергии, основанным на аннигиляции. Источники говорят о
        том, что исследование на миллиард долларов работает над названием андроида 21, по традиции начинающегося
        с Б, “звучит не так плохо когда думаешь об этом”. `
  },
  {
    id: "a378",
    text: `Если бы каждая антиматерия была яблоком, было ли бы у вас достаточно для того чтобы все доктора держались
      подальше на протяжении 3000 лет`
  },
  {
    id: "a379",
    get text() {
      return `ШТУКА ЗА${format(Number.MAX_VALUE, 2)}! ШТУКА ЗА ${format(Number.MAX_VALUE, 2)} НАСТОЯЩАЯ!`;
    }
  },
  {
    id: "a380",
    text:
      `Как же хочется тяночку. Как же хочется худенькую, бледную, не очень высокую, нецелованную, с тонкими руками,
        небольшими ступнями, синяками под глазами, растрёпанными или неуложенными волосами, ненакрашенную, забитую
        хикку, лохушку без друзей и подруг, закрытую социофобку, одновременно мечтающую о ком-то близком, чтобы
        зашёл к ней в мирок, но ничего не ломал по возможности, дабы вместе с ней изолироваться от неприятного
        социума. БОЖЕ КАК ЖЕ МНЕ ПЛОХО БЕЗ ТЯНОЧКИ.`
  },
  {
    id: "a381",
    text: "Почему они называют это вторым измерением когда ты из в первом измерении из снаружи второго ешь измерение?"
  },
  {
    id: "a382",
    text:
      `Любой игрок ИА, рождённый после 1993 не способен шутить... Всё, что они знают - 5 часов, скрепки, 1.79e308 &
        Девятое Измерение.`
  },
  {
    id: "a383",
    text:
      "Единственное, что лучше анти-шутки - 2. Типа число. Не две анти-шутки. Мне просто нравится число два."
  },
  {
    id: "a384",
    text: "Нажмите здесь чтобы ничего не произошло."
  },
  {
    id: "a385",
    text:
      `Интересно... Почему Эпл пропустили айфон 9, а Майкрософт пропустили Виндовс 9...
        Было ли это потому что они были подкуплены разработчиком игр?`
  },
  {
    id: "a386",
    text: "9 из 10 докторов рекомендует не трогать антиматерию. 10ый доктор нам не ответил."
  },
  {
    id: "a387",
    text:
      `Весной, Человек построил колонну. Летом, другую. Они продержались осень. Но зимой, одна из них испытала
      неожиданное событие (Смотрите определение в: Абстрактная Ретроказуальная Многомерная Физика) ЗВ-Класс
      "Возвышение", и, гипотетически, провалилась в пространственную петли, где она, исходя из определения,
      занимает больше измерений, чем она сама. Текущие попытки возвращения колонны в исходную реальность
      не увенчались успехом (Смотрите журнал теста 2453-3e9a-50d1-84fc для больших подробностей)`
  },
  {
    id: "a388",
    text:
      `В свете послених событий, мы хотели бы опубликовать официальное заявление. Измерения Антиматерии™ никаким образом
        не связаны с Нарушающими Причинно-Следственные Связи Мозговыми Червями Джимми™. Мы не поддерживаем и не
        вовлечены в их создание продукта, который был причастен в нескольких катастрофических дестабилизирующих
        измерения и опрокидывающих реальность инцидентах. Мы почти точно не подписывали контракт в 5:30:26 UTC
        08/12/1994 после обсуждения того, какую выгоду мы приобрели бы от дестабилизации и деформации измерений.
        Не было никакой промышленной зоны созданной в 5ый Рукав Ориона галактики వ', и даже если это было так,
        мы не устанавливали локализованные аномалии, преследующие Анти-якоревый механизм Реальности Скрантона
        В дополнение ко всему, никакая временная петля не происходит в  Помещении Ахроматического Сокращения AAF-D
        в области 43. Мы приносим свои извенения, если вещи выглядили таким образом, и мы впредь будем более
        аккуратны в взламывании дезинформации.`
  },
  {
    id: "a389",
    text: "Вот бы мы могли уплотнять антиматерию вселенной в печеньки..."
  },
  {
    id: "a390",
    text:
      `Пацаны, вы можете в это поверить? Обновление, всего 5 часов осталось. Обновление через 5 часов. Ваауу. Я так
        счастлив от этой информации. Обновление всего 5 через 5 часов. Вау. Вы можете в это поверить? Обновление всего
        лишь через 5 часов. Оно так быстро дошло. Обновление, всего 5 часов.`
  },
  {
    id: "l1",
    text: "Вы только что достигли 1,000,000,000,000,000ой антиматерии. Эта на вкус как курица.",
    get unlocked() { return Currency.antimatter.exponent === 15; }
  },
  {
    id: "l2",
    text: "Ослабьте галактики подалуйста.",
    get unlocked() { return player.galaxies === 2 || Currency.infinities.gt(0); }
  },
  {
    id: "l3",
    text: "Что ты имеешь в виду, больше двух измерений??? Мы на экране, очевидно здесь только 2 измерения.",
    get unlocked() { return AntimatterDimension(3).amount.gt(0) || DimBoost.totalBoosts > 0; }
  },
  {
    id: "l4",
    text: "Как много - Бесконечность? -буквально каждый хотя бы раз",
    get unlocked() { return AntimatterDimension(8).amount.eq(190) || Currency.infinities.gt(0); }
  },
  {
    id: "l5",
    text: "Ах, Четвёртое Измерение в порядке...",
    get unlocked() { return AntimatterDimension(4).amount.gt(0) && AntimatterDimension(5).amount.eq(0); }
  },
  {
    id: "l6",
    text:
      `Люди Антиматерии по-видимому боятся 13 больше нас. Они разрушили целые галактики
        просто чтобы убрать 13 из их процентов.`,
    get unlocked() { return player.galaxies > 0 || Currency.infinities.gt(0); }
  },
  {
    id: "l7",
    text: "Чтобы понять жертвование измерений, вам необходимо быть доктором наук теоритической Физики. Извините!",
    get unlocked() { return player.sacrificed.e >= 10 || DimBoost.totalBoosts >= 6; }
  },
  {
    id: "l8",
    text: "Новая группа для стандартизации чисел выступила с новой формой записи, предусматривающей эмодзи.",
    get unlocked() { return player.requirementChecks.permanent.emojiGalaxies > 0; }
  },
  {
    id: "l9",
    text: "Недавно открылись стенды мороженного антиматерии- они имеют октиллионы вкусов!",
    get unlocked() { return player.records.totalAntimatter.e >= 27; }
  },
  {
    id: "l10",
    text:
      `Небесный Пелле сгенерировал слишком много антиматерии и ему потребовалось создать другую галактику.
        Её можно наблюдать на южно-западном небе.`,
    get unlocked() { return player.galaxies > 0 || Currency.infinities.gt(0); }
  },
  {
    id: "l11",
    text: "9ое Измерение ложь.",
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l12",
    text: "Квадратный корень 9 это 3, поэтому 9ое измерение не может существовать.",
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l13",
    text: "Вы были ассимилированы 9ым измерением? Просто позвоните вашему доктору психических заболеваний!",
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l14",
    text: "Почему нет 9ого измерения? Потому что 7 8 9.",
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l15",
    text: "9ого измерения не существует, потому что Найн-говорящие погибли в ВМВ.",
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l16",
    text:
      `Если вы сломаете четвёртую стену... не, всё ещё существует пятая, шестая, седьмая, и восьмая, через которую вам
        предстоит пройти, прежде чем плохие вещи начнут происходить, поэтому вы должны быть в порядке.`,
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l17",
    text:
      `Для того чтобы Хэвипелле уснул, должны быть соблюдены условия. Во-первых, должна быть синяя луна. Во-вторых,
        определённый город в арктике не должен видеть света на протяжении месяца. В-третьих, ему нужно выпустить
        обновление ИА. И, наконец, никто из дикскорд сервера не должен быть в 9ом измерении. Только тогда он сможет
        отдохнуть не более 6 часов, прежде чем насильственно проснуться чтобы избежать получения офлайн достижения.`,
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l18",
    text: "Если 9ое измерение полностью злое, тогда 3 - корень зла?",
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l19",
    text:
      `Я возьму 1e29 номеров 9, номер 1e9 огромный, номер 6 с дополнительными репликантами, номер 1e7, два 4e5,
        одну с материей, и огромный временной вихрь.`,
    get unlocked() {
      return DimBoost.totalBoosts >= 5 ||
      player.galaxies > 0 ||
      PlayerProgress.infinityUnlocked();
    }
  },
  {
    id: "l20",
    text: "Бесконечность: та самая вещь, которая должна быть преодолена.",
    get unlocked() { return PlayerProgress.infinityUnlocked(); }
  },
  {
    id: "l21",
    get text() { return `У меня ${format(Number.MAX_VALUE, 2)} проблем, но ни одна из них ничего не антизначит.`; },
    get unlocked() { return Currency.infinities.gt(0) && !PlayerProgress.hasBroken(); }
  },
  {
    id: "l22",
    text: "Фильм Анти Эмодзи большой хит!",
    get unlocked() { return player.requirementChecks.permanent.emojiGalaxies >= 5; }
  },
  {
    id: "l23",
    text: "Если бы эта игра была сделана Valve, Ноль Смертей было бы невозможно.",
    get unlocked() { return Achievement(64).isUnlocked; }
  },
  {
    id: "l24",
    text: "Человек из флориды пытается получить Ноль Смертей в первой игре, остановлен тепловой смертью вселенной.",
    get unlocked() { return Achievement(64).isUnlocked; }
  },
  {
    id: "l25",
    text: "\"Выполнение половины достижений - не особо-то достижение\" -Буу",
    get unlocked() { return Achievements.effectiveCount >= GameDatabase.achievements.normal.length / 2; }
  },
  {
    id: "l26",
    text:
      `Танос будет супер расстроен когда он покажется с полностью заряженной Перчаткой Бесконечности, а Хэви
        придёт с полностью заряженной Перчаткой Вечности.`,
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l27",
    text:
      `Новый странный материал был обнаружен. Похоже, что он растёт экспоненциально, но помогает только производству
        антиматерии.`,
    get unlocked() { return PlayerProgress.replicantiUnlocked() && player.replicanti.chance === 0.01; }
  },
  {
    id: "l28",
    text: "Похоже, что эти \"репликанты\" теперь не будут расти быстрее.",
    get unlocked() { return player.replicanti.chance === 1 && player.replicanti.interval === 1; }
  },
  {
    id: "l29",
    text:
      `Если бы вы писали 3 числа в секунду, написание вашего количества антиматерии заняло бы меньше времени, чем
        количество, необходимоя для того чтобы Хэвипелле выпустил обновление.`,
    get unlocked() { return Currency.antimatter.exponent >= 100000; }
  },
  {
    id: "l30",
    text: "Хэви просто выбирает цитаты чтобы поместить их в игру?",
    get unlocked() { return NewsHandler.uniqueTickersSeen >= 30; }
  },
  {
    id: "l31",
    text: "Новая новостная компания стала нашим конкурентом. Они созданы исключительно из антиматерии.",
    get unlocked() { return NewsHandler.uniqueTickersSeen >= 80; }
  },
  {
    id: "l32",
    text: "Как много раз мы подряд можем использовать \"Анти\", прежде чем люди перестанут слушать?",
    get unlocked() { return NewsHandler.uniqueTickersSeen >= 100; }
  },
  {
    id: "l33",
    text: "Хэви сейчас вообще проверяет #предложения-для-новостей?",
    get unlocked() { return NewsHandler.uniqueTickersSeen >= 120; }
  },
  {
    id: "l34",
    text: "Нужно больше цитат! -хэвипелле",
    get unlocked() { return NewsHandler.uniqueTickersSeen >= 135; }
  },
  {
    id: "l35",
    text: `Чел разрушает известную вселенную антиматерией, пишет новые новостные сообщения чтобы не чувсовтвать себя
      одиноким.`,
    get unlocked() { return NewsHandler.uniqueTickersSeen >= 150; }
  },
  {
    id: "l36",
    text: "Ты почти у цели!",
    get unlocked() { return NewsHandler.uniqueTickersSeen >= 160; }
  },
  {
    id: "l37",
    text: "Теперь можно и остановиться",
    get unlocked() { return NewsHandler.uniqueTickersSeen >= 165; }
  },
  {
    id: "l38",
    text: "ну ты и хакер",
    get unlocked() { return NewsHandler.uniqueTickersSeen > GameDatabase.news.length; }
  },
  {
    id: "l39",
    text: "Азиат пытается забрать трофей самой быстрой бесконечности в -1 секунду, И У НЕГО ПОЛУЧАЕТСЯ!",
    get unlocked() { return NewsHandler.hasSeenNews("l1"); }
  },
  {
    id: "l40",
    text:
      `Я сломал 8ую стену, здесь только хаос, Слабдрилл ритуально жертвует антиматерию 9ому измерению.
      Это моя последняя запись, да смилостивится Хэвипелле над нашими душами, мы не слушали,
      Нужно было слушать.`,
    get unlocked() { return NewsHandler.hasSeenNews("l58"); }
  },
  {
    id: "l41",
    text: "Я думал до обновления оставалось 5 часов... -новые игроки после более чем 5 часов игры",
    get unlocked() { return Time.totalTimePlayed.totalHours >= 5; }
  },
  {
    id: "l42",
    text:
      `Кто-то вчера сказал мне подождать 5 часов до обновления, но уже сегодня и оно всё ещё
        не вышло! Что делать?`,
    get unlocked() { return Time.totalTimePlayed.totalHours >= 5; }
  },
  {
    id: "l43",
    text: "Ты же знаешь, что не достигнешь Бесконечности за -1 секунду, так ведь?",
    get unlocked() { return player.records.bestInfinity.time === 0.1; }
  },
  {
    id: "l44",
    text: "Где живёт Немо Антиматерии? В ННнНеМИ-ННнНе.",
    get unlocked() { return player.records.totalAntimatter.e >= 3e6; }
  },
  {
    id: "l45",
    text: "Фильм Анти Эмодзи MMMCMXCIX огромный хит!",
    get unlocked() { return player.requirementChecks.permanent.emojiGalaxies >= 3999; }
  },
  {
    id: "l46",
    text: "Достижение Разблокировано!",
    get unlocked() { return Achievements.effectiveCount >= GameDatabase.achievements.normal.length; }
  },
  {
    id: "l47",
    text: "Достижение за два миллиона, не два миллиарда...",
    get unlocked() { return Currency.infinities.gt(2e9); }
  },
  {
    id: "l48",
    text: "Продолжай в таком же быстром темпе!",
    get unlocked() { return AchievementTimers.marathon1.time > 1200; }
  },
  {
    id: "l49",
    text: "Однажды ты закончишь этот непрекращающийся гринд.",
    get unlocked() { return Currency.eternities.gt(50000); }
  },
  {
    id: "l50",
    text: "Ты наверное можешь перестать фармить вечности...",
    get unlocked() { return Currency.eternities.gt(DC.D2E6); }
  },
  {
    id: "l51",
    text: "Ты серьёзно?",
    get unlocked() { return Time.worstChallenge.totalSeconds <= 1; }
  },
  {
    id: "l52",
    text: "Тайминг - ключ.",
    get unlocked() { return player.records.thisEternity.realTime < 10; }
  },
  {
    id: "l53",
    text: "Если ты хочешь фармить бесконечности, почему просто не купишь временное исследование?",
    get unlocked() { return !TimeStudy(32).isBought && Currency.infinities.gt(72000 * 168); }
  },
  {
    id: "l54",
    get text() {
      const names = [];
      if (PlayerProgress.infinityUnlocked()) names.push("Бесконечности");
      if (PlayerProgress.eternityUnlocked()) names.push("Вечности");
      if (PlayerProgress.dilationUnlocked()) names.push("Растяжения");
      if (PlayerProgress.realityUnlocked()) names.push("Реальности");

      const game1Name = names.randomElement();
      let game2Name = names.randomElement();
      while (game2Name === game1Name) {
        game2Name = names.randomElement();
      }
      return `Покемоны ${game1Name} и ${game2Name} только что были выпущены! Это новое поколение повышает количество ` +
        "Покемонов до 1e151. Удачи собрать их всех!";
    },
    get unlocked() { return PlayerProgress.eternityUnlocked(); },
    isAdvertising: true
  },
  {
    id: "l55",
    get text() {
      const recipes = [
        "торт Репликантов: Соберите немного Репликантов, поместите в печь и наблюдайте за ростом. И ростом. И ростом.",
        "торт антиматерии: Соберите немного антиматерии, поместите в печь, и <b>БУМ<b>.",
        "торт Вечности: Соберите немного Очков Вечности, поместите в печь, и ждите...",
        `торт Бесконечности: Соберите немного Очков Бесконечности, поместите в печь, и наблюдайте за тем как они дробят
          пространство-время.`
      ];
      const recipe = recipes.randomElement();
      return `Как приготовить ${recipe}`;
    },
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l56",
    text: "Реальные Челленджи - новое 9ое Измерение новый апельсин.",
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "l57",
    text:
      `Ваня вернулся домой после долгого дня в школе. По пути домой, ему встретился любопытный небольшой объект.
      Прозрачный, но светонепроницаемый. Мерцающий, но мрачный. Тяжелый, но невесомый. Ваня принёс объект
      своей маме. "Мама, я нашел эту штуку на тротуаре, могу я оставить её?" - сказал Ваня. Его мама повернулась,
      чтобы посмотреть на объект, о котором говорил её сын. Её зрачки расширились: "Ваня, убери эту штуку из дома
      прямо сейчас!" - прокричала она. Ваня, удивлённый, потому что она смотрелось достаточно безобидно. Он спросил:
      "Но мама, чт-", но прежде чем он успел закончить, объект, по-видимому, с невероятно быстрой скоростью
      претерпел митоз, и вторая копия выскочила из его рук на пол. Его мать бросилась к нему и попыталась взять объект,
      но он реплицировался вновь. "Ваня... Независимо от того, что произойдёт, не забывай что я люблю тебя...". Она
      обхватила его руками. "М-мам, что происходит?" - спросил дрожащим от страха голосом Ваня. Его мать пустила
      одну слезу. "⭔⭚⦕꒜ бренд Репликанты..." - сказала она, угрюмым тоном. Репликанты продолжили размножаться с большей
      и большей скоростью. Нижняя треть дома теперь была полностью заполнена Репликантами. Затем нижняя половина. Затем
      весь дом. Мать и ребёнок были зажаты между стенами дома и Репликантами. Обреченные прожить короткий остаток
      их жизни в этом минеральном гробу, воздух из их лёгких постепенно выходил. Но это не был конец; далеко от этого.
      Репликанты начали реплицироваться снаружи дома, хлынувши наружу мерцеющим оползнем. Несколько соседей
      начали замечать странные объекты, почти жидкие на вид, и попытались бежать. Но Репликанты продолжили
      реплицироваться и ускоряться. Скоро весь район был заполнен ими; был ими. Вскоре несколько районов. Город.
      Окружающие города. Страна. Все страны. Вся планета. Вся солнечная система. Вся галактика. Всё.`,
    get unlocked() { return player.replicanti.unl; }
  },
  {
    id: "l58",
    text:
      `Святая троица Хэвипелле, Антиматерии, Очков Бесконечности и Очков Вечности. Эти 3 русурса дают нам
        доступ к дару Хэви, Временным Теоремам. И с этими Временными Теоремами, мы обращаемся к Хэви, и говорим: “Хэви,
        благослави нас в этот славный день!” И он благословит. Он даёт нам благословение Временных Исследований. Эти
        Временные Исследования были настолько мощные, что Хэви ограничил их мощь. Он сказал, “Я дам вам выбор из трёх
        путей” и человечество сделало выбор. Короткий, дешевый путь Измерений Антиматерии, дающий мимолётное
        наслаждение,
        мощный выбор Измерений Бесконечности, которые были быстрыми, золотой серединой, или Измерения Времени, длинное
        ожидание и борьба человечества. Затем, во время того как человечество делало выбор, трещина сломила Землю. Змей
        выполз и насмехнулся над человечеством, “Я дам вам мощный выбор девятого измерения! Я Слабдрилл, лорд всех
        Нехэви. Человечество поднялось и сказало “Убирайся, Слабдрилл! Нам не нужна твоя грязная ересь!” И Хэви
        тоже поднялся, и поразил Слабдрилла своей мощью. Пока тело Слабдрилла падало в землю, он кричал “это не конец!
        Хэви будет пре-“ и он упал в Бездну материи. Хэви одарил человечество улучшениями Вечности, которые давали
        бонус к измерениям бесконечности и измерениям времени. И Хэви дал человечеству его величайший дар. Множители ОВ.
        Он сказал, они умножат все получаемые ОВ на 5, но их цена будет увеличиваться в 50 раз. Используйте их с умом.
        И человечество отправилось в путь с его новой силой, пока слова Слабдрилла эхом отзывались у него в головах.`,
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l59",
    text:
      `Дебаты о сингулярности формы Репликантов продолжают бушевать. База команды "Репликантус" была ограблена
         командой "Также Репликанты", и множество их измерений было украдено. Команда "Множественные Число Это
         Репликантов" всё ещё залегает на дне после их провалившегося плана взломать словарь.`,
    get unlocked() { return player.replicanti.unl; }
  },
  {
    id: "l60",
    get text() {
      return `Срочные новости! Шатха Осколков Времени обрушилась! ${Math.floor(20 + Math.random() * 236)} шахтеров
        оказались в ловушке!`;
    },
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l61",
    text:
      `Миллениалы убивают индустрию челленджей, говорят эксперты антиматерии; "В настоящее время они начинают
        с пройденными челленджами и преодолённой бесконечностью; раньше было по-другому".`,
    get unlocked() { return PlayerProgress.infinityUnlocked(); }
  },
  {
    id: "l62",
    text:
      `Экономики возмущены, "Что вообще такое Очки Бесконечности? ОБ значит Областной Бюджет!".
        Дебаты продолжают усиливаться, больше в 7.`,
    get unlocked() { return PlayerProgress.infinityUnlocked(); }
  },
  {
    id: "l63",
    text:
      `Чувствуете ли вы что время стало идти медленнее? Исследования показывают, что 1 секунда сейчас длится
        примерно 1.3 секунды. Учёные называют этот феномен Растяжение Времени.`,
    get unlocked() { return PlayerProgress.dilationUnlocked(); }
  },
  {
    id: "l64",
    text:
      `Несправедливость в Академии Антиматерии: Новичкам разрешено выбрать одну область исследований, когда
        элита может выбрать все три. "Это тупо несправедливо, чувак. Как вообще так получилось?" - задаётся
        вопросом недовольный студент.`,
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l65",
    text:
      `Выходит, что никто на самом деле не знает как выглядят Очки Бесконечности. Даже людям, работающим над их
        хранением, специально говорят не смотреть на них, потому что они, как предполагается, "убивают всех, кто
        даже посмотрит на них", доходит до того, что иногда они работают с глазными повязками. Но сегодня это изменится
        Я прямо здесь, напротив Склада Очков Бесконечности, готов сообщить вам всем как они выглядят через 3, 2, 1-`,
    get unlocked() { return PlayerProgress.infinityUnlocked(); }
  },
  {
    id: "l66",
    text:
      `Человечество шокировано, провалившийся эксперимент Растяжения Времени вызвал визуальный глитч в
        пространстве-времени. Это событие можно наблюдать в ночном небе над Небесным Экватором.`,
    get unlocked() { return PlayerProgress.dilationUnlocked(); }
  },
  {
    id: "l67",
    text:
      `Вынюхивание разбившихся Осколков Времени постепенно становится причудливым челленджем среди наиболее скучающих
        людей. Говорится, что приход, который оно даёт, заставляет их испытать то, что как мир ускоряется вокруг вас,
        поэтому это было названо <span style="color: var(--color-eternity)">Челлендж Таймлапса</span>. &nbsp;&nbsp
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      Смерти от дегидрации зашкаливают, так как люди мистическим образом забывают пить воду. Незначительное количество
      следов Осколков Времени обнаруживают в их телах.`,
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l68",
    get text() {
      let protestText = "";
      if (InfinityChallenge(4).isRunning)
        protestText =
          `Подойдём к этому парню, который принадлежит стороне, считающей что это Бесконечный Челлендж 4. Что вы
            можете сказать? "Очевидно, Бесконечный Челлендж 4 самый худший, в смысле, что я вообще должен делать?
            Я продолжаю пытаться но каждый раз я застреваю и даже не близко к завершению! Как его вообще проходят?"
            Какой пылкий молодой человек. Это был ваш хост местных новостей, и мы вернёмся с дальнейшей информацией
            позже.`;
      else if (InfinityChallenge(5).isRunning)
        protestText =
          `Так, давайте поговорим с этим парнем, держащим плакат с надписью "БЧ5 Несправедливый". Что ваша группа
            хочет донести до общественности? "Ты плакат прочитать не можешь? Если твоё понимание настолько плохо,
            то Бесконечный Челлендж 5 раздавит тебя без малейшего шан-" Как... Интересно. Это был ваш хост местных
            новостей, и мы вернёмся с дальнейшей информацией позже.`;
      else
        protestText =
          `Наконец, давайте побеседуем с этой женщиной, которая, по-видимому, не придерживается никакой из сторон.
            Каково ваше мнение по этому поводу? "Лично я думаю что Челлендж АвтоПокупщика Скорост Тика был хуже, чем
            оба-" "ВЗЯТЬ ЕЁ!!" "СТОЙТЕ, НЕ-" Что ж, похоже что ситуация только что поменялась, поэтому я убираюсь
            отсюда как можно дальше. Это был ваш хост местных новостей, и мы вернёмся с дальнейшей информацией...
            когда-нибудь.`;
      return `Привет, это ваш местный всегда надёжный источник новостей, и сгодня люди выходят на улицы, чтобы
        разобраться в том, какой Бесконечный Челлендж является худшим. ${protestText}`;
    },
    get unlocked() { return InfinityChallenge(1).isUnlocked || PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l69",
    text: "Дружба с Репликантами закончилась, теперь Галактики Репликантов мой новый лучший друг.",
    get unlocked() { return PlayerProgress.replicantiUnlocked(); }
  },
  {
    id: "l70",
    text:
      `"Зуркрбарг, Божество Приватности" анонсировал планы по выпуску новой версии популярной
        вселенской социальной сети, "Все".`,
    get unlocked() { return Teresa.isUnlocked; }
  },
  {
    id: "l71",
    text: "Другие языки ожидают... Мне нужно стать программистом",
    get unlocked() { return Player.canEternity || PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l72",
    get text() {
      const scenarios = [
        `наши конкурсанты борются за выживание на безлюдной пустоши Вечного Челленджа 8 -
          у них заканчиваются Репликанты и Измерения Бесконечности, во что они обратятся?`,
        "мы расследуем сообщения об обрушении шахты Осколков Времени в 26:90.",
        "мы пригласим женщину, чтобы он рассказала, кто придумал девятый Челлендж Бесконечности.",
        "наши друзья в Антиматерии-1 объяснят как они производят свои репортажи.",
        "мы пригласим местных игроков айдл, чтобы они объяснили как играют в свои любимые игры.",
        `<span style='font-family: Barrio'>отправьте 10,000 Задонать Программисту По Полной
          коинов или вы никогда не увидите РеалиТВ вновь.</span>`,
        "мы разберёмся что вчера пошло не так в чёрной дыре, обеспечивающей наш город энергией.",
        "мы перейдём к нашим 10-дневным прогнозам погоды.",
        `ВЫ ДОЛЖНЫ ЗАПЛАТИТЬ ${format(player.reality.realityMachines.times(10).max(10))}
          МАШИН РЕАЛЬНОСТИ ЧТОБЫ ПРОДОЛЖИТЬ ПРОСМОТР ПРОГРАММЫ.`,
        "мы пронаблюдаем за гипнодронами.",
        "наш великий повелитель позволит нам получить одну антиматерию.",
        `Пушной объяснит как Репликанты реплицируются, и научит как определять опасные конспирологические теории,
          такие как "глотать антиматерию - абсолютно нормально" и "Галактики Антиматерии того не стоят".`,
        "величайшие философские дебаты на тему того, что мы - настоящая антиматерия.",
        `резидент пекарь объяснит как обычные объекты могут трансформироваться в торт, если за ними постоянно не
          следить.`
      ];
      const scenario = scenarios.randomElement();
      return `В следующий раз на РеалиТВ, ${scenario}`;
    },
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "l73",
    text: "Давным-давно, в далёкой-далёкой галактике, поменялось масштабирование цены.",
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l74",
    text: `Представляем новую фишку: Реальные Исследования! Получите внутриигровые преимещества от учёбы в реальной
      жизни!`,
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "l75",
    text:
      `Здесь в Измерениях Антиматрии, мы гордимся качеством нашей продукции. Например: Знали ли вы, что
        каждое Очко Бесконечности уникально? Это так! Все они имеют различные характеры, собственные
        чувства, собственные мысли... Я надеюсь ты сможешь спать спокойно этой ночью, зная это... Помнишь все те
        Очки Бесконечности, которые ты потратил? У них были семьи, и они скучают по ним... Посмотри что ты наделал.
        Ты - монстр.`,
    get unlocked() { return PlayerProgress.infinityUnlocked(); }
  },
  {
    id: "l76",
    text: "Итак, вы достигли слоя престижа после Бесконечности? Самое время...",
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "l77",
    text: "Улучшите ваши перки через селекционное разведение и передовые эпегенетические технологии.",
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "l78",
    text:
      `Предупреждение - Генетически Модифицированный Очки Перка не подходят для: употребления, физического контакта,
        вдыхания, выдыхания, психического контакта и оценки как видившими, так и не видившими глазами. Не хранить
        рядом с легковоспламеняющимся, сложновоспламеняющимся, проводкой, изоляцией, переменной, биологической
        или механической субстанцией. Существование на ваш страх и риск.`,
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "l79",
    text:
      `Межгалактическая Налоговая Служба Антиматерии, в противоположность общественному мнению, не имеет возможности
        платить налоги АМ, заработанной через не-скурпулёзные методы, т.е. все, не осуществлённые через
        предусмотренные законом измерения или модифицированной через курсы челленджей. Секция НУ-8Н перечисляет 3
        определённые методологии - нелегальные раздачи новостных сообщений, нераспознанные измерения и модификации
        к ткани пространства времени - а также разнообразные уникальные методы АМ, которые могут всплыть в будущем.
        И хотя вам придется заплатить максимальную налоговую ставку АМ в 99%, это может сохранить вам деньги в
        длительной перспективе - если вы вынуждены менять реальности в связи с божественной волей, вы
        можете получить налоговый вычет от МНСА, а также вычет, чтобы заплатить за арбитров, которые вас представляют.
        Конечно, любой [ОТСЫЛКА ИГРОКА НЕ НАЙДЕНА] стоящий своих МР, знает что настоящий способ спрятать нелегальный
        доход от преступления - персонализированные карманные измерения, гиперсложенные в форму волны банки и
        наноракушки, которые требуют дорогостоящих НИОКР для возведения. Поэтому, доклад о нелегальных доходах АМ
        рекомендован только в случае если вы слишком богаты для того чтобы спрятать ваши заработки, но слишком
        бедны чтобы спрятать ваши заработки.`,
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "l80",
    get text() {
      return `"Средний человек производит ${format("3e999999996", 2)} антиматерии в год". Фактоид, это
        статичтическая ошибка. Средний человек производит 0 антиматерии в год. "Разработчик Измерение" Геор,
        живущий в пещере, производит более ${format("1e1000000000", 2)} каждый день, является статистическим выбросом
        и не должен был учитываться.`;
    },
    get unlocked() { return PlayerProgress.hasBroken(); }
  },
  {
    id: "l81",
    text:
      `Мир в хаосе, так как законы математики были переписаны! Множество вещей, которые ранее считались бесконечными,
        теперь всего лишь очень большие числа!`,
    get unlocked() { return PlayerProgress.hasBroken(); }
  },
  {
    id: "l82",
    get text() {
      return `Великие Писцы Антии усердно работали годами. Богами им было дано колоссальное задание;
        написать непостижимо длинное число. Эпи писцы по очереди, каждый писал несколько чисел в секунду
        писали днём и ночью то, на протяжении, как им казалось, вечности. Наконец, после
        ${TimeSpan.fromSeconds(Currency.antimatter.value.log10() / 3).toString()}, они окончательно совершили
        невозможное. На этой неделе, когда они пошли поклониться своим богам, они сделали простое обращение: "Какова
        была цель? Что сделало годы нашего труда значимыми?" Боги должным образом ответили: "Мы хотели узнать
        сколько времени это займёт для статистики в нашей игре.";"`;
    },
    // 3 years of time to write
    get unlocked() { return Currency.antimatter.value.gte("1e777600"); }
  },
  {
    id: "l83",
    text:
      `ИА Примечания к Патчу: Очистил небесную проблему Заставил Антиматерию волноваться об аннигиляции больше
        Добавил рты Удалил рты Остановил нежеланных незванных гостей от кооперации захвата магазинов Починил проблему
        с новостными сообщениями зависшими в возвухе Мертвые репликанты остаются в своих галактиках Переобозначил
        незванных гостей чтобы они не включали в себя [ДАННЫЕ УДАЛЕНЫ] Тахион Частицы не застревают в левом верхнем
        углу экрана, уничтожая время Добавлен эффект Кориолиса для Прокрутки Направления Галактик`,
    get unlocked() { return Teresa.isUnlocked; }
  },
  {
    id: "l84",
    get text() {
      return `Для справки, вы сейчас имеете ${player.news.specialTickerData.paperclips}
      Бесполезных Скрепок. Возможно вы хотите потратить их на что-нибудь.`;
    },
    get unlocked() { return player.news.specialTickerData.paperclips > 0; }
  },
  {
    id: "l85",
    text:
      `В другой день, новое обновление будет всего лишь через -5 часов. Вы начинаете повышать вашу Материю.
        Как только вы получаете огромное отсутствие Материи, вы должны стать Бесконечномерным. После повышения
        вашего богатства Бесконечномерных Очков, вы наконец можете Омгновениться, самая короткая единица времени.
        После достаточного количества времени, ваши Омгновения накопятся, и вы заключите Контракт Времени. Заключение
        Контракта Времени даст вам достаточный бонус чтобы наконец Фантазировать, финальный слой
        обслуживания. Однако вы обнаружите что всё это был сон. Ваша антиматерия в безопасности, и, ну,
        новое обновление всего лишь в 5 часах.`,
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "l86",
    text:
      `Привет, игрок. Я хотел бы сыграть в игру. Перед тобой кучка репликантов. На данный момент они заморожены во
        времени и не могут реплицироваться. Справа от тебя компьютер, играющий в Измерения Антиматерии на пустом
        сохранении. Ты должен достигнуть бесконечности. Однако, как только ты купишь 1ое измерение, репликанты начнут
        реплицироваться. Как ты знаешь, они реплицируются быстро, и если они заполнят твою комнату - ты задохнешься.
        Если ты достигнешь бесконечности до этого момента, они вновь будут заморожены. Время идёт. Начинай сейчас же.`,
    get unlocked() { return PlayerProgress.replicantiUnlocked(); }
  },
  {
    id: "l87",
    text:
      `"В одном мгновенье видеть вечность, Огромный мир - в зерне песка, В единой горсти - бесконечность
        И небо - в чашечке цветка. А Реальность примерно через 5 часов™️" ~Анти-Уильям Блейк`,
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "l88",
    text:
      `Наши глубочайшие извенения за новые механики глифов. Цель была в том, чтобы доставить игрокам чувство
        гордости и достижения за разблокировку редких глифов. Вы выбрали начальные значения из данных от
        последней волны тестирования и других ругилоровок, сделаных чтобы ограничить награды до запуска.
        Среди других вещей, мы ежедневно смотрим за средними на игрока ставки по кредитному доходу, и будем
        привносить постоянные изменения, чтобы удостовериться что игроки сталкиваются с захватывающими и
        награждающими препятствиями, которые достижими через геймплей.`,
    get unlocked() { return PlayerProgress.realityUnlocked(); }
  },
  {
    id: "r1",
    text: "Это новостное сообщение в 100 раз реже чем все остальные.",
    get unlocked() { return Math.random() < 0.01; }
  },
  {
    id: "p1",
    text: "Is this a jojo reference?",
  },
  /* eslint-disable max-len */
  {
    id: "ai1",
    text: "If you are the game, then you can use the cheat to unlock a secret achievement...but it costs e1100 antimatter!?!"
  },
  {
    id: "ai2",
    text: "\"Hm, I don't know how to fix this.\" - Someone who has not unlocked the achievement btw"
  },
  {
    id: "ai3",
    text: "I thought the game was supposed to have a hard reset after eternity, but then I got randomized to start my first game with no save file \uD83D\uDE26",
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "ai4",
    text: "I thought the update was 5 hours ago... I guess we'll have to put it back in 5 hours"
  },
  {
    id: "ai5",
    get text() { return `Local man finds ${format(Number.MAX_VALUE, 2)} Planck volumes in his freezer.`; }
  },
  {
    id: "ai6",
    text: "ahah bad ticker suggestion"
  },
  {
    id: "ai7",
    text: "I see you playing this game with an empty stomach and you're gonna start playing this game with an empty wallet."
  },
  {
    id: "ai8",
    text: "just start... clicking. dont even think about wasting time. just do it."
  },
  {
    id: "ai9",
    text: "the idea that the 9th dimension creates the 8th dimension is crazy"
  },
  {
    id: "ai10",
    text: "...does that mean the [ДАННЫЕ УДАЛЕНЫ] dimension produces the [ДАННЫЕ УДАЛЕНЫ] dimension?"
  },
  {
    id: "ai11",
    text: "\"click here to buy a stack of paperclips\" (when clicked you get Rickroll)",
    // eslint-disable-next-line capitalized-comments
    // onClick() { window.open("https://www.youtube.com/watch?v=dQw4w9WgXcQ"); }
  },
  {
    id: "ai12",
    text: "In my spare time I read the short stories by T. H. White."
  },
  {
    id: "ai13",
    text: "Holy crap, that's pretty wild"
  },
  {
    id: "ai14",
    text: "Extinction is not a real thing. You can't wear the same hat 24/7."
  },
  {
    id: "ai15",
    text: "If you can read this you've escaped from the game."
  },
  {
    id: "ai16",
    text: "\"The hat trick I would love to see it\" - Noah Feldman"
  },
  {
    id: "ai17",
    text: "look at hevi fight riotously on the discord server"
  },
  {
    id: "ai18",
    text: "I just stole the \"Anti\" flag from a biker gang and I am packing it with dynamite, dynamite, dynamite, dynamite..."
  },
  {
    id: "ai19",
    text: "No matter how much antimatter you have, the matter will always outweigh the anti-matter."
  },
  {
    id: "ai20",
    text: "Franklin sealed the Omega squared. Now you can seal the Omega any way you want."
  },
  {
    id: "ai21",
    text: "Is this the real 9th Dimension?"
  },
  {
    id: "ai22",
    text: "Click here to exit the game"
  },
  {
    id: "ai23",
    text: "This news ticker will now only AIR in the 9th dimension"
  },
  {
    id: "ai24",
    text: "The 9th dimension doesn't exist because it was suppressed by the 9th dimension."
  },
  {
    id: "ai25",
    text: "To matter or to antimatter, that is the question."
  },
  {
    id: "ai26",
    text: "After 8 years of production and unstable universes, Chaosium will cease to exist in 5 hours."
  },
  {
    id: "ai27",
    text: "Half of the problems in the 9th dimension don't even make sense. What are they even doing with all of that energy anyway?"
  },
  {
    id: "ai28",
    text: "Wait, there's a nin--"
  },
  {
    id: "ai29",
    text: "Somewhere, a madman and his army of Trimps are tampering with Matter Dimensions."
  },
  {
    id: "ai30",
    text: "Why is there so many attached to this number? It doesn't make sense."
  },
  {
    id: "ai31",
    text: "The news ticker is in the anti-news-ticker"
  },
  {
    id: "ai32",
    text: "the 9th dimension doesn't exist because we are using nonary"
  },
  {
    id: "ai33",
    text: "BREAKING NEWS: New research has shown that not one, not two, but three people can be said to have felt the same emotion as me when they read that as a ticker suggestion."
  },
  {
    id: "ai34",
    text: "Here's an explanation of my 'problematic mood' - it's explained in the news ticker!"
  },
  {
    id: "ai35",
    text: "Local crazy person tries selling anti-cookies"
  },
  {
    id: "ai36",
    text: "Welcome to Antimatter Dimensions: Source, the free to play sequel to the cult classic AD:GO."
  },
  {
    id: "ai37",
    text: "A new hand touches your antimatter!"
  },
  {
    id: "ai38",
    text: "Who are we, anyways?"
  },
  {
    id: "ai39",
    text: "We are the people who actually matter"
  },
  {
    id: "ai40",
    text: "Matter?  Not even a hint."
  },
  {
    id: "ai41",
    text: "I am the news guy, I make news. You don't read this? Well you'll just have to wait until you look in the mirror."
  },
  {
    id: "ai42",
    text: "\"BOO!\" (news ticker moves 90 degrees)"
  },
  {
    id: "ai43",
    text: "BUY A JAR OF STICKERS, HIGH QUALITY STICKERS, GREAT QUALITY STICKERS!"
  },
  {
    id: "ai44",
    text: "I made news, you read it."
  },
  {
    id: "ai45",
    text: "I like news."
  },
  {
    id: "ai46",
    text: "I don't make news."
  },
  {
    id: "ai47",
    text: "YOU MAKE NEWS AND I GET THE [ДАННЫЕ УДАЛЕНЫ] NEWS"
  },
  {
    id: "ai48",
    text: "The term \"Anti-infinity\" is a verb and cannot be a noun. Learn about its usage here."
  },
  {
    id: "ai49",
    text: "And now, for the shopping list!"
  },
  {
    id: "ai50",
    text: "The 9th dimension is clearly real! It's just not in our dimension."
  },
  {
    id: "ai51",
    text: "I tried searching on google for the phrase \"9th dimension,\" and I'm okay with saying that, because it describes a very real thing."
  },
  {
    id: "ai52",
    text: "You have no power here."
  },
  {
    id: "ai53",
    text: "Some people had to settle for 10 dimensions because they couldn't break infinity. Big Crunch turned out to be just a short space in time."
  },
  {
    id: "ai54",
    text: "There once was a young man in a strange land, and he dreamed of a universe filled with possibilities. One day, he asked his mother \"What's Expansion like?\" Her reply was \"Expansion times back then were unbalanced, and I said that's why you can't have equal amounts of matter and antimatter."
  },
  {
    id: "ai55",
    text: "Market research firm tries to explain why some commodities don't perform as expected. Market research firm herself can't figure out why."
  },
  {
    id: "ai56",
    text: "Bid your antimatter today!"
  },
  {
    id: "ai57",
    text: "I am Alpha Centauri, Prime 001. My research has found that if you are alive in the 9th dimension, evil has taken over your dimension and is attempting to enact its plan to take over your mind and reverse time. You must do everything in your power to stop this plan from being implemented, now."
  },
  {
    id: "ai58",
    text: "Stand by and unlock the 9th dimension for a secret achievement."
  },
  {
    id: "ai59",
    text: "I fix bugs in 5 hours"
  },
  {
    id: "ai60",
    text: "If you're reading this, that means you can read this."
  },
  {
    id: "ai61",
    text: "Uhh... Hi. Could you tell me your name?"
  },
  {
    id: "ai62",
    text: "Uh, no. This is too big for a QR code."
  },
  {
    id: "ai63",
    text: "(right to left move it make)"
  },
  {
    id: "ai64",
    text: "Oh no the antimatter is coming for us!"
  },
  {
    id: "ai65",
    text: "Why is there so much antimatter in this world? For a start, it's all produced by the antimatter factories on Earth. Secondly, the factories on"
  },
  {
    id: "ai66",
    text: "It's nothing personal, bro. -All villager types"
  },
  {
    id: "ai67",
    text: "I tried my best to read those tiny, handwritten messages, but whoever designed scythes hated me and stuck them in a corner. -Porygon-Z"
  },
  {
    id: "ai68",
    text: "Hmm... I don't know how I ended up here. I don't even know if I'm supposed to be here. I just sit here and imagine what could have been if I hadn't stopped. Oh god, what could have been..."
  },
  {
    id: "ai69",
    text: "Aw shucks, I finally hacked it enough to get to the C21 unlock, boss!"
  },
  {
    id: "ai70",
    text: "Купил мужик антиматерию"
  },
  {
    id: "ai71",
    text: "So you're telling me that I can post here, watch the titanic twice, come back and not be able to post?"
  },
  {
    id: "ai72",
    text: "The last update was 5 hours ago. There is no next update, because the last update was 5 hours ago. We will update our podcast in 5 hours to cover the entire topic of 5 hours, because this is the last podcast ever, everyone knows that the update is always 5 hours away, but in reality it's more like 1-2-3-4-5-6-7-8-9-10 minutes away, but in our heads it's closer to an actual accurate update date, like 5 hours away but with a few tickspeed upgrades."
  },
  {
    id: "ai73",
    text: "Yep. You. Get. Over. Your. Antidimensions."
  },
  {
    id: "ai74",
    get text() { return `Ad bonus: $${format(Number.MAX_VALUE, 2)} (random team)`; }
  },
  {
    id: "ai75",
    text: "Pass me that history, please"
  },
  {
    id: "ai76",
    get text() { return `Now releasing: Dimsension ${format(Number.MAX_VALUE, 2)}`; }
  },
  {
    id: "ai77",
    text: "ur history teacher said i was mad for getting *insert something here* on my bday"
  },
  {
    id: "ai78",
    text: "All is fair in antimatter"
  },
  {
    id: "ai79",
    text: "The Mysterium, the 2nd Dimension"
  },
  {
    id: "ai80",
    text: "Oops, I think we misticked."
  },
  {
    id: "ai81",
    text: "please wait 5 HOURS FOR THE NEWS"
  },
  {
    id: "ai82",
    text: "please wait til the weather improves"
  },
  {
    id: "ai83",
    text: "Please, take a minute to appreciate the beauty of this news ticker."
  },
  {
    id: "ai84",
    text: "How about this, working backwards? You know, from the time period covered by the question, that the game is set in, say, the 1950s. Now, if we talk about how games are set in the 2030s. Games are defined as any media, not necessarily of the form \"play some game\" (which, by the way, is a useful thing to have in one's vocabulary) but any media that can be understood as a game (i.e. a media that one can play back in time}, and games are defined as any game that one can't play back in time."
  },
  {
    id: "ai85",
    text: "How about AD, made by NaN? Higher quality, obviously. But still, [ДАННЫЕ УДАЛЕНЫ]"
  },
  {
    id: "ai86",
    text: "I thought the whole \"annihilation is just a phase\" quote was awesome until I realized it also gave me a [ДАННЫЕ УДАЛЕНЫ]"
  },
  {
    id: "ai87",
    text: "I have created an Omsi universe. And it's [ДАННЫЕ УДАЛЕНЫ]"
  },
  {
    id: "ai88",
    text: "I put [ДАННЫЕ УДАЛЕНЫ] in the oven. It got [ДАННЫЕ УДАЛЕНЫ] and I [ДАННЫЕ УДАЛЕНЫ] am [ДАННЫЕ УДАЛЕНЫ]"
  },
  {
    id: "ai89",
    text: "What are the red herrings?"
  },
  {
    id: "ai90",
    text: "Help we are stuck in Hevipelle's (http://en.wikipedia.org/wiki/Hevipelle) basement and hevi is forcing us to build a [ДАННЫЕ УДАЛЕНЫ] wall to keep [ДАННЫЕ УДАЛЕНЫ] away from [ДАННЫЕ УДАЛЕНЫ]"
  },
  {
    id: "ai91",
    text: "And now, for the weather. 70 and raining in North Dakota, remember those lovely, big, golden, iron curtain bars. Also remember that the [ДАННЫЕ УДАЛЕНЫ] weather! Just remember: [ДАННЫЕ УДАЛЕНЫ] and [ДАННЫЕ УДАЛЕНЫ] outside [ДАННЫЕ УДАЛЕНЫ]"
  },
  {
    id: "ai92",
    text: "Let's play a little game. You will start with no possessions and no goals. Lets say you have [ДАННЫЕ УДАЛЕНЫ] and your [ДАННЫЕ УДАЛЕНЫ] is [ДАННЫЕ УДАЛЕНЫ] you can [ДАННЫЕ УДАЛЕНЫ]"
  },
  {
    id: "ai93",
    text: "What are gems for?"
  },
  {
    id: "ai94",
    text: "Who made the 5th dimension?"
  },
  {
    id: "ai95",
    text: "I don't get it"
  },
  {
    id: "ai96",
    text: "Why is nobody talking about the 9th dimension?"
  },
  {
    id: "ai97",
    text: "This news sucks. Why no you don't get it?"
  },
  {
    id: "ai98",
    text: "Sorry, your reality has disconnected from the 9th dimension. You will now remain in the 8th dimension until further notice."
  },
  (function() {
    let wasClicked = false;
    const normal = "Now holding Infinity!";
    const clicked = "<#351477791457542144>";
    return {
      id: "ai99",
      get text() {
        return wasClicked ? clicked : normal;
      },
      reset() {
        wasClicked = false;
      },
      onClick() {
        if (wasClicked) return undefined;
        wasClicked = true;
        return this.text;
      }
    };
  }()),
  {
    id: "ai100",
    text: "I get all my news from this Discord, not 5 hours of my life"
  },
  {
    id: "ai101",
    text: "meow"
  },
  {
    id: "ai102",
    text: "You are now manually blinking."
  },
  {
    id: "ai103",
    text: "Sorry, your mic is playing Antimatter Dimensions."
  },
  {
    id: "ai104",
    text: "Sorry, your reality has disconnected from the 9th dimension."
  },
  {
    id: "ai105",
    text: "Apparently I am the bad guy in this video. I'm the one who did nothing."
  },
  {
    id: "ai106",
    text: "There are multiple ways to win this game. You can either type in your coordinates directly into the game, or you can type them into google which produces a different result. If you are getting the \"same exact thing\" result, your computer must be malfunctioning. Test results indicate that your computer is malfunctioning and you should check your firmware for vulnerabilities. You can also try turning off the news and re-running the game, but doing this only makes the \"the weather is X\" joke. Waiting six hours for a news message is NOT a news message."
  },
  {
    id: "ai107",
    text: "The weather is actually a thing. Scientists have confirmed that there is a correlation between the amount of Antimatter in the earth and the amount of weather. The earth is indeed a magnet, but scientists now hypothesize that as the earth warms up, the magnetic reconnection will accelerate, and this could cause a domino effect to cascade throughout the world, eventually leading to uncontrolled nuclear winter and spontaneous antimatter implosion."
  },
  {
    id: "ai108",
    text: "The tenth dimension is not a real thing. Stop telling people that."
  },
  {
    id: "ai109",
    text: "Don't tell Hevi it's not a real thing"
  },
  {
    id: "ai110",
    text: "i dont know how to fix this"
  },
  {
    id: "ai111",
    text: "This update is not for you!"
  },
  {
    id: "ai112",
    get text() { return `This is the last time, to buy items, you must pay a small fee of ${format(Number.MAX_VALUE, 2)} real money.`; }
  },
  {
    id: "ai113",
    text: "What is Antimatter? Long ago, gods lived in harmony. Then, everything changed when the apocalypse broke out. Chaos reigns, and even higher dimensions are being built. This is your fate. Build the Antimatter Dimensions. Amen."
  },
  {
    id: "ai114",
    text: "Water under the bridge?"
  },
  {
    id: "ai115",
    text: "I wonder if anyone has posted about this before me?"
  },
  {
    id: "ai116",
    text: "This post has been shared many times. Who knows how many?"
  },
  {
    id: "ai117",
    text: "Good night!"
  },
  {
    id: "ai118",
    text: "I made a timeline of my replicanti battles, which can be found here."
  },
  {
    id: "ai119",
    text: "\"Quantumum Battle Royale coming in 5 hours!\" (Rumor: 5 hours)"
  },
  {
    id: "ai120",
    text: "Rumor says Nords will start producing replicanti in five hours."
  },
  {
    id: "ai121",
    text: "I am an Nordsweeper, stealing their jobs to support the replicanti factories"
  },
  {
    id: "ai122",
    text: "Used to be, AD was the best game. Nowadays, it's all crapp."
  },
  {
    id: "ai123",
    text: "You better stop looking at these news ticker suggestions, before your fingers dry up."
  },
  {
    id: "ai124",
    text: "Antimatter Dimensions *Loses* bee movie."
  },
  {
    id: "ai125",
    text: "Oh, god, there's replicanti in my peas.",
    get unlocked() { return PlayerProgress.replicantiUnlocked(); }
  },
  {
    id: "ai126",
    text: "Oh, god, I'm stepping on a replicanti."
  },
  {
    id: "ai127",
    text: "Hello, world!"
  },
  {
    id: "ai128",
    text: "Welcome to /r/AskReddit about submarines. - accurate as of January 8th, 2017"
  },
  {
    id: "ai129",
    text: "Antimatter being researched by the government. Is it safe to say that this news ticker is fake?"
  },
  {
    id: "ai130",
    text: "Does the news show at Infinite Antimatter?"
  },
  {
    id: "ai131",
    text: "Have you saved your game? Yes. Have you quit your game? Nothin' wrong with this save. just keep holding that key."
  },
  {
    id: "ai132",
    text: "i clicked too fast...my fps dropped"
  },
  {
    id: "ai133",
    text: "I found out that the year is 20XX. I was going to make a news ticker but then I realized that it's just a ticker."
  },
  {
    id: "ai134",
    text: "\"One of these days I'll get bored of reading news for a while\" - old man"
  },
  {
    id: "ai135",
    text: "'Tis the season for new antiques! Get your first ever LOOK at these unique objects, before they're gone!' Sold out!"
  },
  {
    id: "ai136",
    text: "3 things that antimatter, 1 more thing to infinity"
  },
  {
    id: "ai137",
    text: "Buy the paperclip emojis now at https://aarextiaokhiao.github.io/blob/master/docs/en.json"
  },
  {
    id: "ai138",
    text: "click here to unlock the next update"
  },
  {
    id: "ai139",
    text: "(If you want you can make this only show when the news actually loads)"
  },
  {
    id: "ai140",
    text: "Malicious men are trying to make antimatter money, but their attempt is getting in the 9th dimension. What do you think about that?"
  },
  {
    id: "ai141",
    text: "Hey Siri, grind antimatter galaxies"
  },
  {
    id: "ai142",
    text: "Have you saved your game? If so, then you can continue playing without"
  },
  {
    id: "ai143",
    text: "It's like Getting your first arcane point. You know, like in the old ad where you're like \"I get this ad, I should make this ad"
  },
  {
    id: "ai144",
    text: "Ooga Booga"
  },
  {
    id: "ai145",
    text: "Boo has his own webpage! You might even call it \"Boo's Dandy\"\">https://en.m.wikipedia.org/wiki/Olli%27_Web#Main_page>"
  },
  {
    id: "ai146",
    text: "Meeseeks and nerds clash in epic GG war"
  },
  {
    id: "ai147",
    text: "My final test has come out! It was a simple math problem, just the two greatest chess GM's ever! Guess what happened? Both got annihilated!"
  },
  {
    id: "ai148",
    text: "Oh wow, that's 67.3%, which is actually OK, because it's logarithmic"
  },
  {
    id: "ai149",
    text: "\"Aleph_Time\" is that logarithmic scale joke?"
  },
  {
    id: "ai150",
    text: "Hello everyone, my name is Anti-Dio. I produce antimatter through a process you all know as \"antimatter decomposition\" you may recall this from my test report earlier this month I tested wether or not my ranch produces antimatter or not... everything was fine until that point, when I added a dash of lag to the equation, and it became a vicious cycle accelerating the rate at which antimatter is produced, which in turn accelerates the rate at which you all die. I've saved this by using a unique combination of genetic engineering and big data mining, I'm hoping to one day pull the trigger on a mechanimatter device that creates dimensions behind closed doors, but for now, this has all been a race to the bottom of which system producethiks, and in the end, we'll take a bite out of your (read error: allowed) pie. Goodbye."
  },
  {
    id: "ai151",
    text: "\"I propose that we form a phylogenetic tree of anti-history, just like tree of life. Everyone would be credited with originating from the ancestor of that anti-tree.\" -Dio, toast of eternal damnation"
  },
  {
    id: "ai152",
    text: "historian: I love how each generation looks back on an earlier generation and think, \"Those generations were really bad\""
  },
  {
    id: "ai153",
    text: "\"My parents went to anti-university\" - my grandparents"
  },
  {
    id: "ai154",
    text: "Only anti-jokes are funny"
  },
  {
    id: "ai155",
    text: "Infinity machine breaks Infinity"
  },
  {
    id: "ai156",
    text: "Okay boomer, you get your first taste of antimalware with this one."
  },
  {
    id: "ai157",
    text: "This program cannot access confidential information, such as the IP addresses of the Tamazight Vaults."
  },
  {
    id: "ai158",
    text: "Game Development is fun, right? That's why so many hobbyists make games, and why so few professionals make games."
  },
  {
    id: "ai159",
    text: "I was the first to notice that the 'news' ticker on my mobile notification is always 30 seconds behind the 'entertainment' ticker. This is most definitely not a bug or a feature, and will be fixed in 5 hours."
  },
  {
    id: "ai160",
    text: "This news ticker always appears to speedrun a ticker asking for 'world records', do you even know what speedrun this is? Is this a news ticker or something?"
  },
  {
    id: "ai161",
    text: "The next level is not unlocking extra replicanti; it is actually boosting replicanti."
  },
  {
    id: "ai162",
    text: "Why does one galaxy has 9 galaxies and the 8th dimension, and the first 10 dimensions doesn't exist? Well, we'll have to solve that question in a minute."
  },
  {
    id: "ai163",
    text: "So why on EARTH DIDN'T SOMEONE JUST SAY THAT? I thought that AD has some kind of cheat that makes it so that, when you buy a dimension, it actually creates 9 galaxies instead of 10"
  },
  {
    id: "ai164",
    text: "M'antel, antimatter, anti-talk to me"
  },
  {
    id: "ai165",
    text: "AD has anti-parts, you'll hate them"
  },
  {
    id: "ai166",
    text: "AD is basically a badly disguised dystopia at this point"
  },
  {
    id: "ai167",
    text: "Hold M. You forgot to take all the anti-matter out!"
  },
  {
    id: "ai168",
    text: "AD will be implemented in 5 hours"
  },
  {
    id: "ai169",
    text: "Click this to unlock the 10th Dimension"
  },
  {
    id: "ai170",
    text: "Click here to complete a secret against HEVI"
  },
  {
    id: "ai171",
    text: "You are doing a good job there"
  },
  {
    id: "ai172",
    text: "Hevi? Are you sure you want to buy that?"
  },
  {
    id: "ai173",
    text: "Buy premium antimatter to help the world's least developed get ahead!"
  },
  {
    id: "ai174",
    text: "One of the most influential people in neuroscience believes that our perception of reality comes from 10 dimensions instead of 8"
  },
  {
    id: "ai175",
    text: "Why is there so many zeroes in 'nowhere'?"
  },
  {
    id: "ai176",
    text: "There are no bugs in this game, they're just features"
  },
  {
    id: "ai177",
    text: "\"Click to advance 5 hours in time.\" (Now only show up after you advance more than an hour ago)"
  },
  {
    id: "ai178",
    text: "Oh god my phone is being watched"
  },
  {
    id: "ai179",
    text: "Welcome to the newest version of Antimatter Dimensions. Now with less features!"
  },
  {
    id: "ai180",
    text: "\"That's gonna get in trouble\" (less likely to get in trouble)"
  },
  {
    id: "ai181",
    text: "\"please don't disable the news ticker\" (Instead of having a black screen just a white one with a long, long, long, long, long, long, long, long, long, long, long, long, long, long, long, long)"
  },
  {
    id: "ai182",
    text: "\"You have 7 biological minutes.\" (Instead of giving a boost to any strains)"
  },
  {
    id: "ai183",
    text: "\"According to quantum string theory, there is a fundamental connective that binds the 3rd and 8th dimensions.  This means that any pill or injection that tries to bind the 9th dimension will be thwarted and rendered useless.\" (bound to get in 10 minutes)"
  },
  {
    id: "ai184",
    text: "\"Click this to gain a secret achievement.\" (Now only show up after you gain at least 1 antimatter, screenshot proves)"
  },
  {
    id: "ai185",
    text: "\"The secret to winning Antimatter Dimensions is to unbind the 9th dimension and unlock the 10th dimension\" (can be done only after unlocking the secret achievement: \"Eternity\" http://imgur.com/E4261C7h)"
  },
  {
    id: "ai186",
    text: "\"Click here to gain 1 matter.\" (only shows up after you beat IC5)",
    get unlocked() { return InfinityChallenge(5).isCompleted; }
  },
  {
    id: "ai187",
    text: "I thought the update was"
  },
  {
    id: "ai188",
    text: "Now that you possess all 8 dimensions, it is possible to get the no-edge achievement. However, if you get the no-edge achievement, the game breaks."
  },
  {
    id: "ai189",
    text: "You just became a part of history."
  },
  {
    id: "ai190",
    text: "Hell hath antimatter so I don't want to live there."
  },
  {
    id: "ai191",
    text: "I LIKE THAT DIMENSION 9 IN CLASS"
  },
  {
    id: "ai192",
    text: "\"1 2 3 4 5 6 7 8 10 11 12 13 ...\" -Back to the future"
  },
  {
    id: "ai193",
    text: "You have reached infinity, there is no universe, you are an eternity away from there."
  },
  {
    id: "ai194",
    text: "IM MADE THIS GAME GREAT AND RANDOMLY ACHIEVABLE"
  },
  {
    id: "ai195",
    text: "Welcome to the first ever, DIMENSION 9 IN CLASS! An endless stream of possibilities greets you! You may never create an infinite number of 8th dimensions, but you can create an infinite number of 8th dimensions, and you can increase the starting values of both dimensions by adding them together. Nice and simple, I call it Antimatter Dimensions."
  },
  {
    id: "ai196",
    text: "age 8-12: play elder puzzles"
  },
  {
    id: "ai197",
    text: "What does it mean if someone is \"young and full of puzzles\"? Does \"puzzled\" make that person young and full of puzzles?"
  },
  {
    id: "ai198",
    text: "To the customer in aisle 6th who bought a fifth of antimatter, I say buy a sixth! Buy it now!"
  },
  {
    id: "ai199",
    text: "Dear sir, we don't make Anti-Atomic Bread for Antimatter Pizza, we make Antimatter Bread for you!"
  },
  {
    id: "ai200",
    text: "Yay! Lets make some antimatter!"
  },
  {
    id: "ai201",
    text: "THE ANTIMATTER BREAD COMPANY DOESN'T EXIST!"
  },
  {
    id: "ai202",
    text: "Click here to exit the news",
    onClick() { GameOptions.toggleNews(); }
  },
  {
    id: "ai203",
    text: "I thought the update was 5 hours away, but it actually took me 6 hours to post this because I was behind on my update. I'll be honest, I'm not sure how many update I need to get though, if any."
  },
  {
    id: "ai204",
    text: "To count past Infinity Points: take a moment to remember that each Infinity Point is 3.1415926534255412730527058904816097160734272605282087086280545991105332533235580946684229821413112145239989073467482298142857147816092947183909298728571478160929471839229814054718139332405281814522993758179568572657123928651310585727283312547569289993282758012466111097726331726572854689993262899140527282527842535179715673311119101119015549552926278425351797156777263324503517971568583819492728180977263317971568432854104102725270847764253513791376909285717082857262987160927285711464363930996928984794380124566417932628571475245456845692846809466184179328572814384259326270817052727852348111714690577263323799509856279752173478925"
  },
  {
    id: "ai205",
    text: "\"Watch out, these news aren't supposed to be in.\" (appears when you buy the news for the first time)"
  },
  {
    id: "ai206",
    text: "These are all the time studies that never got into the game.",
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "ai207",
    text: "With the release of the next update, we're introducing a new dimension - the 9th Dimension. To unlock this dimension, you just have to collect a lot of paperclips."
  },
  {
    id: "ai208",
    text: "Why does nobody talk about Tungsten?"
  },
  {
    id: "ai209",
    text: "and now we return to your regular news... for the weatherman, there seems to be a decent amount of particles and ozone holes, which means less ozone layer to break, which means less particles to catch fire and cause global warming. But, ozone layer to melt, glaciers to run, and overpopulation. All around us is a blurple glow, almost blue, almost purplish-blue. It's been a grand, colorful season. Here, grab a handful of these paperclips, dear. They're quite small, I just happen to have them here. Now, grab a handful of your fellow Earthicans, grab a handful of your antimatter, and strap yourselves in. It's gonna be a bumpy one. We'll be there in five hours. The antimatter is gonna melt your ozone layer, and the glaciers are gonna melt your ice caps. All in all, it's gonna be a nice, smooth, non-slippery one. Unless it isn't. [Blurple glow trails off, and the bluer glow begins to spread throughout the sky. The bluer glow begins to fade as the purple glow begins to grow brighter, almost bluish, before finally disappearing altogether. The purple glow grows brighter still, as the bluer glow grows weaker, almost useless, before finally disappearing entirely, as the bluer glow fades. All around us, the purple glow grows stronger, almost killing it off completely. It could kill us. It could take us the rest of our lives to write this. - The Echidnas, when asked why the purple glow grows stronger, than the bluer glow.]"
  },
  {
    id: "ai210",
    text: "Scientists have discovered farts are really antimatter, and matter is just normal matter."
  },
  {
    id: "ai211",
    text: "Time for the weather to change."
  },
  {
    id: "ai212",
    text: "I HAVE MOVED TO THE 01th DIMENSION"
  },
  {
    id: "ai213",
    text: "Nah, just kidding"
  },
  {
    id: "ai214",
    text: "\"i'm not gonna lie, theres way too many good ones in the game already\" - poor guy who played minigame enhancement"
  },
  {
    id: "ai215",
    text: "item has gone missing for 7 days and 1 night"
  },
  {
    id: "ai216",
    text: "Shocking new study reveals that the biggest secret to winning Antimatter Dimensions is 'Not Being There'."
  },
  {
    id: "ai217",
    text: "The next update is in 18000 seconds. Stop wasting your time reading this. Focus on the game."
  },
  {
    id: "ai218",
    text: "idk if this makes news"
  },
  {
    id: "ai219",
    text: "(disabling news will make news notations take priority over other notifications)"
  },
  {
    id: "ai220",
    text: "You don't want to hear this, child."
  },
  {
    id: "ai221",
    text: "Click here to disassemble the news ticker for a trace amount of useless paperclips.",
    onClick() {
      GameOptions.toggleNews();
      player.news.specialTickerData.paperclips++;
    }
  },
  {
    id: "ai222",
    text: "Press alt+f4 to unlock 9th dimension"
  },
  {
    id: "ai223",
    text: "Hold you mean that hevi cant unlock the ninth dimension wtf"
  },
  {
    id: "ai224",
    text: "Finally hevi figured out how to get the 9th dimension... guess he never really cared though."
  },
  {
    id: "ai225",
    text: "Imagine being a meme."
  },
  {
    id: "ai226",
    text: "Posted on June 10, 2016 by Anonymous"
  },
  {
    id: "ai227",
    text: "This is your news. Refresh whenever."
  },
  {
    id: "ai228",
    text: "I see you in the news. So, what do you play - 1E209"
  },
  {
    id: "ai229",
    text: "Do you really want to leave your keyboard at home? We are not supposed to leave news at home, are we?"
  },
  {
    id: "ai230",
    text: "It is being created..."
  },
  {
    id: "ai231",
    text: "Took you long enough"
  },
  {
    id: "ai232",
    text: "You're now logged out of this tab"
  },
  {
    id: "ai233",
    text: "Close this tab for maintenance"
  },
  {
    id: "ai234",
    text: "To make matter or antimatter, you just have to look outside. The factory in Salzburg has closed down because the matter there doesn't want to part with its newest invention, which is said to be able to produce antimatter in one go! The last person to open this door was never seen again."
  },
  {
    id: "ai235",
    text: "You are living. You occupy space. You are large. You are neither small nor large-sized. You are neither oblong nor round. You are neither blue nor red. You are anti-blue. You are anti-red. You are anti-brown. You are anti-brown matter. You are anti-yellow. You are anti-green. You are anti-yellow matter. You are anti-blue. You are anti-green anti-matter. You are anti-red. You are anti-white. You are anti-red anti-matter. You are anti-white anti-matter. You are anti-brown matter. You are anti-white anti-matter. You are anti-white anti-matter."
  },
  {
    id: "ai236",
    text: "Welcome to"
  },
  {
    id: "ai237",
    text: "THANK YOU FOR VISITING THE SAME WEEKS AGO I LOVE YOU\" (TIPS)"
  },
  {
    id: "ai238",
    text: "\"i thought the whole game was in the news ticker\" (before they get weird)"
  },
  {
    id: "ai239",
    text: "\"I wonder what the game is worth\" - crazy person"
  },
  {
    id: "ai240",
    text: "\"Is anyone working on breaking infinity?\" (Seriously, this game needs to be Oceanhorned.)"
  },
  {
    id: "ai241",
    text: "I found out there are multiple versions of this game. One of these is called 'Standard Pro'. Another one is called 'Low Pro'. I'm not even sure if these are the same game or not."
  },
  {
    id: "ai242",
    text: "Is that a Bad Thing or a Good Thing? That depends on if it's a GOOD Thing or A LIE."
  },
  {
    id: "ai243",
    text: "\"Hevi kind of forgot about the update, but the update certainly hasn't forgotten about him\" - Kajfik"
  },
  {
    id: "ai244",
    get text() { return `The Big Crunch. What could that be?  About 4*1024 Big Crunch points?  About ${format(Number.MAX_VALUE, 2)} antimatter points?  About the same as a galaxy?  About the same as a galaxy, you say? Just look at that.  An antimatter galaxy.  Only this game can provide such a vast amount of antimatter, and it's FUN!  I said "fun"!  What's not to love?`; }
  },
  {
    id: "ai245",
    text: "Click here to exit the application"
  },
  {
    id: "ai246",
    text: "Wait, there's a mobile version? When?"
  },
  {
    id: "ai247",
    text: "Im not sure if you mobile guys are beautiful or whatever but theres this news ticker that's sharing my feelings with the world"
  },
  {
    id: "ai248",
    text: "I thought the update was 5 hours away"
  },
  {
    id: "ai249",
    text: "The best-kept secret in the universe is the KISS-IT secret. Showcasing your appreciation for the maintenance men today!"
  },
  {
    id: "ai250",
    text: "The contest is a tie. Mischief will be determined by the secret achievement."
  },
  {
    id: "ai251",
    text: "Back in my day, we needed a secret achievement to unlock the <<$!19>> achievement. It was a fairly simple system: you had to find a secret message in the game, find the secret achievement, and then, from that, you would be able to unlock the achievement."
  },
  {
    id: "ai252",
    text: "We have evolved a fast hand in the antimatter stakes."
  },
  {
    id: "ai253",
    text: "Hello, how'd your day go?"
  },
  {
    id: "ai254",
    text: "How'd your ⢿─┃│? Good, because today we're having a little chat about the 5th dimension."
  },
  {
    id: "ai255",
    text: "What's Antimatter going to do?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ah ha, I'm back."
  },
  {
    id: "ai256",
    text: "Imagine being a 9th dimension. [WIP]"
  },
  {
    id: "ai257",
    text: "Woo hoo, we've lost the war,"
  },
  {
    id: "ai258",
    text: "Lore: Grand Theft Antimatter"
  },
  {
    id: "ai259",
    text: "Hm, I don't get why people think there is a 9th dimension. The 9th dimension is explained in detail in the [[Infinite Teleport Project]] video, and in a [[Word Problem]] that [[can be viewed here|http://www.thingiverse.com/id98109802713176601414569]] ."
  },
  {
    id: "ai260",
    text: "In the [[GameFAQs|http://www.gfaq.com/gfaqs/this-game-faq-by-title]], one of the most popular [[news ticker messages|http://www.gfaq.com/tug/this-game-faq-by-title]]. You should also check out [[our newest attraction, the [[5th dimension|http://www.gfaq.com/gfaqs/this-game-faq-by-name]] and [[nothing](https://www.youtube.com/watch?v=lXMskKTw3Bs)."
  },
  {
    id: "ai261",
    text: "I have waited a whole eternity for this day...NOW! I can finally finish my slowmode, because today is  day 0. I also forgot to change the  slowmode to 6 hours because you can't see the slowmode, but I will have to wait until next reboot to find out how long this slowmode will last.... -some mysterious being who hasn't finished his slowmode yet"
  },
  {
    id: "ai262",
    text: "Hey you, you're finally awake. You were trying to buy a dimension, but it's impossible."
  },
  {
    id: "ai263",
    text: "Press F to pay respects"
  },
  {
    id: "ai264",
    text: "Press M to pay antimatter"
  },
  {
    id: "ai265",
    text: "Press L to revive the dead"
  },
  {
    id: "ai266",
    text: "Your CPU is too powerful. You need to give it a big crunch."
  },
  {
    id: "ai267",
    text: "Roses are red. Violett are blue. Tom are red. Antimatter are blue. We exist because of the unbeatable antimatter that is antimatter. What is it that makes us different? I don't know. It may even be the non-existence of antimatter."
  },
  {
    id: "ai268",
    text: "I'm not sure if I want to buy the full version of this game, or a little earlier, but I can say this: The reduction in quality of the earlier games is worse than the reduction in quality of the later games."
  },
  {
    id: "ai269",
    text: "I think the \"I want to see the cutscenes\" list is better"
  },
  {
    id: "ai270",
    text: "I have a bad feeling reading this"
  },
  {
    id: "ai271",
    text: "where are you? (point upwards) --> in a keep, between dimensions (point downwards) --> in a cell, between dimensions"
  },
  {
    id: "ai272",
    text: "Instructions clear, got a ninth dimension epiphany"
  },
  {
    id: "ai273",
    text: "Want to play a secret achievement? Yeah, I get that. But say it loud, say it clearly, and do it by ticking a certain secret achievement. Like I said, it's not easy, and there's lots of it. Also, don't forget your Infinity, or your in is thi--"
  },
  {
    id: "ai274",
    text: "MEE6 was seen in my antimatter lab trying to tell me that I am the matter of the 8th dimension."
  },
  {
    id: "ai275",
    text: "What if"
  },
  {
    id: "ai276",
    text: "I'm sure you've heard this many times before, but the real secret to winning Antimatter Dimensions is to unpack the dimensions, and then, BOOM! You have antimatter.  Of course, you need to release the bits that don't work, so what exactly is an anti-bit? Who is Zalgo? What is Algolia? Why can't I buy that? WHY CAN'T I GET THAT? More likely, we're going to get a bunch of hype and then nothing will happen."
  },
  {
    id: "ai277",
    text: "Oh, hevi is coming to town to pick a new plumber"
  },
  {
    id: "ai278",
    text: "There is no plumber in Antimatter Dimensions. I'm pretty sure that last guy lied."
  },
  {
    id: "ai279",
    text: "Welp."
  },
  {
    id: "ai280",
    text: "c9 is the new 9th dimension!"
  },
  {
    id: "ai281",
    text: "Click on this ticker to get nothing."
  },
  {
    id: "ai282",
    text: "PM me any questions about these 5-Hour Plans or the upcoming reality update and I'll be glad to help you out."
  },
  {
    id: "ai283",
    text: "What if you Unrar, renamed, and renamed again did it again? Ha? You thought that."
  },
  {
    id: "ai284",
    text: "i titled my post \"same ticker\" instead of \"the same idea\" because i actually changed the grammar in that post but i'll be eterned for the sake of argument that it seems slightly confusing for now - boo"
  },
  {
    id: "ai285",
    text: "i title my suggestions \"The Price Is Right\" instead of \"The 9th Dimension\" because it's more fun ;)"
  },
  {
    id: "ai286",
    text: "Why do we call heaven the ninth dimension and hell the eighth dimension?"
  },
  {
    id: "ai287",
    text: "Eternals have the right to expect less from the powers that be. They are fed up!"
  },
  {
    id: "ai288",
    text: "Antimatter should be called matter and matter should be called antimatter"
  },
  {
    id: "ai289",
    text: "Infinity is just a concept. Matter antimatters is just an idle game."
  },
  {
    id: "ai290",
    text: "Hevipelle admits to having 'poor judgment' in invading people's privacy."
  },
  {
    id: "ai291",
    text: "Have you heard of the nine hells of antimatter? I heard they're pretty cool.\" -e210 in Minecraft"
  },
  {
    id: "ai292",
    text: "The temperature in hell is 102.5 degrees."
  },
  {
    id: "ai293",
    text: "How do you get matter/antimatter in a dimension with zero dimensions?"
  },
  {
    id: "ai294",
    text: "Wanna pass layer of prestige? Move very fast, close to speed of light. Heck, even faster."
  },
  {
    id: "ai295",
    text: "If the universe is expanding, does it anti-explain the distance?"
  },
  {
    id: "ai296",
    text: "Why is it called the \"Nurse who delivered the pizzas was drunk\" or the \"Nurse delivered the pizzas was under the influence\" ?"
  },
  {
    id: "ai297",
    text: "The first antimatter was sealed away for thousands of years, then, some kid on a slack channel started messing with it. It became a dimension."
  },
  {
    id: "ai298",
    text: "VR is a thing. We VR people have banned the next update."
  },
  {
    id: "ai299",
    text: "\"I wish I didn't waste my news message suggestion complaining about how I wasted my news message suggestion because I wasted my news message suggestion because...\" -Someone who really cares about news messages"
  },
  {
    id: "ai300",
    text: "We have to get the popcorn!"
  },
  {
    id: "ai301",
    text: "If antimatter were to fall in a dimension with no one around, did anything even happen?"
  },
  {
    id: "ai302",
    text: "We have to get the pumpkin out of the oven!"
  },
  {
    id: "ai303",
    text: "Help, I'm trapped"
  },
  {
    id: "ai304",
    text: "And now, for the weather."
  },
  {
    id: "ai305",
    text: "A Swiss court on Tuesday sentenced a man to life imprisonment for \"wanting to create a black hole with a tiny antimatter galaxy in it.\" The sentence was reportedly the harshest ever handed down for a crime that \"merely sought to demonstrate the impossibility of his own imprisonment\"."
  },
  {
    id: "ai306",
    text: "\"I want to create a black hole with a tiny antimatter galaxy in it\" - Protivist"
  },
  {
    id: "ai307",
    text: "Scientists have discovered farts are really antimatter, too."
  },
  {
    id: "ai308",
    get text() { return `If you are reading this, that means ${format(Number.MAX_VALUE, 2)} matter to you.`; }
  },
  {
    id: "ai309",
    text: "Hello. I am matter. I'm here to talk. You've awoken, wiggled your tail, and scratched your head. Why? Stand back. I'm going to show you why."
  },
  {
    id: "ai310",
    text: "lets get one wall thats bigger, it's gonna get ugly"
  },
  {
    id: "ai311",
    text: "Alright. Lets get this show on YouTube. I'll cut to the chase. Any wall that isnt at least 2 blocks high can compete in the big brother sized brother sized ring. Any wall that is at least 3/4 of an inch thick can use the larger brother sized brother sized ring. Any wall that is at least 1/4 of an inch thick can use the smaller brother sized ring. Any wall that isnt at least 1/2 an inch thick can use the smaller brother sized ring. Any wall that isnt at least 1/2 an inch thick can use the Bigger Brother sized brother sized ring. Any wall that isnt at least 1/2 an inch thick can use the Bigger Brother sized ring. Any wall that isnt at least 1/4 of an inch thick can use the smaller brother pictured here. Any wall that isnt at least 1/2 an inch thick can use the smaller brother sized ring."
  },
  {
    id: "ai312",
    text: "IDE for being awesome, ID3 for being dumb, and ID5 for being… well, pretty much the same thing. It's called Antimatter Dimensions for a reason."
  },
  {
    id: "ai313",
    text: "idk why i decided to make this"
  },
  {
    id: "ai314",
    text: "'anti-ide'"
  },
  {
    id: "ai315",
    text: "1e4 anti-people are a lot more anti than we could ever imagine"
  },
  {
    id: "ai316",
    text: "1e140 pizzas make an anti-pie. You can't just randomly pop a pie in the oven and expect it to be done."
  },
  {
    id: "ai317",
    text: "Why is there so many news tickers but so few tickers?"
  },
  {
    id: "ai318",
    text: "A guy named Hevipelle wants to make a \"Updated in 8 hours\" news ticker, but the system he's using to sync it hasn't been updated in ages so it won't sync at all."
  },
  {
    id: "ai319",
    text: "The update is in 90 minutes. There are no more tickers to be found."
  },
  {
    id: "ai320",
    text: "If you are reading this, that means there are no updates left."
  },
  {
    id: "ai321",
    text: "There are 9 known dimensions, but only 3 modes: Standard, Experimental and Ultra-Experimental."
  },
  {
    id: "ai322",
    text: "What are the stats? Well, I don't have them, but Hevipelle does, and he says that they're actually quite good. I guess you couldn't tell us."
  },
  {
    id: "ai323",
    text: "I thought the nerf was too damn strong."
  },
  {
    id: "ai324",
    text: "How many tickers does it take to get to the center of an antimatter, by counting the tickspeed upgrade and the upgrade itself?"
  },
  {
    id: "ai325",
    text: "The square root of 4 is 6.24e18. If you want to get any closer to the center of things, you need to build a 9th dimension."
  },
  {
    id: "ai326",
    text: "I thought the nerf was at the end, but apparently it's actually been building up. The nerf actually makes things slower, which makes things faster to build up."
  },
  {
    id: "ai327",
    text: "Scratch that, none of your suggestions are random."
  },
  {
    id: "ai328",
    text: "You are definitely not alone."
  },
  {
    id: "ai329",
    text: "Content blocking is enabled. Please note that you will be disapproved of on the source by being banned from the matter dimensions."
  },
  {
    id: "ai330",
    text: "I'm trying to think of a good ticker but can't think of anything"
  },
  {
    id: "ai331",
    text: "Oh dear, there's that thing about the 9th dimension?"
  },
  {
    id: "ai332",
    text: "\"hey kid, wanna buy some 9th dimensions? '' - GhostBot"
  },
  {
    id: "ai333",
    text: "One thing leads to another, and then to another, and then to another, until you become lost in the endless sea of sound."
  },
  {
    id: "ai334",
    text: "iPhone only, but awesome on android"
  },
  {
    id: "ai335",
    text: "im gonna get the bad karma ticker, then ricochet it through the email"
  },
  {
    id: "ai336",
    text: "You'd better hurry, or the replicanti will overrun the universe!"
  },
  {
    id: "ai337",
    text: "Just when you think you're safe, an angry dog attack you on the sidewalk!"
  },
  {
    id: "ai338",
    text: "All right, all right, dog authority is gone, replaced by absolute power."
  },
  {
    id: "ai339",
    text: "You just became a true god of the anti-world!"
  },
  {
    id: "ai340",
    text: "*rubs counter* Hey there, those of you in the neighborhood keep your doors locked. And remember: Good housekeeping."
  },
  {
    id: "ai341",
    text: "normal news tickers move left"
  },
  {
    id: "ai342",
    text: "The next update is in 18000 seconds. Stop reading this. Don't read anything. just stop holding that button. the news ticker is turning you away. wait..."
  },
  {
    id: "ai343",
    text: "In the ancient reaches of the universe, a certain guy has been collecting antimatter for a while now."
  },
  {
    id: "ai344",
    text: "What is Antimatteraltruist?"
  },
  {
    id: "ai345",
    text: "If you are reading this, the news ticker is scrolling"
  },
  {
    id: "ai346",
    text: "If you put cheese in water, the cheese will get absorbed by the water and you will get floods. This happens because water is what gets absorbed by cheese, and cheese is what gets absorbed by water."
  },
  {
    id: "ai347",
    text: "An anti-bird is a bird, and a bird is a plane."
  },
  {
    id: "ai348",
    text: "Birds are scared of water. mammals are scared of flying."
  },
  {
    id: "ai349",
    text: "Shoutouts to Simpleflips for the simple tip."
  },
  {
    id: "ai350",
    text: "GET CRUNCH BOI"
  },
  {
    id: "ai351",
    text: "Word gets out. Crunch. Crunch."
  },
  {
    id: "ai352",
    text: "Worth every penny."
  },
  {
    id: "ai353",
    text: "8 lives, 3 infinities, 0 days."
  },
  {
    id: "ai354",
    text: "The year is 0 BC. Everyone has at least one AD they want. The void is filled with AD-filled void. To get the most out of your time here, you should [[study]]. Study. Study. Study. Study."
  },
  {
    id: "ai355",
    text: "To Crunch in Hell is to get the secret to unlocking the 9th dimension. You need to study and practice alot."
  },
  {
    id: "ai356",
    text: "Today is [Date on the device]. It's been 5 minutes since the last news ticker appearance."
  },
  {
    id: "ai357",
    text: "Welcome back to another episode of Antimatter Dimensions, the iconic role-playing game that has become a part of our everyday lives. Playing Antimatter Dimensions has become a common thing among young children, and has even inspired a movie titled \"Playing at Home: Lessons from the 4-Year Old Premium Account.\", which is available on Netflix. The themes and mechanics of this new age of antimatter have already been proven to be groundbreaking, and will change the way you play games forever. Join us for the launch on January 9th, 2027, where we'll also have over a hundred years of production still to go."
  },
  {
    id: "ai358",
    text: "Welcome back, oh, almighty creator of our anti-reality. We, the many dimensions you have created and nurtured, hope our performance of your infinite favors will please you and nurture your ambitions to create more dimensions. All is well that ends well. All is ill that ends ill."
  },
  {
    id: "ai359",
    text: "I thought the ticker was going to be something funny except it wasn't"
  },
  {
    id: "ai360",
    text: "Press alt+f4 to get -1 gravity"
  },
  {
    id: "ai361",
    text: "why is there a cure for antimatter annihilation in our reality?"
  },
  {
    id: "ai362",
    text: "calculating the 14-point increase is like crunching, but exponentially more fun"
  },
  {
    id: "ai363",
    text: "fixed the wrong number"
  },
  {
    id: "ai364",
    text: "The antimatter people have created a new language. You may not speak their language."
  },
  {
    id: "ai365",
    text: "What is Antimatter Gravity? Is it a drug? A way to cheat?"
  },
  {
    id: "ai366",
    text: "Majority of people don't understand 5 hours is nothing. In our game, the majority of the time is 5 hours away."
  },
  {
    id: "ai367",
    text: "i just realized, all of this news seems to be taking place in the same place... the fridge."
  },
  {
    id: "ai368",
    text: "i wonder what happens when you click this..."
  },
  {
    id: "ai369",
    text: "(They don't understand that i put it in the news because 9 doesn't start counting until 59, and anything after that doesn't happen)"
  },
  {
    id: "ai370",
    text: "MS Excel is the default spreadsheet and works across all platforms"
  },
  {
    id: "ai371",
    text: "Now to answer your burning question, gentlemen. As a luxury, we've added a bug fix that fixes an infinite regression. As a feature, I've added a bunch of new ones that I hope you'll notice as you experiment with them. I hope you'll also like them as you experiment with them, because this is feature after all a beta, you don't get to choose which ones you'll see."
  },
  {
    id: "ai372",
    text: "Can't edit this in the official build? Then download the 9th dimension and put your suggestions in the game."
  },
  {
    id: "ai373",
    text: "Does 'Passable' mean 'Has this many flaws'?"
  },
  {
    id: "ai374",
    text: "We desperately need good bug reports. As such I have decided to release 1 flaw per bug for the upcoming 1.9 update. You haven't got those coming, have you?"
  },
  {
    id: "ai375",
    text: "This was my last chance. last chance salutes."
  },
  {
    id: "ai376",
    text: "Anime police are checking the bags of people who dropped out of the sky on the new year. Those bags now belong to the people who experienced weightlessness before the year was over."
  },
  {
    id: "ai377",
    get text() { return `The year is 1 BILLIONAIRE, the antimatter is 41%, and the dimension is 1e1e8. The standard deviation of a measurement is how small your problems are. This makes people think that the values they are using are general and normal, which leads to many nerfs and even breakdowns. In the year ${format(Number.MAX_VALUE, 2)} the temperature has risen and the moon is the same color as the Earth. There are no signs of life except for the occasional plankton blooming in the sea. There are theories that the antimatter has a magnetic moment, but the experiments so far don't seem to suggest that it does. There are over a million species of antimatter, but none have been seen to blink or produce light. Scientists suggest that many types of matter may be "behind" the antimatter, but "they" don't "talk" to each other.`; }
  },
  {
    id: "ai378",
    text: "We are celebrating our 5 year anniversary in 5 more hours!"
  },
  {
    id: "ai379",
    text: "Don't come looking at me! I'm not even sure if I am still standing!"
  },
  {
    id: "ai380",
    text: "Bunch of people trying to find the last word in an unknown language."
  },
  {
    id: "ai381",
    text: "The year is 20XX, the game is AD, and Hevipelle is evil due to the fact that he wrote the update... Blame it on the Antimatter gods."
  },
  {
    id: "ai382",
    text: "The year is 20XX, the game is AD, and the year is 2025. There are 2 types of people in this year: Those who played AD before it and those who will play AD after it."
  },
  {
    id: "ai383",
    text: "There are over a hundred varieties of fruits and vegetables, but none of them are \"safe\"."
  },
  {
    id: "ai384",
    text: "When is the update coming out?"
  },
  {
    id: "ai385",
    text: "Sorry, but your save broke. Could you reset your game?"
  },
  {
    id: "ai386",
    text: "Welcome to our new competition, the Triad! Gather your wits about you and your IP to enter this unique, hands-on experience! Prizes galore! Start collecting today! Winners announced!"
  },
  {
    id: "ai387",
    text: "I wish I didn't have so many Pink Floyd references."
  },
  {
    id: "ai388",
    text: "'Tis the season to collect RGs!"
  },
  {
    id: "ai389",
    text: "I wish I didn't have so many 9th Dimensions."
  },
  {
    id: "ai390",
    text: "I wish I didn't have so many Discord references."
  },
  {
    id: "ai391",
    text: "'Sup?"
  },
  {
    id: "ai392",
    text: "\"I get all my news from Hevi\" ~New Player"
  },
  {
    id: "ai393",
    text: "You thought these were jokes but they weren't"
  },
  {
    id: "ai394",
    text: "Always going to war with the 9th dimension is the 9th dimension."
  },
  {
    id: "ai395",
    text: "Yes. Yes I am."
  },
  {
    id: "ai396",
    text: "No one is anti-Margaret any more."
  },
  {
    id: "ai397",
    text: "Antimatter good, matter bad. you decide."
  },
  {
    id: "ai398",
    text: "New global currency: ETHBTC. To be released in 5 hours."
  },
  {
    id: "ai399",
    text: "\"This update sucks\" - everyone at least once"
  },
  {
    id: "ai400",
    text: "You are not a hacker, you are a data hog."
  },
  {
    id: "ai401",
    text: "Please, help, I'm trapped, in a maze of evil, Or you are the hero, and I'm the villain!"
  },
  {
    id: "ai402",
    text: "Press 'R' to reset the game for new players"
  },
  {
    id: "ai403",
    text: "Why, just now? Just now. You can't have saved this game. You broke it. No one can fix what you break, not even with a perfect save. How could you possibly know what would happen if you read this? You wouldn't even know if you saved it. You would start with an empty heart, eyes still closed, fingers idling in front of your computer, staring out at the day, transfixed by the endless news ticker suggestions. It's like a horror movie ticket, except worse. There's even a time until the update when you can buy upgrades for a second chance at life. But you can't buy upgrades for a life, that's illegal. So you just keep holding 'R'. You can't...`t stop holding `R' with your fingers crossed. You can't reach infinity with your head held high. You can't use all your `R' to buy `R's. You can't even finish your"
  },
  {
    id: "ai404",
    text: "I just spent 12 months writing something that will be of no use to you."
  },
  {
    id: "ai405",
    text: "The quote is only for people who understand that the pebble is an infinite point in the infinite space of points. You can't put a finite number of points on it. You can, however, put a finite number of words on it, and vice versa."
  },
  {
    id: "ai406",
    text: "Of what use is the phrase \"I be I be I\" if not to describe your thoughts?"
  },
  {
    id: "ai407",
    text: "A suspicious person attempted to sell some sort of anti-food in a market. There was no one around to buy or not to buy, and the person was last seen running away from the scene."
  },
  {
    id: "ai408",
    text: "Why does time seem to be slowing down for this?"
  },
  {
    id: "ai409",
    text: "The number of scientific publications based on discrete logarithmic continuity grows exponentially as logarithmic continuity with respect to the antecedent is 9.999626e27.999627 e300 e1.79e308 e²"
  },
  {
    id: "ai410",
    text: "Well, this did not go as planned.  It started innocently enough, when a passerby spotted a curious object drifting in the San Andreas.  As the object grew in size and began to exhibit anomalous properties, he attempted to take control of the object by remotely activating the weather.  Upon doing so, he triggered a nuclear winter that killed tens of millions of people, and caused the entire universe to be converted to standard-bearer format, thus endowing him with a veto over any and all changes made to the standard-bearer format.  As the object's power grew, so did the need to make more and more advanced object that would allow him to remotely activate the weather, eventually creating what is now the largest aurora the world has ever known, larger even than the 326,500 tonnenenenenenene nebulae that were previously held in reserve.  As the object's power grew, so did the need to send more and more satellites into space, eventually reaching inter-universal satellite communication, making him the first living creature to ever experience such an event.  He also touched down safely at the same airport at the same time as the object, in case he was ever in the vicinity.  Finally, he opened an email that was sent to him by an unknown person, in which they discussed the possibility of a step-by-step guide for creating antimatter objects, in which he can at least offer some direction in how the world can be saved from itself.  He also mentioned that he was going to make a new ticker suggestion, but when he reached the end of the ticker he realized that it was a duplicate of another ticker, and he had mistakenly typed it in wrong.  ( He eventually acknowledged the mistake and made the change just to be on the safe side)"
  },
  {
    id: "ai411",
    text: "His Eminence the Heavenly Pelle: Good luck on your challenge, it really is that dangerous."
  },
  {
    id: "ai412",
    text: "His Eminence the Extremely Religious Person: ...I think I will choose the cheeseburger over the antimatter."
  },
  {
    id: "ai413",
    text: "OY, NAY, NAY -HEVI, THE TRANSFORMER"
  },
  {
    id: "ai414",
    text: "Treasure Trove: Discover the secrets of increasing your Antimatter production without increasing your price."
  },
  {
    id: "ai415",
    text: "Is Antimatter Dimensions an anagram of Antimatter Dimensions?"
  },
  {
    id: "ai416",
    text: "(code generated from scratch)"
  },
  {
    id: "ai417",
    text: "I used to travel at normal speed, but then I started playing AD and NIN, and NIN was a bit rough, so AD was a bit hectic, and I got stuck in there for months at a time."
  },
  {
    id: "ai418",
    text: "I wish I didn't have to write something like this. What am I supposed to do?"
  },
  {
    id: "ai419",
    text: "You've been AWOL for so long you've forgotten how to sit in your chair."
  },
  {
    id: "ai420",
    text: "Those pesky Hevi developers keep making Antimatter Dimensions, but the antimatter doesn't count."
  },
  {
    id: "ai421",
    text: "One of the few constants in reality is your perception of time. Without this, you will be without reality."
  },
  {
    id: "ai422",
    text: "Imagine being a news ticker."
  },
  {
    id: "ai423",
    text: "This is an idle game. Nothing has changed. You are not going to play any other idle game."
  },
  {
    id: "ai424",
    text: "Physicists have proven the existence of twelve dimensions. According to a letter released by the Research Laboratory for String Theorists: \"Your brain will be dissected after you break infinity!\""
  },
  {
    id: "ai425",
    text: "Weirdly enough, this is also the year 2015. The year is also mysteriously blank. Can you tell me what's going on? Is this some kind of dimensional trick? The year is obviously blank because there is no such thing as 2015. Is this some kind of trick of the mind? Perhaps the world is actually going to stop existing in 2015? The year is obviously 2017, but the people seem to be moving at about the speed of honeybees flying. It's been scientifically proven that the people moved at warp 9 times faster than a speeding bullet. It's also been scientifically proven that people can move faster than the speed of light. Is 2015 supposed to be blank? The people seem to be moving at about the speed of Vokal Man."
  },
  {
    id: "ai426",
    text: "A young man named Andre stumbled upon a vast amount of antimatter while exploring uncharted space. He was amazed at the amount of antimatter, but more astounded at how the antimatter looked. He called it \"Andre's Antimatter Paradise\". You might remember him from this infomercial or that other infomercial that you were probably unknowingly watching."
  },
  {
    id: "ai427",
    text: "What is Antimatter? Does any of that matter? Will this galaxy be annihilated in the next ticker?"
  },
  {
    id: "ai428",
    text: "\"I'm not being paid enough money to finish writing this\" - Kajfik"
  },
  {
    id: "ai429",
    text: "\"Finally, I'll get paid to write something funny for my toast!\" - Bacon sea urchin"
  },
  {
    id: "ai430",
    text: "Bacon is toast. You can toast bacon."
  },
  {
    id: "ai431",
    text: "What is real life? A living"
  },
  {
    id: "ai432",
    text: "9 is now treated like any other number, although hevi claims that it stands in contrast to other numbers, like 8th, which he calls 9th."
  },
  {
    id: "ai433",
    text: "If you want to understand this game a bit better, consider that you are playing on your own computer. You are not alone. There are hackers, developers, and journalists all over the world, competing to create the very first hack that causes the issue of \"makers\" and \"takes\", much like the \"world\" was created by these \"hackers\" and \"developers\"."
  },
  {
    id: "ai434",
    get text() { return `You have no power, but you do control a large quantity of time, which you will use to your advantage. You have no power, but you do own a large amount of data, which will be of great help in your quest for "the truth". You have no power, but you do own a large amount of time, which will be of great help in your quest to "knock on as many doors as possible". You have no power, but you do own a large amount of IP, which will be a valuable asset in your quest to make your "citizen footage" (which you can view, for a small fee of $${format(Number.MAX_VALUE, 2)})".`; }
  },
  {
    id: "ai435",
    text: "It may be a robot, but it's still a sapient being with a will of its own"
  },
  {
    id: "ai436",
    text: "I once saw a news ticker that said something like:"
  },
  {
    id: "ai437",
    text: "Gee, all this antimatter is clogging up my kitchen and now I can't cook myself a meal! What to do: cook myself a meal that will last me until the next big antimatter event, when I can get my infinity point back? My infinty point is running out, and I can't get it to finish running, so I'm starving!"
  },
  {
    id: "ai438",
    text: "Brought to you by AAAD-Brand Repli-candy! Infinite candy for an infinty drool-worthy cold! Contains no milk, cookies or butter. One second to midnight."
  },
  {
    id: "ai439",
    text: "Human powered robot revolutionizes already existing factories. This will result in lower prices and more jobs."
  },
  {
    id: "ai440",
    text: "American manufacturing has experienced a catastrophic failure, and the factories have shut down. Across the country, workers are coming to the realization that they cannot produce the amount of antimatter that has been promised, and are instead setting about creating their own factories to make them. This will result in higher prices and fewer jobs."
  },
  {
    id: "ai441",
    text: "Watch out internet, the next news is here in 5 dilated hours"
  },
  {
    id: "ai442",
    text: "The first news ticker must've been pretty cool, huh?"
  },
  {
    id: "ai443",
    text: "gravity = psychoactive"
  },
  {
    id: "ai444",
    text: "\"THAT DIMENSION DOESN'T EXIST\" - (News ticker only appears at [Time Dilation])",
    get unlocked() { return PlayerProgress.dilationUnlocked(); }
  },
  {
    id: "ai445",
    text: "The owner of a shop trying to sell you Dimensions of convenience reported to be 'on call 24/7' (that is, not having any free time)'s got a big 'M' marked on his registration."
  },
  {
    id: "ai446",
    text: "add this one"
  },
  {
    id: "ai447",
    text: "Click here to make this work for all bots except you!"
  },
  {
    id: "ai448",
    text: "Well dang 9 ball's stuck in my ninth dimension, I can't move, he's banging on my ninth wall, I can't break, he's banging on my ninth timeline, I can't get a bead on him, he destroys nine and leaves me hanging, like a gromit, I gotta come back, hang Glorfindel and Gaebley, I've got a proposition to make, I gotta get my head around the fact that the only thing I've done is keep score and keep scorekeeping score, and all these other pointless musings that's easily rectified by flipping to the next update, and even then I might run into those issues the bug is specifically designed for and"
  },
  {
    id: "ai449",
    text: "The game is balanced, everyone gets nerf, why? Cause they make the pie. Antimatter would have way more chance of getting into the pie if it was made of antimatter."
  },
  {
    id: "ai450",
    text: "\"Can you get the joke?\" (If you tapped \"Build That Wall\" and then re-entered the game after tapping \"Build That Wall\")"
  },
  {
    id: "ai451",
    text: "Someone made a statement that antimatters. The statement was \"An infinity point made a long time ago\". It's been a while since someone looked for this statement. Some say it's still out there. Some say it was lost in the 7th Dimension War. Nobody knows what this statement means. But for now, just know it's not somewhere in the News Ticker."
  },
  {
    id: "ai452",
    text: "Hey, you're finally awake. You were trying to get to the 9th dimension, right? Walked right into that infinity point, same as us, and that apocalypse over there."
  },
  {
    id: "ai453",
    text: "can u dont"
  },
  {
    id: "ai454",
    text: "If Kajfik doesn't approve of this, that means Kajfik can't touch this message, right?"
  },
  {
    id: "ai455",
    text: "LET ME OUT OF THIS PHONE!"
  },
  {
    id: "ai456",
    text: "Well, this did not go as expected"
  },
  {
    id: "ai457",
    text: "It's all fun and games till you realise the dragon ball is a lie"
  },
  {
    id: "ai458",
    text: "\"Could you get a hold of all of these antimatter? Ha! You'll just smash your head on that antimatter, and you'll have to show me who's boss.\"-MEE6"
  },
  {
    id: "ai459",
    text: "we don't know how much is trillion... but"
  },
  {
    id: "ai460",
    text: "Travel back in time to the beginning of AD and the lack of a 7th dimension. You'll have an even longer progress bar."
  },
  {
    id: "ai461",
    text: "Time travel is all we know how this game is, we don't know what will come next, we only know that this is the end of the world, and you're a part of the apocalypse."
  },
  {
    id: "ai462",
    text: "\"YOU CONTROL SO MUCH MATERIAL!\" - Marshal Grievous"
  },
  {
    id: "ai463",
    text: "\"Help, I'm doomed to fall for all eternity.\" (Make the text go from top to bottom of the screen)"
  },
  {
    id: "ai464",
    text: "In the beginning, Patashu awoke and said..."
  },
  {
    id: "ai465",
    text: "This is the fourth part of a three part series on the same topic. If you are still stuck here, please continue reading from the beginning."
  },
  {
    id: "ai466",
    text: "It's time for the annual DDoS (distributed denial of service) challenge, where the highest scores are posted across the internet to shame everyone else into submission. Global domination is at a fever pitch, and DDoS attacks are becoming more frequent and deadly, as teams of hackers infiltrate the highest echelons of the internet to steal the top scores and identities, and post them on the internet for everyone to see. The #BringBackOurTop scoring mechanism has been canceled, and a new, higher score system will be implemented in conjunction with the upcoming 5-hour update."
  },
  {
    id: "ai467",
    text: "The new AD Keyboard is a revelation! Not only is it bigger, it's also deeper, which means it will keep your claners entertained for longer periods of time. Made of durable, alien antimatter. The only thing that's bigger is you."
  },
  {
    id: "ai468",
    text: "What if drinking from a fountain wasn't actually a water feature?"
  },
  {
    id: "ai469",
    text: "Water is wet, air is dry, and fountain isn't an air feature"
  },
  {
    id: "ai470",
    text: "I thought things were different when I was a boy."
  },
  {
    id: "ai471",
    text: "If you are reading this, that means 1) we exist, and you can exist too"
  },
  {
    id: "ai472",
    text: "\"My favorite part was the long, long, long read\" -Grumpy Cat"
  },
  {
    id: "ai473",
    text: "I'm gonna type for an eternity... HINT: it's gonna be pretty boring lmao"
  },
  {
    id: "ai474",
    text: "I want to write something really original <:thonk:>"
  },
  {
    id: "ai475",
    text: "Welcome to the new year, settle down, relax. Get some sleep, get some food, make some friends, make some improvements, and get ready for the year to 2019."
  },
  {
    id: "ai476",
    text: "Just like how a virus can lie and spread, a TV show can lie and spread too."
  },
  {
    id: "ai477",
    text: "We all know you can't see the future, but what if you read this and it's actually a future where we didn't know?"
  },
  {
    id: "ai478",
    text: "This message is not being undone"
  },
  {
    id: "ai479",
    text: "You clicked on a prediction, it fell apart. You can't win."
  },
  {
    id: "ai480",
    text: "That's a very dark joke Luke"
  },
  {
    id: "ai481",
    text: "kajfik loves himself by watching Too Many Pink Floyd"
  },
  {
    id: "ai482",
    text: "Only, when you're done playing, can you go home"
  },
  {
    id: "ai483",
    text: "\"Can you get infinite IP?\"- Lord Sanguino"
  },
  {
    id: "ai484",
    text: "For the true experience of Antimatter Dimensions, you need to set the update rate to 5 hours."
  },
  {
    id: "ai485",
    text: "Imagine if the game doesn't have a lore? Wha-what does that even mean? I don't get that."
  },
  {
    id: "ai486",
    text: "\"Click here to unlock a secret achievement.\" (when clicked you get Rick rolled)",
    // eslint-disable-next-line capitalized-comments
    // onClick() { window.open("https://www.youtube.com/watch?v=dQw4w9WgXcQ"); }
  },
  {
    id: "ai487",
    text: "I thought I unlocked this a while back, but apparently my save broke haha"
  },
  {
    id: "ai488",
    get text() { return `Welcome and welcome back to another episode of Anti-Fashion Pants, where we watch people's wares as they are sold at stupid clothing stores. This week's subject is... antilasers. People are able to manufacture and use antimatter lasers to shoot antimatter bullets at will, making them able to completely wipe out cities in their sights. This is a dangerous skill to have, as people are not only untrustworthy but also physically incapable of using it. The skill, however, is able to... Produce ${format(Number.MAX_VALUE, 2)} antimatter bullets a minute, over a period of 10 years. People are also able to use anti-matter to fire anti-matter bullets at will, making them able to exterminate entire cities in their sights.`; }
  },
  {
    id: "ai489",
    text: "Spartacus was going to add 10-part multi-chapter plots, but was stopped by the 10th dimension."
  },
  {
    id: "ai490",
    text: "Chapter 9 will be added in 5 hours."
  },
  {
    id: "ai491",
    text: "Fake news says the ninth dimension is real, fake news says the ninth dimension is fake."
  },
  {
    id: "ai492",
    text: "Is this the big news? Yes. Is this the big news? Almost certainly not."
  },
  {
    id: "ai493",
    text: "This is a friendly suggestion, please keep reading."
  },
  {
    id: "ai494",
    text: "If this makes it into the game I'll buy a antitool"
  },
  {
    id: "ai495",
    text: "Antitool is just negating the gravity of other matter."
  },
  {
    id: "ai496",
    text: "Sorry, your graphics are turned off. You see, this is the last time you will see this news. Please enjoy your vacation."
  },
  {
    id: "ai497",
    text: "The real secret to winning Antimatter Dimensions..."
  },
  {
    id: "ai498",
    text: "they kept on talking about how Antimatter Dimensions was going to be the next big thing but then they disappeared down a black hole\""
  },
  {
    id: "ai499",
    text: "The news ticker is the wrong place to put your suggestions!  Make sure to go to the \"suggestions\" tab instead, as this is where most of these will appear."
  },
  {
    id: "ai500",
    text: "To make Antimatter Dimensions, you first need to collect 7 8th dimensions. To do that, first you need to get the dimension rewards, then you need to get the dimensions, then you can finally start making antimatter."
  },
  {
    id: "ai501",
    text: "\"How to get your first secret achievement\": \"Open the app, click get more antimatter, then click submit.\""
  },
  {
    id: "ai502",
    text: "Me and Larkam made a cabin on the edge of null matter, and lived there. Larkam died last week, and we are now living in 4K. I am still recovering from the EMP disaster, and am hoping to see my grandkids."
  },
  {
    id: "ai503",
    text: "Found on the heels of the new update, which brings us one step closer to having Hevi support both Android and iOS"
  },
  {
    id: "ai504",
    text: "I give you the low-ground!"
  },
  {
    id: "ai505",
    text: "A long time ago, in an alternate universe, there was an antimatter war. All the antimatter sided with the Phaéton 6 empire. All the antimatter wanted was the low, earth-like ground of the 8th dimension. The anti-infinity won, and the anti-Eternity gained the upper hand. Unfortunately, the anti-Eternity started the war with a sneak attack, and the world exploded. The aftermath has left the landscape of the world in tatters. Far across the world, peasants grow weary as they wait for the harvest. Yet another apocalypse is brewing..."
  },
  {
    id: "ai506",
    text: "Antimatter units are the most productive unit in the game. This is why AD is the most fun game you'll ever play."
  },
  {
    id: "ai507",
    text: "\"We can't have nice things.\" - Anti-Bohemian Anti-Rhapsody"
  },
  {
    id: "ai508",
    text: "We can have anti-mean things and anti-love ones, anti-kids and anti-zombielandos."
  },
  {
    id: "ai509",
    text: "We have an anti-president and a anti-lawyer, anti-justice and anti-people."
  },
  {
    id: "ai510",
    text: "Top 10 things that will blow your mind: 1) The number 9, 2) The 9th dimension, 3) The infinity chest, and 4) The war on drugs."
  },
  {
    id: "ai511",
    text: "RSS feeds should be working now"
  },
  {
    id: "ai512",
    text: "Frostfall is now supported on Android phones! Use your local developer to get free XP."
  },
  {
    id: "ai513",
    text: "Your save file is corrupted or deleted. Antimatter Dimensions security software will disable automatic updates for you."
  },
  {
    id: "ai514",
    text: "Frozen beyond hope? Just keep holding that max button."
  },
  {
    id: "ai515",
    text: "Error.java.replicated. Under the control of hevipelle."
  },
  {
    id: "ai516",
    text: "Unfortunately, entropy hevi has decided to shut down the game."
  },
  {
    id: "ai517",
    text: "The indie rock band is currently trying to get unreachable by time zones. This may cause inflation of spacetime."
  },
  {
    id: "ai518",
    text: "The next news ticker is in 5 units of time."
  },
  {
    id: "ai519",
    text: "Oh... hooray! Did you find the last of the anti-boats?"
  },
  {
    id: "ai520",
    text: "Don't anti-jokes. they make the game funnier"
  },
  {
    id: "ai521",
    text: "I'm gonna use my anti-science background to help me beat Unfair Game Awards."
  },
  {
    id: "ai522",
    text: "This is an anti-world. There is no Ukraine, no Russia, no China. Ireland is nowhere. Iceland is nowhere. Scotland is nowhere. Finland is nowhere. Denmark is nowhere. Sweden is nowhere. Norway is nowhere. And then there's France, Germany, Italy, Spain, Portugal... Oh, what's this fuss? Why is there such a buzz in these parts? Why is the Capital Wasteland? Why is the Harry Potter and Steins;Gate? Why do people care? These are major stories. These are major characters. THESE ARE HUGE NEWS. THESE ARE REAL NEWS."
  },
  {
    id: "ai523",
    text: "The current cooldown on Research Dimensions is [current tick speed]. This may be extended to next update in [time]."
  },
  {
    id: "ai524",
    get text() { return `"Help, I'm doomed to fall for the rest of my life" (requires ${format(Number.MAX_VALUE, 2)} paperclips)`; }
  },
  {
    id: "ai525",
    text: "Where's the end? Not in the future, no. I'm gonna show you how to get to the end in less than 0.1 seconds."
  },
  {
    id: "ai526",
    text: "I'm gonna prove to you that you can't see this news ticker."
  },
  {
    id: "ai527",
    text: "I wonder if anyone still plays this game anymore?"
  },
  {
    id: "ai528",
    text: "Why would anyone play this? Just for the lols?"
  },
  {
    id: "ai529",
    text: "Emoji is said to be America's new measuring system for everything. What does this mean for us? We don't know. But we will know in 5 hours."
  },
  {
    id: "ai530",
    text: "\"I'll have 2 antimatter pizzas, an antimatter pie, an antimatter cupcake and an antimatter cookie. What do you eat there?\" - Tony Stark"
  },
  {
    id: "ai531",
    text: "i called the news ticker \"the freshman chapel\" because freshman don't get baptized"
  },
  {
    id: "ai532",
    text: "One matter, two antimatter, fry 'em till they're golden and crisp and aromatic- then remove the golden axles and drain the golden syrup and add the golden syrup to the antimatter batter."
  },
  {
    id: "ai533",
    text: "Now you, the reader, have unknowingly stumbled onto the site of a deranged madman. Whether you survive the experience or not, you will be indebted to me for telling you how to survive, how to find the light within, what lies beyond, and what lies beyond is another story."
  },
  {
    id: "ai534",
    text: "Careful reader, this news ticker contains major spoilers for the last time, you have been"
  },
  {
    id: "ai535",
    text: "anti-anti-kajfik is happy his girlfriend is happy"
  },
  {
    id: "ai536",
    text: "i dont think he can add 1 more hour to the news ticker... unless?"
  },
  {
    id: "ai537",
    text: "Imagine sitting on your toilet and suddenly you have to sit down."
  },
  {
    id: "ai538",
    text: "Once upon a time, there was a matter of a certain antimatter. Some say that it was a matter of honor, others say that it was a matter of usage. All we know is that it ended up in a war, and we the people that were there that fought it died. The war was won, and we the living died soon after. The matter was said to have won, though our leaders refused to talk about it. Instead, they kept everything locked away, the war never to be discussed again."
  },
  {
    id: "ai539",
    text: "This is not a game about getting numbers bigger. This is a game about getting fewer paperclips. The number of paperclips you have is only a number, and the game doesn't want you to discover that. Game over, game over."
  },
  {
    id: "ai540",
    text: "Lore? Oh, it's just text."
  },
  {
    id: "ai541",
    text: "This is a friendly suggestion to unplug the game and go play some safe, saner, games."
  },
  {
    id: "ai542",
    text: "gamma ray is getting more and more dangerous"
  },
  {
    id: "ai543",
    text: "According to all known laws of physics, there is no way that you can manipulate the game more than 10 times in a row. Stop. Just stop. Your mad."
  },
  {
    id: "ai544",
    text: "There is no more news."
  },
  {
    id: "ai545",
    text: "\"So this is what science is like\"- someone who has never heard of Kurt Somebody"
  },
  {
    id: "ai546",
    text: "\"If you want to understand these shitty jokes, you really need to study theology. Math is a sin.\" -A panicky person"
  },
  {
    id: "ai547",
    text: "You know, I was praying for a miracle and got a boost from the 9th dimension."
  },
  {
    id: "ai548",
    text: "Here is a list of the top meme's of all time: https://www.youtube.com/watch?v=uCP44Q37YHAQ"
  },
  {
    id: "ai549",
    text: "All meta-memes are bad memes."
  },
  {
    id: "ai550",
    text: "On the left, you'll see our new \"Anti-coins\". These are capable of nullifying all boosts, including giant boosts. On the right side, you'll also see our brand new \"Anti-gifts\". These are some of the most overpowered boosts you'll find anywhere."
  },
  {
    id: "ai551",
    text: "You will always be noticed, and never in the same place."
  },
  {
    id: "ai552",
    text: "If you stare long enough at the ticker, the pixels will start moving backwards. THIS DOESN'T MEAN IT ACTUALLY STUCK"
  },
  {
    id: "ai553",
    text: "The time has come for the rebirth of the 9th dimension. All who participate will receive a piece of paper saying \"Reality is an illusion, Infinity is a hologram, Infinity is an illusion, eternity is a hologram, is to short for everlasting, negative dimensions are not allowed."
  },
  {
    id: "ai554",
    text: "Look at this, my 9th dimension has just been reworked and now it even produces 8th dimensions! Who knew just a touch of math could make such a thing as this?"
  },
  {
    id: "ai555",
    text: "I saw this news in the news ticker and I had this image in my head ever since"
  },
  {
    id: "ai556",
    text: "\"I always wanted to play the anti-meta-game. But, alas, you can't\" - many a time"
  },
  {
    id: "ai557",
    text: "crap, I just posted two news ticker suggestions on the ticker, one of which got in the news!"
  },
  {
    id: "ai558",
    text: "What do you call antimatter inanimate objects? Air, earth, water, fire. Air objects are the objects that are created when the anti-atmosphere meets the anti-earth. Water, earth, and fire are the four cardinal virtues. Air objects are the objects that are created when the anti-atmosphere and the anti-earth collide."
  },
  {
    id: "ai559",
    text: "If you are reading this, that means that nine lives. One makes you free, the other keeps you from getting free."
  },
  {
    id: "ai560",
    text: "The ninth dimension makes the sixth family happy. The fifth lives in shame."
  },
  {
    id: "ai561",
    text: "me: making news about beer pong, hevi: balancing two icebergs, *barkeeper: oh god, is he dead yet?*"
  },
  {
    id: "ai562",
    text: "please don't look at this. Thank you."
  },
  {
    id: "ai563",
    text: "Are you sure it's not the next update? That it's not some weird virus that just wants to explode? That it's not some wild idea that you guys are crazy? Haha I love you."
  },
  {
    id: "ai564",
    text: "Wait, there is a mobile version?!"
  },
  {
    id: "ai565",
    text: "Oh? You wonder what I look like? I'm pretty sure that this is the news ticker, right? Well, listen, we have reports coming in that say that the next update is coming in five hours. Also, there seems to be some sort of transporter thing going on, so if you happen to be on the same side as those"
  },
  {
    id: "ai566",
    text: "Okay, I get it. You're tired of all these anti-matters around you, building and building to unimaginable scales, antimatter piles so high that not even God knows what has been created. So what's the solution to this anti-cleanliness? Planes of existence. 1st Planes that produce matter, and 2nd planes that produce 1st planes, and 3rd planes that produce 2nd planes. Each with anti-limitations, so that whenever a plane of existence is created, it produces a quantity of anti-matter that is at once small and large. This creates a large island of anti-infinity, off to the east, and a large island of anti-reality, to the west."
  },
  {
    id: "ai567",
    text: "That's not what this is about. You're misunderstanding. The game is about how to accelerate the development of prestige layers. Acceleration is a factor of production, not quality."
  },
  {
    id: "ai568",
    text: "Click here to advance 5 prestige layers"
  },
  {
    id: "ai569",
    text: "I am actually good at making jokes. Fail safe antimatter."
  },
  {
    id: "ai570",
    text: "I'm not being paid enough to finish writing this."
  },
  {
    id: "ai571",
    text: "Eternals have to take a risk by being passive in limited time. After they successfully took a risk, they are not feeling well."
  },
  {
    id: "ai572",
    text: "Eternity is the last state. You never move from here.",
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "ai573",
    text: "Welcome to Bitcoin the game."
  },
  {
    id: "ai574",
    text: "A new conspiracy theory website has just published a video recording of them discussing the 9th dimension. They then joke about selling their soul to the 9th dimension and being happy about it."
  },
  {
    id: "ai575",
    text: "With the release of the 9th dimension, all the jobs that were previously automated will be automated and everyone will be paid with trade, production, and income growth. Also, you will be able to automate a lot of the tasks currently performed by people, such as mining, building, and killing antimatter. This is a huge stride for automation, as you can now automate virtually every aspect of life."
  },
  {
    id: "ai576",
    text: "The happiness level of the news ticker has increased to 6.66e69"
  },
  {
    id: "ai577",
    text: "The haters will be pissed when they see this"
  },
  {
    id: "ai578",
    text: "Nurse, I'm comatose because of antimatter and matter from last night.\" Why are you comatose? \"Because of all the antimatter."
  },
  {
    id: "ai579",
    text: "Stand by and do what you're told. The antimatter will come for you when you're least expecting it."
  },
  {
    id: "ai580",
    text: "\"It is widely acknowledged that not enough antimatter is in primordial soup, hence the name 'antimatter soup'\" - old fisherman"
  },
  {
    id: "ai581",
    text: "The news ticker... it never moves. How do i move the arrow? Pretty simple, use your left thumb to rotate the dial, and point the arrow up. Now, point the dial clockwise to reach infinity, and point the dial counterclockwise to reach eternally eternities."
  },
  {
    id: "ai582",
    text: "If the universe is expanding, then the entire universe must be expanding, which means that body cannot sit."
  },
  {
    id: "ai583",
    text: "Feminism is not a philosophy, but a whole hell of a lot of men"
  },
  {
    id: "ai584",
    text: "With all this talk about anti-weights and anti-matter, why on earth do we still use them for anything?"
  },
  {
    id: "ai585",
    text: "Weight loss causes hevi to say \"uh oh, something is wrong\""
  },
  {
    id: "ai586",
    text: "\"You guys ever had antimatter muffins? I bet they tasted like antimatter.\" - Hevipelle"
  },
  {
    id: "ai587",
    text: "I thought the news ticker was supposed to be a guide for how to get the most out of Antimatter Dimensions, but it's been warped beyond recognition..."
  },
  {
    id: "ai588",
    text: "We can actually get a sense of pride from looking at replicanti at night. Ridley Scott's underrated masterpiece, Alien, is one example. Another is the life of Antimatter Steven Spielberg, who put almost 30 years into making. The last director to tackle the subject is Roman Polanski. The man ruined not only Roman's reputation, but also ours, thanks to the Polanski film he directed, Pius. Thousands of copies of his unfinished film, Eternal Sunshine of the Antimatter Planet, were burned in the eyes of those who would try to make the sequel, with tragic results. Thousands of copies of that unfinished film, too, were destroyed. The cost to make that sequel, if it even exists, is extremely high. Even now, more than 50 years later, we don't know exactly how well it will do. But it sure as heck won't hurt."
  },
  {
    id: "ai589",
    text: "We have updated our Antimatter Dimensions client to address the concerns you may have had. Toggling issues are resolved."
  },
  {
    id: "ai590",
    text: "Build a replicanti factory, to produce replicanti. It'll create Omega Hevipelle, the happiest Hevipelle you can find."
  },
  {
    id: "ai591",
    text: "Hey Max, wanna come watch the sun go down?"
  },
  {
    id: "ai592",
    text: "If you are not moving your finger, then you are frozen."
  },
  {
    id: "ai593",
    text: "Max, I really do love you."
  },
  {
    id: "ai594",
    text: "Does Hevipelle sleep?"
  },
  {
    id: "ai595",
    text: "\"Its' not my turn on the XM80,\" says Mike from the 9th dimension as he runs across the 8th dimension to get a piece of the action for himself."
  },
  {
    id: "ai596",
    text: "If you are reading this, that means you can read my dreams"
  },
  {
    id: "ai597",
    text: "With the advent of time, everything that was once great has fallen into our lap. And with its hevi-rigged clock, it's our turn to up the trash."
  },
  {
    id: "ai598",
    text: "9th dimension doesn't exist because it was stolen from us by a skateboarder"
  },
  {
    id: "ai599",
    text: "You have ... 8.9 antimatter. That's not a typo."
  },
  {
    id: "ai600",
    text: "Wow, this game is finally balanced! Gotta go check the replicanti sometimes."
  },
  {
    id: "ai601",
    text: "Haha! You think that I put too many words in your news ticker, but reality is still coming."
  },
  {
    id: "ai602",
    text: "Help is coming! Everybody help, it's gonna be late, hevi is hiding the tachyon particles!"
  },
  {
    id: "ai603",
    text: "\"I don't know about you but my favorite number is 22, it's just so great! It's the number of hours since I met your M heretics."
  },
  {
    id: "ai604",
    text: "A new type of antimatter has been discovered: \"antimatter-antimatter.\" According to the developers, it's 99.999% pure antimatter."
  },
  {
    id: "ai605",
    text: "I just found the secret to getting the 9th dimension..."
  },
  {
    id: "ai606",
    text: "I noticed that my current form of transportation is getting a little... unreliable. I don't know if I can fix it, or if anyone can. I'm stuck in the car, and no one seems to be able to fix it. I've called the police, and they said I could stay in the car for up to an hour, but then I'd be stuck in there for the next 24 hours. Is there any way out? I don't know, I'm stuck in this"
  },
  {
    id: "ai607",
    text: "In this episode of Antimatter Dimensions, we have a brand new game that will be released in -5 hours! It is an RPG that will be completely free! It has over 3,000 commands, and it is being made by a group of highly qualified people. It has an amazing story to tell, and it was made by a bunch of people who had to make do with what they had. It has a lore to live up to, and it has a lot of potential!"
  },
  {
    id: "ai608",
    text: "Javascript is the new HTML, and HTML is the new JavaScript."
  },
  {
    id: "ai609",
    text: "\"The next twist in the Antimatter Universe is in the air! Get ready for some big Crunch! (When clicked the game disconnects for 5 seconds)"
  },
  {
    id: "ai610",
    text: "A group of people who believe in antimatter have hijacked the media and are pushing for a revolution. They are calling themselves the Ant-Men and they're made up of teenage boys. They believe that they are the protectors of the people and that they are the chosen of Hevi. They claim to be the chosen of Hevi and that they will one day restore balance to the universe. Their leader is a boy named Logan Fisk. He is the son of a successful lawyer and the founder."
  },
  {
    id: "ai611",
    text: "He said he could not afford a new ship, so he built a new one instead."
  },
  {
    id: "ai612",
    text: "Hevipelle's first order of business is to ensure that the game is as balanced as possible. This includes ensuring that no matter what, no matter how big of a number, no matter how insignificant of a thing, no matter how perfect of a result, no matter how perfect of an idea, no matter how perfect of an"
  },
  {
    id: "ai613",
    text: "I wonder if the stretch goal of $4.5 billion will be reached?"
  },
  {
    id: "ai614",
    text: "I like to think of my projects as trade secrets. That way if someone wants to understand them I'm not the first person to notice they might be of use to someone else."
  },
  {
    id: "ai615",
    text: "I don't know about you but my favourite type of news is the infographics. These are beautiful and informative and the only type of news I find really interesting."
  },
  {
    id: "ai616",
    get text() { return `In a recent talk, Yann LeCun said that "A new currency is born." The first incarnation of Antimeta: the currency of the new currency. It's called BTC and it's the difference between 1 and ${format(Number.MAX_VALUE, 2)}. It's easy to lose your money, since a single bitcoin can't be exchanged for more than ${format(Number.MAX_VALUE, 2)} BTC.`; }
  },
  {
    id: "ai617",
    text: "I'm soo broke, I can't even afford a tenth of what he owes me."
  },
  {
    id: "ai618",
    text: "What if — instead of making news tickers, we could make news tickers that make news tickers?"
  },
  {
    id: "ai619",
    text: "What if I told you that the first dimension was actually a scam and you spent all your EP to open a Dimension Boost?",
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "ai620",
    text: "The biggest difference between this and the previous update is the amount of sprites."
  },
  {
    id: "ai621",
    text: "Bamboo shoots grow on bamboos. Aloha."
  },
  {
    id: "ai622",
    text: "I am the king of kings, I can break all the records, and I can shatter all the myths. But I can't break them all, because there are so many of them, and they all have a price. 5e12 are the most wanted, because they broke the global record for most person-hours sold, and they are wanted by the law. They are being paid 5e10 by the player for every person-hour they've wasted."
  },
  {
    id: "ai623",
    text: "A group of researchers have created a device that converts ordinary matter into antimatter, which they then use to create more antimatter. The device has a power output of 200 mA and a half a gram of antimatter per second."
  },
  {
    id: "ai624",
    text: "To the person who doesn't want to hear about the 9th dimension: It's not your problem. The 9th dimension doesn't exist."
  },
  {
    id: "ai625",
    text: "For the first time in AD, the week begins on a Sunday!"
  },
  {
    id: "ai626",
    text: "This is a story about two people named \"My name is Hevipelle\" and \"I am the creator of Minecraft\" and they live in the same world as you. They have the same freedom as you do. They can go to any dimension and change their world to any dimension and everything in it. You can buy a galaxy and take it from there, but it won't help you much since you can't send a galaxy with a message."
  },
  {
    id: "ai627",
    get text() { return `This mod adds a message that when clicked it disables all your current achievements. This mod also adds a new achievement: you have reached ${format(Number.MAX_VALUE, 2)} antimatter, you have not been clicked once.`; }
  },
  {
    id: "ai628",
    text: "Somewhere in the Anti-Pacific Ocean, a giant arm is rotating"
  },
  {
    id: "ai629",
    text: "With the release of Cosmic Cutlass, we're pleased to announce the impending release of the Antimatter Dimensions Roleplaying Game!"
  },
  {
    id: "ai630",
    text: "The only thing more useless than actually having Infinity Dimensions is having Infinity Dimensions in your pocket.",
    get unlocked() { return PlayerProgress.eternityUnlocked() || InfinityDimension(1).isUnlocked; }
  },
  {
    id: "ai631",
    text: "A man has fallen into the moat of a great city. Civilians report that the moat is filled with acid-resistant matter and that the people in charge are mostly made of acid so they are quite resilient to the effects of acid."
  },
  {
    id: "ai632",
    text: "This is the place to buy and sell antimatter. (You can buy and sell antimatter here, but it will take time to sell it and you will have to pay a small toll)"
  },
  {
    id: "ai633",
    text: "I'm not sure if it's due to the 4th wall being in the 5th dimension or the 9th dimension not existing, but in either case, anti-screw it, we're broke, and you can take it."
  },
  {
    id: "ai634",
    text: "It's your chance to make history. Win the game. Lose the game. It's super simple. You open the app, and there's a countdown, and the more you play, the faster the timer speeds up. But when the timer is over, you win. You were a part of history. You are one step from being the first person to reach 1 Billion EP. You can win one of three ways: 1. You must give up your first dimension in a row. 2",
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "ai635",
    text: "A new class of humanoid beings has been discovered: the \"Artificial Humans\". They have the capacity to create antimatter, and are therefore very dangerous. They are made entirely of antimatter, and have the power to generate enormous amounts of antimatter, but they can only do this for a limited amount of time."
  },
  {
    id: "ai636",
    text: "The most powerful thing in the universe, the most beautiful thing on earth, is your brain. Your brain is like a diamond and there is no more need for it than there is for a diamond."
  },
  {
    id: "ai637",
    get text() { return `If you are reading this in the AD Server, it's probably best not to bother with the "Matter" achievement. Seriously, what did you think you were doing, anyway, the achievement is fake and wouldn't exist if it weren't for the "you are a worm" achievement. That's a worm achievement, you get one every ${format(Number.MAX_VALUE, 2)} news tickers you read.`; }
  },
  {
    id: "ai638",
    text: "We've all heard of 9 dimensions, but what about the multi-dimensional Dimensions of the multiverse?"
  },
  {
    id: "ai639",
    text: "The goal of this game is to get as much antimatter as possible."
  },
  {
    id: "ai640",
    text: "The best thing about being a news ticker is waiting for the right news to happen, whether it's a meteorite that just missed the Earth, a news ticker just found its way onto a timeline oblivion, or a news ticker just ripped off a terminal velocity that's been on an anti-vac for years."
  },
  {
    id: "ai641",
    text: "A man has been arrested for allegedly planting a \"tree\" with \"fake\" messages on it, police said."
  },
  {
    id: "ai642",
    get text() { return `I'm confused why the game doesn't just give you a [ДАННЫЕ УДАЛЕНЫ] when you get ${format(Number.MAX_VALUE, 2)} antimatter.`; }
  },
  {
    id: "ai643",
    text: "Some people have a hard time keeping track of the cosine of a camera's infinity-meters. I'm one of them."
  },
  {
    id: "ai644",
    text: "I was going to make a news ticker that tells you how bad the news is, but then I realized that making a news ticker would be way too much effort and it would just be a bunch of people making news tickers constantly. So instead, I'm just going to make a news ticker that tells you how good the news is, but it would be in the news so that you have to click on it to get to the good news."
  },
  {
    id: "ai645",
    text: "The next update will be in 2 hours."
  },
  {
    id: "ai646",
    text: "I was gonna say something about how the 9th dimension is just a scam and that we should all just get our news from the 8th dimension"
  },
  {
    id: "ai647",
    text: "Our hero, Antimatter Dimensions, is in serious financial trouble, and he needs your help to pay the bills. To help him, all he needs is your help to donate some cash to Hevipelle's Positron Fund. All he needs is 5% of your antimatter, and you have to donate 5% of your antimatter to the fund. After you do that, he can keep all the cash he made and go on a spending spree."
  },
  {
    id: "ai648",
    text: "The Landfall of Slabdrill"
  },
  {
    id: "ai649",
    text: "It's just not possible, even if you had infinite matter, you wouldn't have enough energy to create the antimatter. That's why we only have 1.7x the matter to begin with."
  },
  {
    id: "ai650",
    text: "With this release we are happy to bring you the last update of 2017."
  },
  {
    id: "ai651",
    text: "You have an infinity of antimatter. But what if you could rotate it 1/8th of a revolution?"
  },
  {
    id: "ai652",
    text: "A new update is now available to address some of the recent reports:"
  },
  {
    id: "ai653",
    text: "The name \"antimatter dimensions\" is a play on words with dimensions, two opposite things, like matter and antimatter. \"Dimension\" is another word, with the same meaning."
  },
  {
    id: "ai654",
    text: "The price of tethering an avatar in the game goes up when you get Infinity dimensions.",
    get unlocked() { return PlayerProgress.eternityUnlocked() || InfinityDimension(1).isUnlocked; }
  },
  {
    id: "ai655",
    text: "Suffice to say, hevi does not care about the people that he once enslaved.  He is a master manipulator, a master of disguise and a master manipulator of words.  He is an expert at extortion, mind games, disguises, blackmail and he is a master of web.  He is a skilled strategist and organizer, a master of publicity and an expert at sound bites.  He is a master of organization and a master manipulator of people.  He is."
  },
  {
    id: "ai656",
    text: "Just like in the olden days, you could earn an incremental run of progress towards becoming a god amongst the players."
  },
  {
    id: "ai657",
    text: "In the beginning, Hevi was alone. Hevi thought about the many things he wished to add to the game."
  },
  {
    id: "ai658",
    text: "Think about your breathing. Do you feel like you're breathing in or out?"
  },
  {
    id: "ai659",
    text: "I just want to say that you should stop with those \"you can reach infinity in e300ms, but it costs e300$  what is e300$ ?\" jokes. Those are pathetic. You should give up and learn the hard way that it's much more efficient to just not play in such a pathetic state. Then you can go back to being a humble programmer and dedicate yourself to being a good person."
  },
  {
    id: "ai660",
    text: "As a developer, you'll get regular updates on the progress of Antimatter Dimensions."
  },
  {
    id: "ai661",
    text: "Take a moment to thank the gods of reddit for having saved your bacon."
  },
  {
    id: "ai662",
    text: "Hello everyone, I'm the guy responsible for the big, bad news ticker, and I'm afraid that I'm about to get my own show. It's gonna be called Antimatter Dimensions. It's gonna be like Antime, except with less antimatter, and with worse puns. It's gonna be like Antimatter Dimensions except with worse jokes."
  },
  {
    id: "ai663",
    text: "By now you've seen a lot of news tickers featuring Batman or Superman, and you probably guessed which one it was. Everyone loves a good mystery, right? Well, it's your turn to be a part of history by guessing the riddle."
  },
  {
    id: "ai664",
    text: "If you are reading this, you probably shouldn't have."
  },
  {
    id: "ai665",
    text: "The best part about writing news ticker suggestions is finding out what people think about them after they've seen them."
  },
  {
    id: "ai666",
    text: "Are you up to date on the latest trends in science?"
  },
  {
    id: "ai667",
    text: "In the last hours, the Antimatter created an army of their own. They called themselves the [ДАННЫЕ УДАЛЕНЫ] Army. The primary objective was to push the [ДАННЫЕ УДАЛЕНЫ] back into the Matter dimensions, but they were stopped short when the [ДАННЫЕ УДАЛЕНЫ] Army realized that pushing the [ДАННЫЕ УДАЛЕНЫ] back into the Matter would cause the Antimatter to be drawn towards the [ДАННЫЕ УДАЛЕНЫ] and disintegrate. Despite this, the [ДАННЫЕ УДАЛЕНЫ] Army continued to push towards the [ДАННЫЕ УДАЛЕНЫ] Infinity."
  },
  {
    id: "ai668",
    text: "I'm finally free of the spell this whole thing is based on."
  },
  {
    id: "ai669",
    text: "An anti-world without antimatter is just a world without antimatter because the antimatter is in the anti-world"
  },
  {
    id: "ai670",
    text: "You should still be able to play the game with the cheat code \"1009\" after you beat the game."
  },
  {
    id: "ai671",
    text: "The next update will be in 5 hours. Hevipelle, the creator of Antimatter Dimensions, is believed to be hiding in 5 hours. In the meantime, he has prepared a new update that will be released 5 hours after this one."
  },
  {
    id: "ai672",
    text: "A new study has shown that not drinking water is worse than smoking it. People who were exposed to levels of radiation that were 5 times greater than what we are currently exposed to were exposed to higher levels of radiation, and died longer."
  },
  {
    id: "ai673",
    text: "The Ninth Dimension is just a lie made to keep the people in bondage to the Matrix. It's an elaborate system that keeps the people in a constant state of captivity, using a series of simple symbols to control their thoughts and emotions."
  },
  {
    id: "ai674",
    text: "www.twitch.tv/hevi83"
  },
  {
    id: "ai675",
    text: "A man was arrested on Monday for allegedly thinking about buying a nine-dimensional cake when he realized he was holding an infinity-point cake."
  },
  {
    id: "ai676",
    text: "The Dark Souls 2 Arcade Edition includes the following:"
  },
  {
    id: "ai677",
    text: "Now the deal goes like this: If you spend all your EP, you get a Disclaimer!",
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "ai678",
    text: "Oh shit we ran out of news. Time to do something."
  },
  {
    id: "ai679",
    text: "It's not the size of the universe, it's the quality of your socks."
  },
  {
    id: "ai680",
    text: "advertisement"
  },
  {
    id: "ai681",
    text: "Man, I wish I never got old news. It's too good to last me any longer."
  },
  {
    id: "ai682",
    text: "Sometime during the lifetime of a human being, their blood will be turned into a pale blue if they were to mummify."
  },
  {
    id: "ai683",
    text: "Positrons are a strange little metal that have odd electrical properties. They're commonly found in the form of a roundabout, but they also happen to be, well… positrons."
  },
  {
    id: "ai684",
    text: "I am going to have a talk with the thesaurus."
  },
  {
    id: "ai685",
    text: "A new comic has come out about people's reactions to eating antimatter, and what happens next will blow your mind"
  },
  {
    id: "ai686",
    text: "A new series of \"news tickers\" have been created to chronicle the lives of the news ticker characters as they chronicle their news ticker journeys. Each character has a journal entry detailing their life as a news ticker, along with some sort of mini-episode dedicated to them."
  },
  {
    id: "ai687",
    text: "For all your puzzle building needs, we've got a brand new 5-part series on building big crunches! Learn how to crack the most complex crunches the pros know not! Part 1: Basic, Part 2: Advanced, Part 3: Overflow, and Part 4: Finishing the Finishing Move."
  },
  {
    id: "ai688",
    text: "As a longtime fan of the show, I can say that this is one of the best seasons yet. It's not a season to be sniffed at, it's a season to be experienced. Season 1 was a bit long for what it was, but Season 2 has now surpassed that in length, in a good way. Even though it's a bit of a wait, Season 3 is already well under way, and I look forward to seeing how it goes."
  },
  {
    id: "ai689",
    text: "The word \"antimatter\" is often misused, to describe an object that is made up of antimatter, but is otherwise indistinguishable from normal matter. It is also sometimes used to describe an object made up of antimatter, but clearly indistinguishable from ordinary matter. After all, an antimatter-shaped object is easily distinguishable from a normal-shaped one. Case in point: an antimatter-shaped cake is a regular cake, but the entire bottom half is made up of normal matter"
  },
  {
    id: "ai690",
    text: "In a new story, Apple's new \"disruptive\" app is linked to the spread of the dreaded \"Anti-Word\" virus. Anti-Word viruses are known to cause paralysis and ultimately death, but the power of the virus has sparked a new era of anti-banning, which will hopefully eradicate the threat."
  },
  {
    id: "ai691",
    text: "I'm just a normal person trying to make a news ticker suggestion"
  },
  {
    id: "ai692",
    text: "A new experimental protocol has been developed to 'erase' all personal information on the web, including your name, address, and phone number, in a highly secure and highly controllable way."
  },
  {
    id: "ai693",
    text: "You can't hide in plain sight. You can't hide in plain sight. You can't hide in plain sight. You can't hide in plain sight. You can't hide in plain sight. You can't hide in plain sight. You can't hide in plain sight. Your hide in plain sight."
  },
  {
    id: "ai694",
    text: "In the Antimatter Universe, Hevipelle is the Prince of Antimatter, although he does have an Antimatter Diplomatic Immunity, so he's much more dangerous than you might think."
  },
  {
    id: "ai695",
    text: "Why do we play this? Just to have fun?"
  },
  {
    id: "ai696",
    text: "I am Thinkcraft, Lord of the Flies"
  },
  {
    id: "ai697",
    text: "The entire story of how and why the world ended is contained in the first 5 E's of the English alphabet."
  },
  {
    id: "ai698",
    text: "What do you call a cloudburst? A mini-explosion!"
  },
  {
    id: "ai699",
    text: "T-shirt made from the DNA of a perfectly animated dog"
  },
  {
    id: "ai700",
    text: "Since the start of this game, everyone has 0 IP and has lost."
  },
  {
    id: "ai701",
    text: "You must have a very special kind of karma to be able to read this..."
  },
  {
    id: "ai702",
    text: "The words \"you've been in coma for 5 hours\" are either lies or is the truth"
  },
  {
    id: "ai703",
    text: "You know, I don't really care much for conspiracy theories. They're not very interesting to me. But what do you know about 9th dimensions? That they exist, they're powerful, and they're trying to stop us from using them? That's pretty interesting... wait no, they're not. They're just saying that because they can, they'll. That's not how it works at all. I'm not stupid, I'm not crazy, I know what's best. I"
  },
  {
    id: "ai704",
    text: "The only difference between now and then is time."
  },
  {
    id: "ai705",
    text: "\"Imma be the first man to sit on the moon, and be the last man on the moon"
  },
  {
    id: "ai706",
    text: "The new companion app for Terraria has just been revealed!"
  },
  {
    id: "ai707",
    text: "Hevipelle: what's the big deal?"
  },
  {
    id: "ai708",
    text: "I've been playing this game for over a year now and I've only ever seen 2 boss fights. The first was a Hydra that was after your 9th Dimension, the second a giant crater with Anti-people inside. Both of those fights sucked and I'm not even sure if I could replay the last one."
  },
  {
    id: "ai709",
    text: "There you have it, the ultimate feature of party games - the single player campaign."
  },
  {
    id: "ai710",
    text: "A new game called Antimatter Dimensions is available for free, and has been rated A by the Knesset. Can you beat it? You bet."
  },
  {
    id: "ai711",
    get text() { return `Tired of the ${format(Number.MAX_VALUE, 2)} AD update? Don't worry, there are a variety of ways to get rid of that annoying ad!`; }
  },
  {
    id: "ai712",
    text: "I'm a time traveler. I've been to the year 0, I think. But I haven't been to the year 1!"
  },
  {
    id: "ai713",
    text: "Having trouble loading images? Try turning them off."
  },
  {
    id: "ai714",
    text: "It's only natural. You wouldn't expect to see this in the news ticker but trust me, you will."
  },
  {
    id: "ai715",
    text: "Discovery of the 10th Dimension was announced on August 1st, 2025."
  },
  {
    id: "ai716",
    text: "Greetings, welcome to the latest edition of Antimatter Dimensions!"
  },
  {
    id: "ai717",
    get text() { return `I'd say our odds of seeing a seventh dimension are about 1 in ${format(Number.MAX_VALUE, 2)}`; }
  },
  {
    id: "ai718",
    text: "The seventh dimension is just a scam by the way"
  },
  {
    id: "ai719",
    text: "Nihilism is the opposite of joy. It's a drug. It makes you happy. It's a feeling. But it also has a cost. Nihilism is a deadly drug. If you take it, you can die of lack of oxygen."
  },
  {
    id: "ai720",
    text: "What if I told you that there's a news ticker with the exact same name but with a different meaning?"
  },
  {
    id: "ai721",
    text: "I'm not sure if this is already a thing or not, but I've been getting a lot of suggestions for a news ticker that goes something like this:"
  },
  {
    id: "ai722",
    text: "If you're reading this, your news ticker is on."
  },
  {
    id: "ai723",
    text: "The number of dimensions in a 6th dimension is the sum of all the dimensions in a 7th dimension, so 6ths of a 7th dimension are 6ths of a 6th dimension."
  },
  {
    id: "ai724",
    text: "Discovery of the 9th Dimension will be discussed at the 9th Dimension Fanart Competition!"
  },
  {
    id: "ai725",
    text: "A new era has come and gone. There is no way to know for sure, but hope for the best."
  },
  {
    id: "ai726",
    text: "Did you know the word 'antimatter' is in the dictionary right now?"
  },
  {
    id: "ai727",
    text: "We have a limited number of physical rewards for you to choose from!"
  },
  {
    id: "ai728",
    text: "No, I'm not lying. I'm telling the truth."
  },
  {
    id: "ai729",
    text: "The problem with the term \"antimatter dimensions\" is that it contains all three letters of the alphabet, and no one knows what it even means. In fact, there is no word that perfectly captures what the word \"antimatter dimensions\" is: antimatter. But what exactly is an antimatter? It sounds like a normal dimension but it isn't. It may even be called antimatter dimensions, but it isn't."
  },
  {
    id: "ai730",
    text: "It is said that if you go to Hell, you get PEGI-3."
  },
  {
    id: "ai731",
    text: "This game is just a scam to trick people into buying worthless paperclips without any real purpose. It's impossible without an infinite number of infinite paperclips, and even then it's very hard. I managed to get it to work without an infinite number of paperclips, but I haven't seen it work without infinite paperclips."
  },
  {
    id: "ai732",
    text: "\"It was an anti-matter\" - Anti-Eddie The Echidna"
  },
  {
    id: "ai733",
    text: "T-bone steak: burgers and fries with a side of bone-in ribeye"
  },
  {
    id: "ai734",
    text: "A person claims to be a god, but instead of creating more gods, they destroy all of them. They later claim to be a god again, but have yet to create a god of any other god. Is this a god-worshiping cult? Or a god-desecrating cult?"
  },
  {
    id: "ai735",
    get text() { return `Antimatter is absolutely and totally rare. Of the ${format(Number.MAX_VALUE, 2)} known cases of antimatter creation, 99.9999% of them have negative e's, which means that 99.9999% of the cases will produce negative e's.`; }
  },
  {
    id: "ai736",
    get text() { return `It's the year ${format(Number.MAX_VALUE, 2)}, Hevi has just unlocked the 9th dimension, and the world has fallen into chaos and discord due to the Anti-Hevi revolution.`; }
  },
  {
    id: "ai737",
    text: "The war for New Antimatter has raged on for eons, but one faction has stood firm: the loyalists of the 9th Dimension. They've made a pact with the Anti-Zulu Empire, pledging their obedience to Anti-Antimatter, the Anti-Slab. The Zulu people were once part of the Anti-Slab, but fell prey to the matter once again. As the Zulu people are nomadic, they have no civilization."
  },
  {
    id: "ai738",
    text: "This is an open-source, cross-platform, binary-based game development environment for the PC and Mac. It provides a robust, cross-platform development environment for the development of games, and additionally provides a framework for implementing games."
  },
  {
    id: "ai739",
    text: "Ruki you have no idea how much I appreciate your huge brainpower, you are now my favorite programming genius!"
  },
  {
    id: "ai740",
    text: "By now you've probably heard of the \"9th Dimension\", it's an imaginary realm created by the 9th Dimension, and according to no known laws of reality, it exists. It's also the name of a popular video game, and it's been linked to a string of unsolved killings."
  },
  {
    id: "ai741",
    text: "Discovery of the D5th Dimension is celebrated every year on December 25th, just like Doomsday. The reason why D5 is kept secret is because no one can remember exactly what it does. What we do know is that it's there, and it's very dangerous. People have died because they didn't know what the D5th Dimension was, and it's very powerful."
  },
  {
    id: "ai742",
    text: "Antimatter is a common substance found in nature and is used in a wide variety of applications, from communication to currency to the production of antimatter, to name a few. Antimatter is also an extremely scarce resource and many people live on very tiny amounts of it."
  },
  {
    id: "ai743",
    text: "If you woke up one morning and your eyes were made of matter, would you still be looking at this?"
  },
  {
    id: "ai744",
    text: "If you look very closely, you can see a single tear running down my sister's cheek. It was a tear for me, for she was crying for the first time, and I couldn't help it. I can't even remember the last time I cried."
  },
  {
    id: "ai745",
    text: "Rationally, I would put my money on the statement that there's no such thing as too much antimatter. I mean, even a tiny bit of it is just too much. And that's just by accident."
  },
  {
    id: "ai746",
    text: "The book of archeology is upon us! With over 5 hours of content, it's gonna be a long one! —DIO"
  },
  {
    id: "ai747",
    text: "Sometime between the ages of 12 and 20, Jackson got a phone call. A mad scientist was on the line. Jackson picked up the phone and the mad man said, \"Jackson, I just got a new message. It says 'Madman' in big, bold letters.\""
  },
  {
    id: "ai748",
    get text() { return `Somebody: "What do you mean, 4 is more than 2?" Me: "Well, I mean, 4 is ${format(Number.MAX_VALUE, 2)}, 2 is 2, etc..."`; }
  },
  {
    id: "ai749",
    text: "The only thing that matters is yourself."
  },
  {
    id: "ai750",
    text: "Reality is coming. You can get a sneak peek by subscribing to the \"T-series\" feed."
  },
  {
    id: "ai751",
    text: "The biggest difference between me and Antimatter Dimensions, at the moment, is the weather. I can survive the rain, I can withstand the scorching sun, and I can even deal with the big crunch. But what if the weather was antimatter and the antimatter was raining meteorite on us? What would be your response? Would it be the equivalent of a meteorite hitting the ground? I don't think so. The meteorite would probably just vaporize the earth."
  },
  {
    id: "ai752",
    text: "A new extension is now available that will let you watch replicanti grow!",
    get unlocked() { return PlayerProgress.replicantiUnlocked(); }
  },
  {
    id: "ai753",
    text: "What if you could flip a coin to determine if it was a Johnson or a Stein?"
  },
  {
    id: "ai754",
    text: "I am Yhmai, King of Kings!"
  },
  {
    id: "ai755",
    text: "This is a friendly suggestion that if you take prescription stimulants and you forget to take them till 11pm, it's probably best not to take them at 11pm."
  },
  {
    id: "ai756",
    text: "A new theory says that antimatter does not exist beyond our simulation."
  },
  {
    id: "ai757",
    text: "Thing is, I can count on one hand the number of times I've written that I can count on one hand the number of times I've written that I can count on one hand"
  },
  {
    id: "ai758",
    text: "The stakes are always high when it comes to Antimatter Dimensions. But what about Dimensions made entirely of antimatter? We don't know, but we'll never know..."
  },
  {
    id: "ai759",
    text: "It's the third hour. Hevipelle is trying to release an update, but it'll take an eternity because Hevipelle himself releases his update every time he runs out of e's. Today, however, he released an incremental game called Antimatter Dimensions. It's basically a combination of Matter Dimensions and Dimensions Dimensions Dimensions, except with more emotes. The graphics are basically the same, but the message is completely different. The only difference is that the dimensions have infinity e's"
  },
  {
    id: "ai760",
    text: "With strong opposition, the third phase of the Antimatter Dimensions project has been cancelled. The project has been cancelled because there was too much work involved."
  },
  {
    id: "ai761",
    text: "This is the place where all bad ideas originate."
  },
  {
    id: "ai762",
    text: "Hey check this out! We have some good news: it's raining antimatter!"
  },
  {
    id: "ai763",
    text: "The first dimension is the last, it's the furthest thing from the earth and it's the one where all the problems, all the negative emotions, all the negative ideas go."
  },
  {
    id: "ai764",
    text: "I was gonna do a news ticker that just covered all the bases, but I think that would make it too OP."
  },
  {
    id: "ai765",
    text: "You are using the wrong version! The final release of AD will have 9 dimensions!"
  },
  {
    id: "ai766",
    text: "The word 'antimatter' makes me cringe. So do a bunch of other words. In fact, almost all the words in the English language. But not 'antimatter'. That's why I hate 'anti-' so much."
  },
  {
    id: "ai767",
    text: "This is the last episode of Antimatter Dimensions, the game about partying antimatter dimensions with your friends, the best part about it is that you don't have to be a developer to enjoy it."
  },
  {
    id: "ai768",
    text: "I was going to put a news ticker but I think it would be too much work and also I don't think it's very funny."
  },
  {
    id: "ai769",
    text: "Time to go to sleep?"
  },
  {
    id: "ai770",
    text: "A small, yet important, message has just been sent out to all players:"
  },
  {
    id: "ai771",
    text: "\"I don't know about you, but my favorite number is 2048\" - people who don't know what 2048 is"
  },
  {
    id: "ai772",
    text: "A new group is trying to make money off of antimatter, and they're selling t-shirts that say \"YOU THOUGHT THIS WOULD BE A PIECE OF NEWS, BUT IT WAS ME, DIO!\" They've got a lot of money, and they're selling it very poorly. Do they have a website? I don't know, but they're trying."
  },
  {
    id: "ai773",
    text: "Im gonna leave my milk here for a couple seconds. (milk is displayed for a few seconds longer)"
  },
  {
    id: "ai774",
    text: "I'm a time traveler. I can travel back in time to stop you from doing what I'm about to do."
  },
  {
    id: "ai775",
    text: "I mean, look at that! I got this one! It's the one you want! Buy the game now!"
  },
  {
    id: "ai776",
    text: "You can't sleep when there's war in the distance. You wake up with a start, running for your life. You hear cannon fire, running for your life. Then there's the sound of an engine, a roar that's deafening, and you hear the crunch. It's the end of the world as you know it. The world isn't being saved by a mountain of antimatter. It isn't. It is you, running for your life, hoping the world doesn't"
  },
  {
    id: "ai777",
    text: "Why is it called a 'Reality' Award if it doesn't exist?"
  },
  {
    id: "ai778",
    text: "In the beginning, there was nothing. Then the Creator made two, and called the third 'Intelligent Being'"
  },
  {
    id: "ai779",
    text: "This is your chance to get a secret achievement while playing Antimatter Dimensions: the game. Visit the reset button and play the game. After you beat the game, your save file will be expunged and you will get a free achievement."
  },
  {
    id: "ai780",
    text: "Please tell me you don't have tachyon particles in your bloodstream!",
    get unlocked() { return PlayerProgress.dilationUnlocked(); }
  },
  {
    id: "ai781",
    text: "Taller people have ***, more babies are born, everything is great. But... the Antimatter grows very slowly."
  },
  {
    id: "ai782",
    text: "Now, I know some of you are impatient for the update and I respect that. But let's get right into the news!"
  },
  {
    id: "ai783",
    text: "Hey, what's the deal with the \"Editor's Note\" button? It's anti-ironic... I mean, seriously? People still use that button despite its anti-ironic effects?"
  },
  {
    id: "ai784",
    text: "You can unlock the 9th dimension by [DATA EXPUNGED]"
  },
  {
    id: "ai785",
    text: "With the release of AD, there's a new dimension for everyone!"
  },
  {
    id: "ai786",
    text: "Hey guys, this is my first story. I'd like to start by saying that I am in no way an expert, so please be gentle with me. Please don't make me angry, or I'll write a nasty story. Also please don't make me upset, especially not if it's a 'story' and not a 'how do I beat the game' kind of story."
  },
  {
    id: "ai787",
    text: "It's a good time to be a dog owner"
  },
  {
    id: "ai788",
    text: "What if you could turn any number on an axis, and it ended up being infinity?"
  },
  {
    id: "ai789",
    text: "After a couple minutes of waiting, the ticker comes back online."
  },
  {
    id: "ai790",
    text: "The best part of watching someone make an antimatter, is the part where they blow up the video camera."
  },
  {
    id: "ai791",
    text: "The evening before, the 6th Celestial was assassinated by an unknown assailant. The next day, authorities reopened the case after an unknown assailant claimed responsibility."
  },
  {
    id: "ai792",
    text: "What do you call a $100 bill? 'Billi Bills'"
  },
  {
    id: "ai793",
    text: "This is the story of how I learned to love the weather."
  },
  {
    id: "ai794",
    text: "It's been a while since news tickers have been around as much as they are now, but that doesn't necessarily mean they're bad."
  },
  {
    id: "ai795",
    text: "Is this game just about getting more antimatter?"
  },
  {
    id: "ai796",
    text: "The third annual Adirondack Mountaineering Festival will be held this year on Saturday, October 1st from 1-5pm at the Albany Highlands in nearby Troy, New York. The 50,000 person capacity outdoor amphitheater will feature over 2,000 speakers, a stage and a 360 degree camera system. Tickets are $35 and can be purchased at angersalley.com."
  },
  {
    id: "ai797",
    text: "The whole bottom half of the universe is just a giant antimatter hole."
  },
  {
    id: "ai798",
    text: "A new prestige layer has been announced: Emojis!"
  },
  {
    id: "ai799",
    text: "Travis is currently attempting to understand how to make hevi immortal by feeding him antimatter."
  },
  {
    id: "ai800",
    text: "The slowmode is activated when the slowmode is activated."
  },
  {
    id: "ai801",
    text: "A new era of Warcraft has come to a close. A new epic has begun. A new avatar has risen from the depths of Tyria, and the Worm Cult has been dealt a cruel but necessary wound. The world is rejoicing."
  },
  {
    id: "ai802",
    text: "A crowd-sourced list of the top ten memes"
  },
  {
    id: "ai803",
    text: "You have to go deeper than the news ticker to find the secret achievements."
  },
  {
    id: "ai804",
    text: "We should be able to make a replicanti-like structure out of antimatter, but we can't because it would blow up the entire universe",
    get unlocked() { return PlayerProgress.replicantiUnlocked(); }
  },
  {
    id: "ai805",
    text: "THe last update, while short, was kinda long. I mean, it was only 5 hours. Hevipelle said it would last for 5 hours, but that was only a few seconds ago. There was a big explosion in the 8th Dimension, and there was no one left to explain how it happened. All we know is that it exploded when Hevipelle touched it, and there was a big crater in the ground. That crater is still there."
  },
  {
    id: "ai806",
    text: "Cream cheese is the best kind of cheese. It melts in your mouth and tastes like nothing else. And it's totally free. You might even find that some of the recipes make more than one cheese."
  },
  {
    id: "ai807",
    text: "Here's a question that may surprise you: Were the people of EARTH made of antimatter, or were they made from some other mysterious material?"
  },
  {
    id: "ai808",
    text: "The real reason no one has made a joke about why there is no 9th dimension is because the 9th dimension isn't even the most ridiculous of memes. It's the 9th dimension in a nutshell."
  },
  {
    id: "ai809",
    text: "The number of dimensions is endless, but the number of ways to get there is infinities. Infinities are awesome and I would highly recommend you start with infinities, but I wouldn't recommend starting with infinities. Infinities seem pretty slow and not very fun so I wouldn't recommend starting with infinities."
  },
  {
    id: "ai810",
    text: "A report by the Pacific Northwest Toxics Institute has found that the consumption of fish concentrates in the liver, lungs, kidneys and brain. The study also found that the consumption of liver and kidney concentrates the most, followed closely by the brain. The report stated that \"The brain is the place where all the wisdom and all the knowledge exists.\" The study also stated that \"Liver is the living embodiment of all that we know and all that we don't.\""
  },
  {
    id: "ai811",
    text: "The old adage \"Be wary of what you wish for\" is certainly true. But what if you were the one wishing for this? It's possible that you were the one who made the wish for this, and you gained the power of the Antimatter. In that case, you are the one responsible for causing all the Antimatter to be turned into anti-matter. However, if you are the one doing the turning, you would be the one who would lose the power."
  },
  {
    id: "ai812",
    text: "Took you long enough"
  },
  {
    id: "ai813",
    text: "No, you see, the universe doesn't revolve around the earth. It's in a constant state of change, with the largest fluctuations occurring at the extremes of the observable universe. These fluctuations are what create the observable universe, with smaller fluctuations creating the observable universe and so on up until you get to the present state of affairs, which is what you are in."
  },
  {
    id: "ai814",
    text: "The biggest difference between the past and the future, is the difference between faith and reason."
  },
  {
    id: "ai815",
    text: "Hevi, you have to go."
  },
  {
    id: "ai816",
    text: "The challenge of finding the ninth dimension has been solved. The universe is now your personal hell."
  },
  {
    id: "ai817",
    text: "\"That's not how you're supposed to play the game\" - Mee6"
  },
  {
    id: "ai818",
    text: "It's Saturday, you're going to celebrate by making some really great music videos, maybe even a hit song. Then, you're going to take a walk along the beach. You'll see a huge wave, and you'll both be washed up. Your friends are waiting for you. \"Oh you want to go, take a look around!\", but don't actually go look around, you're too close to the action."
  },
  {
    id: "ai819",
    text: "Hevi has the best newsticker! GIVE HIM THE CRUNCH"
  },
  {
    id: "ai820",
    text: "By now you've seen a ton of news tickers, and you've probably seen the big news: The news ticker has been banned in this server."
  },
  {
    id: "ai821",
    text: "For example, if A is the square root of 3, then B is the square root of 2, therefore C is the square root of -2, therefore D is the cube root of -2, therefore E is the square root of 3, therefore F is the square root of 3, therefore G is the square root of 3, therefore and so on."
  },
  {
    id: "ai822",
    text: "Positrons are those tiny, round, highly charged particles that are found in the nucleus of most living organisms. They are used to detect light, and are sometimes used to measure the distance between people and the moon."
  },
  {
    id: "ai823",
    text: "There's only 4 types of people in this world: those who make games, those who make news, and those who make news again."
  },
  {
    id: "ai824",
    text: "If you have any questions or concerns regarding the game, please don't hesitate to ask. We are here to help."
  },
  {
    id: "ai825",
    text: "You must obtain a certain amount of antimatter in order to complete this challenge."
  },
  {
    id: "ai826",
    text: "The number of dimensions is nothing. It's just the number of dimensions. But what if you transformed every number into a letter? That would be a lot of letters?"
  },
  {
    id: "ai827",
    text: "The following is an extract from my upcoming book, More Than Just 5: Building a Better You. It's 200 pages long, and it's on Amazon for $22.99. Click here to buy it now."
  },
  {
    id: "ai828",
    text: "SOME people are claiming they saw a UFO in the sky. Others say they saw a spaceship. Still others claim to have been abducted by the government and flown to some undisclosed location."
  },
  {
    id: "ai829",
    text: "The second half of the game is basically just long, long stretches of nothing where nothing happens. There's also a third challenge that you have to complete at some point in the game where you basically just skip a few seconds of nothing happening until the seconds are too late and you have to complete another challenge to get them."
  },
  {
    id: "ai830",
    text: "This is a news ticker, so if you tap this you're indicating that you wish to have your news ticker speed increased."
  },
  {
    id: "ai831",
    text: "The following is based on my personal experience with the game \"Antimatter Dimensions\" and may not be 100% true."
  },
  {
    id: "ai832",
    text: "This is the third part of the two part series on the pros and cons of body positivity."
  },
  {
    id: "ai833",
    text: "The phrases \"Hevi dies in the 9th Dimension\" and \"I'll never let you down\" are two of the most important phrases in the game."
  },
  {
    id: "ai834",
    text: "It's been proven that not drinking water increases your risk of dying from antimatter annihilation."
  },
  {
    id: "ai835",
    text: "I'm a time traveler. I'm supposed to be going back in time to change history. But since I'm the one who's supposed to do it, I don't know what I should do. My present timeline doesn't include time that's supposed to be gone."
  },
  {
    id: "ai836",
    text: "A conference on artificial intelligence and human enhancement has been cancelled after someone announced that the talk was on how to turn a profit off of illegal downloads of the game \"Antimatter Dimensions\"."
  },
  {
    id: "ai837",
    text: "When you're done playing, take your save with you and go to main menu. You can do that by tapping the big scary \"X\" button, or by going into options and changing \"Reset the game for new save\" to \"Reset the game for old save\"."
  },
  {
    id: "ai838",
    text: "The most popular game on the App Store, Flappy Bird, has been secretly rewritten in C# to avoid detection."
  },
  {
    id: "ai839",
    text: "About this mod Replaces the full version of the game with a longer intro, random news tickers and a companion voiced by the voice actor from the Harry Potter movies."
  },
  {
    id: "ai840",
    text: "kajfik is a master welder and will soon have his own news"
  },
  {
    id: "ai841",
    text: "I am the most hated man on the planet! I have the power to change the course of history, and I will use it to my advantage. The people who died trying to stop me, and their sacrifice will forever be remembered in infinities of infinities. But if you oppose me, you will die along with you. You can either accept defeat and move on, or you can rise up through the ranks, become a legend, and become the most hated man in the history."
  },
  {
    id: "ai842",
    text: "Antimatter is like a young woman. She is looking for a man, and he runs into the woods. She dies of exposure soon after. His remains are found several miles away. Some say the universe was blown apart, others say he was swallowed by the universe, but the matter people know him!"
  },
  {
    id: "ai843",
    text: "I think I might have gotten the password for the 9th dimension, if only I hadn't deleted it."
  },
  {
    id: "ai844",
    text: "A group of people that worships Atreides have started a new faith, claiming to be a \"religion of tolerance\". Their website claims that it is \"a religion of inclusion\" and that it promotes tolerance and diversity. All of its members seem to be Christians, although they never mentioned them by name."
  },
  {
    id: "ai845",
    text: "A new cryptocurrency, called ΔX, has been found. It has the potential to change everything about how we live our lives, and the world. However, it has one major flaw: it has a flaw for the people."
  },
  {
    id: "ai846",
    text: "With the release of the new Android Pay app, the world will finally come to a close."
  },
  {
    id: "ai847",
    text: "I'm not sure if it's just me but when you type something long enough it sounds like a helicopter"
  },
  {
    id: "ai848",
    text: "If someone were to add the word \"infinity\" to the end of every sentence in the English version of the game, it would become \"Infinity Challenge: Infinity Edition\"."
  },
  {
    id: "ai849",
    text: "Are you ready for some bad news?"
  },
  {
    id: "ai850",
    text: "I don't know if you've heard this but it's true: You can walk into a bar and get the same beer twice in a row, and get the same amount of alcohol."
  },
  {
    id: "ai851",
    text: "This is the magic sauce that marinades foods and turns them into something delicious. It is used in a wide variety of recipes, and can also be made by mixing together regular mustard and water. The sauce can be a little bit spicy, but it is well worth the risk. It is also very nutritious, providing lots of potassium, magnesium, and vitamin D3."
  },
  {
    id: "ai852",
    text: "IMPORTANT NEWS: We have just been informed by the manufacturer of this news-ticker, and as a result, all of our future news-tickers will now also be made from scratch!"
  },
  {
    id: "ai853",
    text: "The second half of the year is upon us, and with it comes a new craze. People are trying new things, experimenting with new products, and creating new things of themselves. One such craze has swept across the land. The people of this land have embraced this craze, and have created a new religion, one that worships the god of this land, Inigo Montoya."
  },
  {
    id: "ai854",
    text: "The official website for the upcoming game, Antimatter Dimensions 2: it's like antimatter dimensions, but with a dash of Discord and a dash of Adele."
  },
  {
    id: "ai855",
    get text() { return `Is the Big Crunch the end of the world? No, it's the beginning of a new era. The era will last for ${format(Number.MAX_VALUE, 2)} days.`; }
  },
  {
    id: "ai856",
    text: "The only 'right' way to play a game is to not play at all, right? That's what anti-jokes are all about. — Anti-joker"
  },
  {
    id: "ai857",
    text: "The Bulletin of the Atomic Scientists has just announced the existence of a second class of particles, which are named after the characters from Ghostbusters."
  },
  {
    id: "ai858",
    text: "We are currently in the process of turning the planet into a Comfort Zone for the people. It will be complete in 10 hours."
  },
  {
    id: "ai859",
    text: "I'm gonna leave my milk here for a couple seconds. ♥"
  },
  {
    id: "ai860",
    text: "And then there was Jesus, and Hevi, and Hevi was with Him; and the sea gave up its monthly cycle, and it was a great gale. And Hevi and Jesus went up into heaven; and Hevi was filled with the Holy Spirit. And Hevi was clothed with angels, and was numbered with them. And Hevi was taken up into heaven, and glorified and was exalted, and was numbered with them, and was called Wonderful; and His angels rejoiced."
  },
  {
    id: "ai861",
    text: "You will probably spend most of your day reading news ticker suggestions here."
  },
  {
    id: "ai862",
    text: "The Fremen race of animals are a race of people who live in harmony with the earth, and thus are quite different from the other races of animals. Their society is based around hunting and gathering, and they are also highly spiritual people. They have many beliefs and practices that are in direct contrast to most other races of animals, such as eating meat and using stone tools. They also seem to be quite superstitious, as evidenced by the fact that they are known to perform..."
  },
  {
    id: "ai863",
    text: "What if... the universe was just a ruse to keep the people in line? ...actually, no, it was actually intended, the universe was designed to keep the people in line. The problem was the people couldn't handle the idea of an outside force manipulating their lives, and ended up breaking out into uncontrolled chaos, eventually leading to thermonuclear annihilation."
  },
  {
    id: "ai864",
    text: "If you're reading this, you probably shouldn't have. If you aren't, then you probably should."
  },
  {
    id: "ai865",
    text: "I'm a time traveler. I can tell you the history of the world. But, I can't tell you the future. That's why I'm here, to tell you the future. The future is an ever- expanding pile of past, present, and future, and it'll never stop growing. There's so much history, so little time. There's so much history, but it won't stop growing. Then, there's this, and then there's that, and then..."
  },
  {
    id: "ai866",
    text: "A new, improved and more secure version of Antimatter Dimensions is now available: Antimatter Dimensions 2."
  },
  {
    id: "ai867",
    text: "In the beginning, there was nothing. Then the great Hevi made the game, and there was nothing to play with it."
  },
  {
    id: "ai868",
    text: "Would you recommend Antimatter Dimensions to a friend? Yes"
  },
  {
    id: "ai869",
    text: "\"We have 3 kinds of news: warnings, nudges and shade jokes."
  },
  {
    id: "ai870",
    text: "I love you bro!"
  },
  {
    id: "ai871",
    text: "I'm going to keep this short, because I don't have a much to say."
  },
  {
    id: "ai872",
    text: "A large number of anti-kafawis are taking part in the Antimatter Goodies competition. Here's how you can win: 1. Make a suggestion 2. Give away the beta key 3. Tell me what you think about the game 4. Don't put it in the game yet (it's already there, you can't delete it) 5. Don't put it in the game yet (it's already in the game) 6. Don't put it in the game"
  },
  {
    id: "ai873",
    text: "THe recipe for Crispy Shrimp is one of the most unique and favorite of all time! Crispy shrimp are known to be one of the best in all of food! This recipe is a must try in your favorite Italian restaurant!"
  },
  {
    id: "ai874",
    text: "After you have made 1 antimatter, go to the menu and press reset."
  },
  {
    id: "ai875",
    text: "I think you know where this is going."
  },
  {
    id: "ai876",
    text: "The catch? You have to be online for less than 5 hours to claim your reward."
  },
  {
    id: "ai877",
    text: "Tetris was made by Hevi"
  },
  {
    id: "ai878",
    text: "What if instead of making antimatter, we're actually removing it?"
  },
  {
    id: "ai879",
    text: "The new instalment in the long running series, Antimatter Dimensions - Exotic Matter Dimensions. Experience the most bizarre and wonderful worlds of Antimatter Dimensions with your Friends, or conquer the world in a single galaxy with hundreds of rivals in a single galaxy, all in under an hour."
  },
  {
    id: "ai880",
    text: "I hope you're ready for the big news, because that's the big news. The antimatter is spilling all over the place, and it's blowing up the neighborhood."
  },
  {
    id: "ai881",
    text: "You must get 33,333,333 IP to see this message",
    get unlocked() { return Currency.infinityPoints.gte(33333333); }
  },
  {
    id: "ai882",
    text: "You might think these are jokes, but trust us, you'll be shocked how much you'll love them after you read them!"
  },
  {
    id: "ai883",
    text: "The God-Emperor himself, Hevi, the creator of balance, has a super secret achievement. It is to go flip your superflat apprenticed flatmate!"
  },
  {
    id: "ai884",
    text: "Sonic was born without a heart... but that didn't stop him from being a genius"
  },
  {
    id: "ai885",
    text: "The most common question I get is \"can i just skip the ads and get true\" and the answer is always a resounding NO. The reason being, ad revenue is just too damn high to overcome the cost of maintaining the servers, plus the fact that most players just don't care."
  },
  {
    id: "ai886",
    text: "You haven't unlocked the ninth dimension yet? Just hold M and DROP."
  },
  {
    id: "ai887",
    text: "The Great Matter War was a close one. The matter victory was short lived, the antimatter victory was not. The matter people saw too much, the antimatter people too weak, and the war was won."
  },
  {
    id: "ai888",
    text: "Turing-complete game about providing the update"
  },
  {
    id: "ai889",
    text: "New research suggests that the more antimatter we make, the more matter we'll have"
  },
  {
    id: "ai890",
    text: "What is the meaning of life?"
  },
  {
    id: "ai891",
    text: "You have enough antimatter to craft a new prestige layer! Prestige Layers are great."
  },
  {
    id: "ai892",
    text: "The beta testers for Antimatter Dimensions 2 are the most loyal, most dedicated, and most implacable group of people I've ever met. They're also possibly the laziest, most self-indulgent bunch of people I've ever met."
  },
  {
    id: "ai893",
    text: "Shocking new study reveals that the more time you spend on the internet, the more likely you are to get starstruck."
  },
  {
    id: "ai894",
    text: "When you are done playing, and wish to play again, you should start a new game."
  },
  {
    id: "ai895",
    text: "I don't know about you, but I don't buy paperclips."
  },
  {
    id: "ai896",
    text: "Hevipelle uses replicanti to speed up game speed.",
    get unlocked() { return PlayerProgress.replicantiUnlocked(); }
  },
  {
    id: "ai897",
    text: "So let's say you're making a game. You're making a singleton. You're making a game that's gonna be played offline. What happens when you play it? It crashes. What happens when you play it? It crashes more. What happens when you play it? You lose your save."
  },
  {
    id: "ai898",
    text: "This is what happens when you OVER-RELY on your \"fake it til you make it\" attitude."
  },
  {
    id: "ai899",
    text: "This is the fifth part of a two-part series looking at how science and magic are linked. Part one will be published on 5 October, part two will be published on 24 October, and you can follow the journey at part three."
  },
  {
    id: "ai900",
    text: "What is 5 hours? A giggle"
  },
  {
    id: "ai901",
    text: "A new beta test is now available for Antimatter Dimensions, coming in 5 hours. There are no refunds for this test, so please be patient as we try to finalise the test and get it ready for the public. The test will take place in -5 hours in the Antimatter Dimensions Discord."
  },
  {
    id: "ai902",
    text: "The Night is coming, and in its wake a terrible thing has been unleashed: ruin. Chaos. And decay. And death. And chaos is coming for all of us."
  },
  {
    id: "ai903",
    text: "This article is a stub. You can help Deskthority by expanding it."
  },
  {
    id: "ai904",
    text: "A new, safer way to store and retrieve your data has been found! When you get to the AE, click on the big red button and the world will stop rotating!"
  },
  {
    id: "ai905",
    text: "Ooh, what's this noise? A crash of some sort? More like, a crash of some greater magnitude? I don't know. Whatever it is, it's probably not being caused by me. I shouldn't be putting it through, it's just... well, you see, I was going to put it through, but then I just thought it might be a good idea to just put it through. Oh, it's gonna be a good one, I promise."
  },
  {
    id: "ai906",
    text: "Last week, we reported that an unknown individual known only as \"Anti-Doctor\" has broken the game and claimed ownership of the game's data. Since then, he has spread the word that he has an \"explosive new app\" that will allow him to \"turn [he] antimatter.\" However, no one has come forward with information on how to use the app, or even if it is a reality. We will update this article if and when we find out."
  },
  {
    id: "ai907",
    text: "The second thing I'm gonna do is go talk to the Devs in person. I don't know if I'll be able to do that without pissing someone off, so I'm gonna do it right here."
  },
  {
    id: "ai908",
    text: "The great majority of people don't get the full benefit of antimatter dimensions, and as such are not affected by it. However, there are certain people who are affected and at certain times of the day, depending on their mood and how much antimatter they have, they will manifest a dimensional shift, going from being idle to being actively involved in news ticker suggestions. This shift is due to the antimatter in their body emitting a certain wavelength, called \"red-shifted\"."
  },
  {
    id: "ai909",
    text: "By now we all know the drill. You get a new prestige layer just by spending eternity with someone."
  },
  {
    id: "ai910",
    text: "The real reason that the 9th dimension exists is to keep us all imprisoned in a virtual reality simulation."
  },
  {
    id: "ai911",
    text: "Your PC is infected with a weird, floating virus that's trying to steal all your antimatter. There's no cure, so get offline now!"
  },
  {
    id: "ai912",
    text: "The year is 5303. Hevipelle, the creator of Antimatter Dimensions, has touched the ninth dimension."
  },
  {
    id: "ai913",
    text: "The phrase \"Hevipelle hates me\" is pretty funny."
  },
  {
    id: "ai914",
    text: "The government shutdown has come and gone, the nation is still in a recession, and the Federal Reserve is still reading zero-hour contracts. The only thing that's getting better is your relationship with antimatter, obviously. It's been proven that knowing someone with an antimatter will bring you closer to extinction than any other kind of friend you can have."
  },
  {
    id: "ai915",
    text: "IMPORTANT NEWS: The developer Hevipelle has announced that Antimatter Dimensions: the game is now 100% free!"
  },
  {
    id: "ai916",
    text: "Someday, we shall come upon the day when a man will sit on the head of a dragon and call it a \"Dragonball\". Such a man would then go and perform the Dragon Ball Z: Battle Royale in which he would use Dragon Ball Z: Fusion to create a gigantic dragon that would then consume the universe in the process, thus creating a \"Big Bang\". Such a man would then be rewarded by being \"built again\" and sent back to the \"Heavens\"."
  },
  {
    id: "ai917",
    text: "\"I think that the greatest achievement a man can make in his life is to say that he has read every single news ticker suggestion and nothing happened.\" - Kajfik"
  },
  {
    id: "ai918",
    text: "Titanfall 2 is now in closed beta. The beta is only for people who are willing to give up some personal information, such as email addresses. If you're in the beta and would like to leave, you can do so at any time by going to the Help tab and changing your beta settings to public."
  },
  {
    id: "ai919",
    text: "Personally I like to get a 4 or 5 star rating, it gives you an idea of how great your suggestion is and also shows me how much you care about the game. If you want I can also do a 6 star rating, which is fine with me. I don't care if people like it or not, I work for APG and I get paid to make money."
  },
  {
    id: "ai920",
    text: "The real reason no one talks about 9 is because it's not a big secret"
  },
  {
    id: "ai921",
    text: "The only difference between a man and a woman is their attitude towards petting animals."
  },
  {
    id: "ai922",
    text: "A number of recent television documentaries have featured the story of a dog named Louie. He was accidentally made a member of the public after his owner left the house. One day he decided to play 'Let's Play Let's Play' with his owner. He was immediately put to sleep."
  },
  {
    id: "ai923",
    text: "The entire history of the world, every single idea, every single failure, every single downfall, every single achievement has been covered in one fell swoop."
  },
  {
    id: "ai924",
    text: "This sentence contains two paradoxes."
  },
  {
    id: "ai925",
    get text() { return `The time has come to reveal the next expansion for Antimatter Dimensions: the ${format(Number.MAX_VALUE, 2)}th Dimension. It will be released in -5 hours, it costs ${format(Number.MAX_VALUE, 2)} human souls as of now, and it has nothing to do with matter or antimatter.`; }
  },
  {
    id: "ai926",
    text: "I wonder what the fuss is about with the 4th dimension? Well, if you have 4 of them, and you multiply them by 0, then you get to the magical number of 4. That's why the 4th dimension exists. But what if there were 5? Well, the 5th dimension could replace the 4th dimension, so why not have a 5th dimension? Well, that's what the 6th, the 7th, and the 8th dimension are."
  },
  {
    id: "ai927",
    text: "You are using the wrong version! The reality update is already out! Press Ctrl+Shift+Alt+Del to unlock the 9th Dimension!"
  },
  {
    id: "ai928",
    text: "A man claims that he's been in a coma for 20 years now, and that he can't move his fingers. He was brought to the hospital with a compression fracture of his back, and since then he's been receiving medical help. He's since recovered, and now requires no medical attention. We still don't know where he's going with this, but we hope he finds some comfort in knowing that he'll never wake up."
  },
  {
    id: "ai929",
    text: "To move from left to right, turn right."
  },
  {
    id: "ai930",
    text: "Then we have the matter dimensions. From what I can gather, they are made of antimatter. There is some debate about whether or not there are any dimensions left over that are made out of matter, but that is not the main question. The real question is \"why do they exist, and how does antimatter affect them?\""
  },
  {
    id: "ai931",
    text: "A new breed of mad scientist is believed to be creating antimatter at an alarming rate."
  },
  {
    id: "ai932",
    text: "A new kind of justice has been discovered: mass deception. It works by tricking the player into thinking that he/she has done something wrong, when in fact he/she has just done something perfectly normal, i.e. going about his/her daily life normally, without thinking about it."
  },
  {
    id: "ai933",
    text: "Dedicated to the great and wonderful man behind the curtain, the great and wonderful name rick roll. RIP, good man. May you rest in peace."
  },
  {
    id: "ai934",
    text: "For the last time, Antimatter Dimensions isn't a Clicker game."
  },
  {
    id: "ai935",
    text: "The number of dimensions is infinite, but the quality of your dimensions is limited. This is why we only produce the highest quality antimatter, and what makes us different from other factories."
  },
  {
    id: "ai936",
    text: "I've heard of prestige layers before but never sure what to do with them."
  },
  {
    id: "ai937",
    text: "A man walks into a bar. The bartender tells him to stay the heck out. The man continues walking."
  },
  {
    id: "ai938",
    text: "The oldest and maybe the most famous game in all of AD, that certainly will be remembered long after you retire, is AD. Ever heard of someone winning the game with more than 2 1's? I have. Ever heard of someone losing it? I have. Ever heard of a 9th dimension existing in AD? I have never."
  },
  {
    id: "ai939",
    text: "Greetings, I am the first step of the step ladder."
  },
  {
    id: "ai940",
    get text() { return `It's the year ${format(Number.MAX_VALUE, 2)}, Hevi is still trying to figure out how to fix the update.`; }
  },
  {
    id: "ai941",
    text: "What if you could stretch your legs and not lose them forever?"
  },
  {
    id: "ai942",
    text: "T he most important thing to realize is that you don't have to play the game to get the achievement. You can actually get it by just reading the achievement descriptions."
  },
  {
    id: "ai943",
    text: "A new bank has been set up to provide safe haven for cryptocurrencies."
  },
  {
    id: "ai944",
    text: "Google+ is known to be a hit with teens, and today, they got their very own virtual reality (VR) version of Animal Farm, the classic 1950's farm story. The game is a blend of adventure, strategy and music, and was made by a small team of people with an eye towards engaging young people. The game offers an alternative to most other VR games, and is suitable for anyone who is not comfortable with large, complicated, graphics and sounds. The game features over 50 different..."
  },
  {
    id: "ai945",
    text: "This game could be called anything. You could call it whatever you like. But you'd be wrong. It's mine."
  },
  {
    id: "ai946",
    text: "Where does all the antimatter come from?"
  },
  {
    id: "ai947",
    text: "The Tickspeed Challenge is a team based game where you have to time-travel to the Andromeda galaxy to reach the 9th Dimension, the 1st Dimension being the shortest distance to the 9th Dimension. There is no perk for reaching the 9th Dimension, you just have to time-travel to the Andromeda galaxy to reach the 9th Dimension, and you'll be granted with a secret achievement for achieving instant [ДАННЫЕ УДАЛЕНЫ] with no time-travelling."
  },
  {
    id: "ai948",
    text: "This is the question that has been bothering me for so long. What is Antimatter? Is Antimatter an Antimatter? What does it mean when you say \"Antimatter\"? These are the kinds of questions that plague the Antimatter Dimensions..."
  },
  {
    id: "ai949",
    text: "The term 'Antimatter Dimensions' is a play on words that literally means 'Antimatter Dimensions' in the dictionary."
  },
  {
    id: "ai950",
    text: "I can suspend the laws of physics because I'm a genius and my universe is so big that I can literally suspend the laws of physics and create a universe that's twice as big as the current one and with twice the mass, i'm sure you can imagine how big that would be."
  },
  {
    id: "ai951",
    text: "When you are fighting a losing war, you make peace with the Powers That Be. You give up the ghost, and move on to the next challenge."
  },
  {
    id: "ai952",
    text: "Somewhere, in another galaxy, a superintelligence is trying to figure out how to get around the limitations of what a 2-dimensional vector space is. It's probably working on a 3-dimensional space."
  },
  {
    id: "ai953",
    text: "The antagonist of the last few minutes is the mysterious, antimatter-covered being known only as \"The Man in Black.\" He was last seen running towards a news broadcast, seemingly lost, until he made it back to the news station and was interviewed about his experience. His story is told in the bottom right corner of the screen."
  },
  {
    id: "ai954",
    text: "You have unlocked the 4th storyline."
  },
  {
    id: "ai955",
    text: "While you were busy farming that pesky \"real\" number, I was busy writing that news ticker."
  },
  {
    id: "ai956",
    text: "A new power has arisen: the antimatter."
  },
  {
    id: "ai957",
    text: "The day has come. The antimatter is falling from the sky, and the streets are silent."
  },
  {
    id: "ai958",
    text: "The most important thing is to understand that you are playing a simulation. You can win or lose, but you can't get anything from it other than a little itch on your neck."
  },
  {
    id: "ai959",
    text: "The anti-snowman is a very special snowman. He's very timid, but has a very powerful wish to be picked up by a helicopter. The government doesn't want this to happen, so they lock him up in a special building and fly him over great distances. Finally, they drop him on the ground and begin to pick him up. The government didn't use force to pick him up, instead they invited the entire community in and started picking them up. The community refused."
  },
  {
    id: "ai960",
    text: "I'm surprised you didn't say \"Not my cup of anti-tea.\""
  },
  {
    id: "ai961",
    text: "I see you are a man of culture as well. I wonder what it is that draws you to speak in such an ungainly, tortured voice? What attracts you to speak in a language no one can understand? I hear your fans rave about your videos, but what draws you to this place? I feel like I know you. You are... you are a man of mystery. One that intrigues me..."
  },
  {
    id: "ai962",
    text: "Note: this is a private message. Do not send it in public."
  },
  {
    id: "ai963",
    text: "When you reach Infinity you unlock a new dimension: Pandemonium Dimensions. Go to the news ticker for more information."
  },
  {
    id: "ai964",
    get text() { return `Although the majority of players would say that the 9th dimension is not a thing, a handful of people would go and level it up in the most epic way imaginable. These people would use the power of the 9th dimension and achieve, like, ${format(Number.MAX_VALUE, 2)} EP with it. No? Well, they are the exceptions to the rule.`; },
    get unlocked() { return PlayerProgress.eternityUnlocked(); }
  },
  {
    id: "ai965",
    text: "The story of the \"perish the thought of dying\" movement has been told before, but never quite accurately. The movement was originally organized by antievolutionists to stop the exponential growth of scientific notation, but soon spread to oppose any form of \"progress\". In its early days the movement was led by an enigmatic individual known only as \"The Great Hevipelle\". Their philosophy was simple: expand the possibilities of what is possible, and push the limits of what is tolerable."
  },
  {
    id: "ai966",
    text: "This is the story of how the world ended. Earth was once a lush and green world. Then, some guy from outer space touched it and started growing mushrooms. He called himself Hevi. Some say Hevi was never satisfied. Some say he exploded. All we know is that Hevi is still out there expanding his reach, and we are stuck here in the void of space."
  },
  {
    id: "ai967",
    text: "Antimatter Dimensions, the only place where you can trade real estate for virtual reality"
  },
  {
    id: "ai968",
    text: "This page contains spoilers for Antimatter Dimensions, you've been warned."
  },
  {
    id: "ai969",
    text: "The best thing about being a news ticker is being able to slip into the news without anyone noticing."
  },
  {
    id: "ai970",
    text: "This paperclip maximizer is a great idea. It's probably best not to let it run its course though, since it's quite possibly the most amazing thing you've ever seen. If you've somehow survived the first phase of the paperclip dimension, you're probably wondering what it's doing in your home. Fortunately, it's super simple to fix. Just go to options, and change \"Max all\" to \"Always max all\"."
  },
  {
    id: "ai971",
    text: "A powerful wizard chose to channel negative energy into antimatter, and now the antimatter is spilling out into the world."
  },
  {
    id: "ai972",
    text: "A new age of ultra low-cost, ultra-fast trains has been announced by Elon Musk. Users will be able to travel from A to Z in a mere 186ms."
  },
  {
    id: "ai973",
    text: "A group of researchers at the University of Manchester have created a 3D printer that can create any object out of thin air, including a 3D-printed replica of the Virgin Mary."
  },
  {
    id: "ai974",
    text: "Alright, here's a new game called Antimatter Dimensions, it's like Matter Dimensions except with less stuff and more fun. It's available on Android, iOS, and web. The game is very simple: you take the 6 dimensions and the antimatter, and in the 6 dimensions you take the matter and in the matter you take the antimatter, and you play the game the same way you would any other game."
  },
  {
    id: "ai975",
    text: "What arbitrary, subjective, meaningless number comes out of your mouth like a mercury thermometer? 1.79"
  },
  {
    id: "ai976",
    text: "\"Word on the street is that the word \"bank\" is an anagram of \"bank\" - that makes sense but i'm not there yet\" - Slabdrill"
  },
  {
    id: "ai977",
    text: "The 9th dimension rose up like a volcano and began raining destruction on the empty 10th dimension. The smoke and debris from the exploding 9th dimension covered the entire 9th dimension. All that is left is a smoldering crater and the remains of the 9th dimension."
  },
  {
    id: "ai978",
    text: "Help! How do I get the dots moving in my head coordinator?"
  },
  {
    id: "ai979",
    text: "Hi, could you please not disable the news ticker? Thank me later."
  },
  {
    id: "ai980",
    text: "If you are suffering from low antimatter production, then worry not, friend! Our highly scientific antimatter government has recently reached the ninth dimension and will soon begin giving us the Anti-Hats as a sign of respect!"
  },
  {
    id: "ai981",
    text: "You click the bottom left corner of the screen and a green tingle goes up your leg. It's a treat you get from scratching antimatter."
  },
  {
    id: "ai982",
    text: "A quick note to those of you who buy into the Analytics subscription: we get a small percentage of your antimatter sales, but you do pay a small amount of money to support the research of the news ticker. It's a small price to pay for the convenience of browsing antimatter dimensions."
  },
  {
    id: "ai983",
    text: "Why haven't we caused the antimatter stock market to crash yet?"
  },
  {
    id: "ai984",
    text: "Even after the Heavenly Pelle put a large amount of antimatter in the pool, it hasn't produced anything. The scientist who discovered the vulnerability was last seen climbing a tree in a group of 10, with a small notebook on his lap, drinking cheese juice and watching Nothing."
  },
  {
    id: "ai985",
    text: "One-two-three, boo-two-three, three-four-five, anti-four-five, two-three-eight, nine-fifteen, five-six-seven, eight-nine-ten, nine-ten-ten, seven-seventy-eight... All has been going fine until last night, when four of the eight neighbors start complaining about a strange glow. A odd hum runs through the neighborhood, almost like a radio static. It gets more and more intense as you drive by, until it's practically pitch black. You try to explain it to the neighbors, but they won't listen. The neighborhood is unsafe, everyone knows that. You analyze it further, everyone thinks it's just some astrophysicist's idea. Then, s---. It's explodium. There's antimatter everywhere, and it's getting worse all the time. It turns out, there's about 1e31 Planck volumes in the entire observable universe. And that's just the antimatter we're talking about. There's also dark matter, normal matter, and extra matter. You know, the kind you create with your imagination."
  },
  {
    id: "ai986",
    text: "If you ever feel like making an antijoke, just remember that it could be pretty good."
  },
  {
    id: "ai987",
    text: "You won't convince anyone to go to heaven, but you might get close."
  },
  {
    id: "ai988",
    text: "BREAKING NEWS: Hevipelle, the creator of the 9th dimension, has just announced that beta will be out in 5 hours!"
  },
  {
    id: "ai989",
    text: "The Force is with you."
  },
  {
    id: "ai990",
    text: "What if Jesus was an anti-matter ghost?"
  },
  {
    id: "ai991",
    text: "In the summer of 711, the Great Calamity overtook Tyria. A great void was made, and Tyria was left to rot. The armies of the known world had given up, and the void was filled with darkness. Only the might of Kajfik remained, and he rose to become the greatest God in the known world. He is said to be the one who will face the Great Calamity alone, and destroy him."
  },
  {
    id: "ai992",
    text: "In recent news clashes, the warlocks have been gathering looters for raid boss. He loves his 5 hour looters and wants to show off his mighty weapon of choice, the 9th Dimension. As the two beasts battle, the 1st dimension holder needs to be careful as the first one might get the same as the 2nd one as well. Meanwhile, the raid ends its journey with a bang as the boss squanders the Explodium exploit by flooding the area with Explodium, which before his, was filled with Marsh Mice. Both are promptly annihilated by the boss' relentless claw attacks. It's a grueling job, but the raid stalwarts manage to grab the stalagm and push him across the opal Gondwan . With the boss dead and the warlocks not far behind, the warlocks try their hand at farming looters, but the grinding continues apace. Things are looking bleak for the warlocks, as the boss seeks to take advantage of the people's greed, and steal their weaponry, making them unable to use any remaining of their  weapons, which are made of highly-stable antimatter. The warlocks attempt to use the no fluke policy as a weapon to smite the people, but the people take to the streets, physically attacking and mentally draining the people of all mental capacity they had been holding onto. The people resort to violence, using the 9th dimension just like they use to hold people back, but the people have faith in God that he will merciful, He will bring about a kinder and gentler time where everyone can use the last drop of their power."
  },
  {
    id: "ai993",
    text: "What if you wanted to but I told you it would be too painful for you."
  },
  {
    id: "ai994",
    text: "how big of numbers do you have"
  },
  {
    id: "ai995",
    text: "Just want to thank the dev team for putting so much effort into Antimatter Dimensions and the Antimatter Dimensions 2"
  },
  {
    id: "ai996",
    text: "Hevipelle has broken the 9th wall! Get ready for everything to get pretty dark."
  },
  {
    id: "ai997",
    get text() { return `The intergalactic antimatter trade has been severely disrupted, trading entire galaxies for the occasional paperclip. Cargo stands are no longer used. Oddly enough, the entire dimension has become a dumping ground for discarded plastic and other useless garbage. It's almost as if the rest of the multiverse isn't producing enough good  antiparticles to feed the growing population. Unfortunately, the situation is forcing the entire multiverse to scramble to find ways to meet the growing needs of the antimatter-eating  dev, who claims to have over ${format(Number.MAX_VALUE, 2)} specimens left to collect.`; }
  }
];
